/* tslint:disable */
/* eslint-disable */
/**
 * Core Tasks API
 * MagMutual Core Tasks API
 *
 * The version of the OpenAPI document: v0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AdditionalOptions } from '../models';
// @ts-ignore
import type { AdditionalOptionsEssential } from '../models';
// @ts-ignore
import type { AdditionalOptionsIdEssential } from '../models';
// @ts-ignore
import type { AggregateRiskReportDTO } from '../models';
// @ts-ignore
import type { Auth0RoleDTO } from '../models';
// @ts-ignore
import type { Auth0UserDTO } from '../models';
// @ts-ignore
import type { BulkStepRevisionResultDTO } from '../models';
// @ts-ignore
import type { CompactRiskSourceResponse } from '../models';
// @ts-ignore
import type { Control } from '../models';
// @ts-ignore
import type { ControlAttestation } from '../models';
// @ts-ignore
import type { ControlAttestationDocument } from '../models';
// @ts-ignore
import type { ControlAttestationDocumentEssential } from '../models';
// @ts-ignore
import type { ControlAttestationDocumentIdEssential } from '../models';
// @ts-ignore
import type { ControlAttestationEssential } from '../models';
// @ts-ignore
import type { ControlAttestationIdEssential } from '../models';
// @ts-ignore
import type { ControlAttestationListDTO } from '../models';
// @ts-ignore
import type { ControlAttestationStepRevision } from '../models';
// @ts-ignore
import type { ControlAttestationStepRevisionEssential } from '../models';
// @ts-ignore
import type { ControlAttestationStepRevisionIdEssential } from '../models';
// @ts-ignore
import type { ControlIdEssential } from '../models';
// @ts-ignore
import type { ControlRevision } from '../models';
// @ts-ignore
import type { ControlRevisionEssential } from '../models';
// @ts-ignore
import type { ControlRevisionIdEssential } from '../models';
// @ts-ignore
import type { ControlStep } from '../models';
// @ts-ignore
import type { ControlStepEditsDTO } from '../models';
// @ts-ignore
import type { ControlStepEssential } from '../models';
// @ts-ignore
import type { ControlStepIdEssential } from '../models';
// @ts-ignore
import type { CreateTaskRequest } from '../models';
// @ts-ignore
import type { DomainFilter } from '../models';
// @ts-ignore
import type { EmailParams } from '../models';
// @ts-ignore
import type { EmployeeData } from '../models';
// @ts-ignore
import type { EmployeeLayoutResult } from '../models';
// @ts-ignore
import type { EnterpriseRiskDTO } from '../models';
// @ts-ignore
import type { ExternalNodeDTO } from '../models';
// @ts-ignore
import type { FilterDTO } from '../models';
// @ts-ignore
import type { GraphEdge } from '../models';
// @ts-ignore
import type { GraphNode } from '../models';
// @ts-ignore
import type { GraphNodeFilterRequest } from '../models';
// @ts-ignore
import type { GraphState } from '../models';
// @ts-ignore
import type { GraphStateEssential } from '../models';
// @ts-ignore
import type { GraphStateIdEssential } from '../models';
// @ts-ignore
import type { GroupedRiskFilters } from '../models';
// @ts-ignore
import type { JobAid } from '../models';
// @ts-ignore
import type { JobAidLinkEditDTO } from '../models';
// @ts-ignore
import type { LayoutBodyDTO } from '../models';
// @ts-ignore
import type { LinkedStepsDTO } from '../models';
// @ts-ignore
import type { MarkTaskCompleteRequest } from '../models';
// @ts-ignore
import type { MitigationStep } from '../models';
// @ts-ignore
import type { MitigationStepEssential } from '../models';
// @ts-ignore
import type { MitigationStepIdEssential } from '../models';
// @ts-ignore
import type { Ownership } from '../models';
// @ts-ignore
import type { OwnershipEssential } from '../models';
// @ts-ignore
import type { OwnershipIdEssential } from '../models';
// @ts-ignore
import type { ReviewPeriod } from '../models';
// @ts-ignore
import type { ReviewPeriodEssential } from '../models';
// @ts-ignore
import type { ReviewPeriodIdEssential } from '../models';
// @ts-ignore
import type { Risk } from '../models';
// @ts-ignore
import type { RiskConnectionsDTO } from '../models';
// @ts-ignore
import type { RiskIdEssential } from '../models';
// @ts-ignore
import type { RiskRevision } from '../models';
// @ts-ignore
import type { RiskRevisionEssential } from '../models';
// @ts-ignore
import type { RiskRevisionIdEssential } from '../models';
// @ts-ignore
import type { RiskSource } from '../models';
// @ts-ignore
import type { RiskSourceAggregateCreateRequest } from '../models';
// @ts-ignore
import type { RiskSourceAggregateDTO } from '../models';
// @ts-ignore
import type { RiskSourceAggregateReadResponse } from '../models';
// @ts-ignore
import type { RiskSourceAggregateResponse } from '../models';
// @ts-ignore
import type { RiskSourceAggregateUpdateRequest } from '../models';
// @ts-ignore
import type { RiskSourceConnectionCounts } from '../models';
// @ts-ignore
import type { RiskSourceEssential } from '../models';
// @ts-ignore
import type { RiskSourceIdEssential } from '../models';
// @ts-ignore
import type { RiskSourceLinkOptionResponse } from '../models';
// @ts-ignore
import type { RiskSourceRevision } from '../models';
// @ts-ignore
import type { RiskSourceRevisionEssential } from '../models';
// @ts-ignore
import type { RiskSourceRevisionIdEssential } from '../models';
// @ts-ignore
import type { RiskWithAggregateFieldsDTO } from '../models';
// @ts-ignore
import type { RootTask } from '../models';
// @ts-ignore
import type { RootTaskEssential } from '../models';
// @ts-ignore
import type { RootTaskIdEssential } from '../models';
// @ts-ignore
import type { RootTaskSummaryDto } from '../models';
// @ts-ignore
import type { SignOffInsertDTO } from '../models';
// @ts-ignore
import type { SignOffOwners } from '../models';
// @ts-ignore
import type { SourceStep } from '../models';
// @ts-ignore
import type { SourceStepEssential } from '../models';
// @ts-ignore
import type { SourceStepIdEssential } from '../models';
// @ts-ignore
import type { Status } from '../models';
// @ts-ignore
import type { Step } from '../models';
// @ts-ignore
import type { StepConfirmation } from '../models';
// @ts-ignore
import type { StepConfirmationEssential } from '../models';
// @ts-ignore
import type { StepConfirmationIdEssential } from '../models';
// @ts-ignore
import type { StepConfirmationLink } from '../models';
// @ts-ignore
import type { StepConfirmationLinkDetailed } from '../models';
// @ts-ignore
import type { StepConfirmationLinkEssential } from '../models';
// @ts-ignore
import type { StepConfirmationLinkIdEssential } from '../models';
// @ts-ignore
import type { StepDocument } from '../models';
// @ts-ignore
import type { StepDocumentEditDTO } from '../models';
// @ts-ignore
import type { StepDocumentEssential } from '../models';
// @ts-ignore
import type { StepDocumentIdEssential } from '../models';
// @ts-ignore
import type { StepIdEssential } from '../models';
// @ts-ignore
import type { StepLink } from '../models';
// @ts-ignore
import type { StepLinkEditDTO } from '../models';
// @ts-ignore
import type { StepLinkEssential } from '../models';
// @ts-ignore
import type { StepLinkIdEssential } from '../models';
// @ts-ignore
import type { StepRevision } from '../models';
// @ts-ignore
import type { StepRevisionEditDTO } from '../models';
// @ts-ignore
import type { StepRevisionEssential } from '../models';
// @ts-ignore
import type { StepRevisionIdEssential } from '../models';
// @ts-ignore
import type { TaskActionRequest } from '../models';
// @ts-ignore
import type { TaskLog } from '../models';
// @ts-ignore
import type { TaskLogActivityEnum } from '../models';
// @ts-ignore
import type { TaskLogEssential } from '../models';
// @ts-ignore
import type { TaskLogIdEssential } from '../models';
// @ts-ignore
import type { TaskTypeEnum } from '../models';
// @ts-ignore
import type { User } from '../models';
// @ts-ignore
import type { UserIdEssential } from '../models';
// @ts-ignore
import type { UserRoleUpdateRequest } from '../models';
/**
 * DefaultApi - axios parameter creator
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AdditionalOptionsEssential} additionalOptionsEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        additionalOptionsControllerCreateEntity: async (additionalOptionsEssential: AdditionalOptionsEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'additionalOptionsEssential' is not null or undefined
            assertParamExists('additionalOptionsControllerCreateEntity', 'additionalOptionsEssential', additionalOptionsEssential)
            const localVarPath = `/additional/options/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(additionalOptionsEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        additionalOptionsControllerDeleteEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('additionalOptionsControllerDeleteEntity', 'id', id)
            const localVarPath = `/additional/options/delete/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        additionalOptionsControllerGetAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/additional/options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        additionalOptionsControllerGetById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('additionalOptionsControllerGetById', 'id', id)
            const localVarPath = `/additional/options/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AdditionalOptionsIdEssential} additionalOptionsIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        additionalOptionsControllerUpdateEntity: async (additionalOptionsIdEssential: AdditionalOptionsIdEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'additionalOptionsIdEssential' is not null or undefined
            assertParamExists('additionalOptionsControllerUpdateEntity', 'additionalOptionsIdEssential', additionalOptionsIdEssential)
            const localVarPath = `/additional/options/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(additionalOptionsIdEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ControlAttestationEssential} controlAttestationEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationControllerCreateEntity: async (controlAttestationEssential: ControlAttestationEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlAttestationEssential' is not null or undefined
            assertParamExists('controlAttestationControllerCreateEntity', 'controlAttestationEssential', controlAttestationEssential)
            const localVarPath = `/control-attestation/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(controlAttestationEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationControllerDeleteEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('controlAttestationControllerDeleteEntity', 'id', id)
            const localVarPath = `/control-attestation/delete/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationControllerGetAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/control-attestation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationControllerGetAllEntities: async (instant: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instant' is not null or undefined
            assertParamExists('controlAttestationControllerGetAllEntities', 'instant', instant)
            const localVarPath = `/control-attestation/get/all/{instant}`
                .replace('{instant}', encodeURIComponent(String(instant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationControllerGetByControlId: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('controlAttestationControllerGetByControlId', 'id', id)
            const localVarPath = `/control-attestation/control/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationControllerGetById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('controlAttestationControllerGetById', 'id', id)
            const localVarPath = `/control-attestation/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} processName 
         * @param {string} controlId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationControllerGetControlAttestationByRange: async (processName: string, controlId: string, startDate: string, endDate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processName' is not null or undefined
            assertParamExists('controlAttestationControllerGetControlAttestationByRange', 'processName', processName)
            // verify required parameter 'controlId' is not null or undefined
            assertParamExists('controlAttestationControllerGetControlAttestationByRange', 'controlId', controlId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('controlAttestationControllerGetControlAttestationByRange', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('controlAttestationControllerGetControlAttestationByRange', 'endDate', endDate)
            const localVarPath = `/control-attestation/control-attestation-by-range`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (processName !== undefined) {
                localVarQueryParameter['processName'] = processName;
            }

            if (controlId !== undefined) {
                localVarQueryParameter['controlId'] = controlId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} processName 
         * @param {string} controlId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationControllerGetControlAttestationsByRange: async (processName: string, controlId: string, startDate: string, endDate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processName' is not null or undefined
            assertParamExists('controlAttestationControllerGetControlAttestationsByRange', 'processName', processName)
            // verify required parameter 'controlId' is not null or undefined
            assertParamExists('controlAttestationControllerGetControlAttestationsByRange', 'controlId', controlId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('controlAttestationControllerGetControlAttestationsByRange', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('controlAttestationControllerGetControlAttestationsByRange', 'endDate', endDate)
            const localVarPath = `/control-attestation/control-attestations-by-range`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (processName !== undefined) {
                localVarQueryParameter['processName'] = processName;
            }

            if (controlId !== undefined) {
                localVarQueryParameter['controlId'] = controlId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationControllerGetDistinctValues: async (columnName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'columnName' is not null or undefined
            assertParamExists('controlAttestationControllerGetDistinctValues', 'columnName', columnName)
            const localVarPath = `/control-attestation/distinct-values`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (columnName !== undefined) {
                localVarQueryParameter['columnName'] = columnName;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationControllerGetSelectableValues: async (columnName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'columnName' is not null or undefined
            assertParamExists('controlAttestationControllerGetSelectableValues', 'columnName', columnName)
            const localVarPath = `/control-attestation/selectable-values`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (columnName !== undefined) {
                localVarQueryParameter['columnName'] = columnName;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationControllerRemoveEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('controlAttestationControllerRemoveEntity', 'id', id)
            const localVarPath = `/control-attestation/remove/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationControllerRestoreEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('controlAttestationControllerRestoreEntity', 'id', id)
            const localVarPath = `/control-attestation/restore/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} removedBy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationControllerRestoreEntityGroup: async (removedBy: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'removedBy' is not null or undefined
            assertParamExists('controlAttestationControllerRestoreEntityGroup', 'removedBy', removedBy)
            const localVarPath = `/control-attestation/restore-group/{removedBy}`
                .replace('{removedBy}', encodeURIComponent(String(removedBy)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {string} control 
         * @param {Array<string>} stepRevisionIds 
         * @param {Status} status 
         * @param {string} [notes] 
         * @param {Array<File>} [documents] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationControllerSubmitNewAttestation: async (employeeId: string, control: string, stepRevisionIds: Array<string>, status: Status, notes?: string, documents?: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('controlAttestationControllerSubmitNewAttestation', 'employeeId', employeeId)
            // verify required parameter 'control' is not null or undefined
            assertParamExists('controlAttestationControllerSubmitNewAttestation', 'control', control)
            // verify required parameter 'stepRevisionIds' is not null or undefined
            assertParamExists('controlAttestationControllerSubmitNewAttestation', 'stepRevisionIds', stepRevisionIds)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('controlAttestationControllerSubmitNewAttestation', 'status', status)
            const localVarPath = `/control-attestation/submit/{employeeId}`
                .replace('{employeeId}', encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)


            if (control !== undefined) { 
                localVarFormParams.append('control', control as any);
            }
            if (stepRevisionIds) {
                localVarFormParams.append('stepRevisionIds', stepRevisionIds.join(COLLECTION_FORMATS.csv));
            }


            if (status !== undefined) { 
                localVarFormParams.append('status', status as any);
            }

            if (notes !== undefined) { 
                localVarFormParams.append('notes', notes as any);
            }
            if (documents) {
                documents.forEach((element) => {
                    localVarFormParams.append('documents', element as any);
                })
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ControlAttestationIdEssential} controlAttestationIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationControllerUpdateEntity: async (controlAttestationIdEssential: ControlAttestationIdEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlAttestationIdEssential' is not null or undefined
            assertParamExists('controlAttestationControllerUpdateEntity', 'controlAttestationIdEssential', controlAttestationIdEssential)
            const localVarPath = `/control-attestation/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(controlAttestationIdEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ControlAttestationDocumentEssential} controlAttestationDocumentEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationDocumentControllerCreateEntity: async (controlAttestationDocumentEssential: ControlAttestationDocumentEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlAttestationDocumentEssential' is not null or undefined
            assertParamExists('controlAttestationDocumentControllerCreateEntity', 'controlAttestationDocumentEssential', controlAttestationDocumentEssential)
            const localVarPath = `/control-attestation-document/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(controlAttestationDocumentEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationDocumentControllerDeleteEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('controlAttestationDocumentControllerDeleteEntity', 'id', id)
            const localVarPath = `/control-attestation-document/delete/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} controlAttestationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationDocumentControllerDownloadAllDocuments: async (controlAttestationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlAttestationId' is not null or undefined
            assertParamExists('controlAttestationDocumentControllerDownloadAllDocuments', 'controlAttestationId', controlAttestationId)
            const localVarPath = `/control-attestation-document/download/batch/{controlAttestationId}`
                .replace('{controlAttestationId}', encodeURIComponent(String(controlAttestationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} documentId 
         * @param {string} extension 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationDocumentControllerDownloadDocument: async (documentId: string, extension: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('controlAttestationDocumentControllerDownloadDocument', 'documentId', documentId)
            // verify required parameter 'extension' is not null or undefined
            assertParamExists('controlAttestationDocumentControllerDownloadDocument', 'extension', extension)
            const localVarPath = `/control-attestation-document/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (documentId !== undefined) {
                localVarQueryParameter['documentId'] = documentId;
            }

            if (extension !== undefined) {
                localVarQueryParameter['extension'] = extension;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<ControlAttestationDocument>} controlAttestationDocument 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationDocumentControllerDownloadDocuments: async (controlAttestationDocument: Array<ControlAttestationDocument>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlAttestationDocument' is not null or undefined
            assertParamExists('controlAttestationDocumentControllerDownloadDocuments', 'controlAttestationDocument', controlAttestationDocument)
            const localVarPath = `/control-attestation-document/download/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(controlAttestationDocument, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} controlAttestationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationDocumentControllerFindByControlAttestation: async (controlAttestationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlAttestationId' is not null or undefined
            assertParamExists('controlAttestationDocumentControllerFindByControlAttestation', 'controlAttestationId', controlAttestationId)
            const localVarPath = `/control-attestation-document/info/{controlAttestationId}`
                .replace('{controlAttestationId}', encodeURIComponent(String(controlAttestationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationDocumentControllerFindByDocumentId: async (documentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('controlAttestationDocumentControllerFindByDocumentId', 'documentId', documentId)
            const localVarPath = `/control-attestation-document/document/{documentId}`
                .replace('{documentId}', encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationDocumentControllerGetAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/control-attestation-document`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationDocumentControllerGetAllEntities: async (instant: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instant' is not null or undefined
            assertParamExists('controlAttestationDocumentControllerGetAllEntities', 'instant', instant)
            const localVarPath = `/control-attestation-document/get/all/{instant}`
                .replace('{instant}', encodeURIComponent(String(instant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationDocumentControllerGetById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('controlAttestationDocumentControllerGetById', 'id', id)
            const localVarPath = `/control-attestation-document/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationDocumentControllerGetDistinctValues: async (columnName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'columnName' is not null or undefined
            assertParamExists('controlAttestationDocumentControllerGetDistinctValues', 'columnName', columnName)
            const localVarPath = `/control-attestation-document/distinct-values`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (columnName !== undefined) {
                localVarQueryParameter['columnName'] = columnName;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationDocumentControllerGetSelectableValues: async (columnName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'columnName' is not null or undefined
            assertParamExists('controlAttestationDocumentControllerGetSelectableValues', 'columnName', columnName)
            const localVarPath = `/control-attestation-document/selectable-values`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (columnName !== undefined) {
                localVarQueryParameter['columnName'] = columnName;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationDocumentControllerRemoveEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('controlAttestationDocumentControllerRemoveEntity', 'id', id)
            const localVarPath = `/control-attestation-document/remove/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationDocumentControllerRestoreEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('controlAttestationDocumentControllerRestoreEntity', 'id', id)
            const localVarPath = `/control-attestation-document/restore/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} removedBy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationDocumentControllerRestoreEntityGroup: async (removedBy: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'removedBy' is not null or undefined
            assertParamExists('controlAttestationDocumentControllerRestoreEntityGroup', 'removedBy', removedBy)
            const localVarPath = `/control-attestation-document/restore-group/{removedBy}`
                .replace('{removedBy}', encodeURIComponent(String(removedBy)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ControlAttestationDocumentIdEssential} controlAttestationDocumentIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationDocumentControllerUpdateEntity: async (controlAttestationDocumentIdEssential: ControlAttestationDocumentIdEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlAttestationDocumentIdEssential' is not null or undefined
            assertParamExists('controlAttestationDocumentControllerUpdateEntity', 'controlAttestationDocumentIdEssential', controlAttestationDocumentIdEssential)
            const localVarPath = `/control-attestation-document/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(controlAttestationDocumentIdEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} entityId 
         * @param {File} document 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationDocumentControllerUploadDocument: async (entityId: string, document: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('controlAttestationDocumentControllerUploadDocument', 'entityId', entityId)
            // verify required parameter 'document' is not null or undefined
            assertParamExists('controlAttestationDocumentControllerUploadDocument', 'document', document)
            const localVarPath = `/control-attestation-document/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }


            if (document !== undefined) { 
                localVarFormParams.append('document', document as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} entityId 
         * @param {Array<File>} documents 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationDocumentControllerUploadDocuments: async (entityId: string, documents: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('controlAttestationDocumentControllerUploadDocuments', 'entityId', entityId)
            // verify required parameter 'documents' is not null or undefined
            assertParamExists('controlAttestationDocumentControllerUploadDocuments', 'documents', documents)
            const localVarPath = `/control-attestation-document/upload/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }

            if (documents) {
                documents.forEach((element) => {
                    localVarFormParams.append('documents', element as any);
                })
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ControlAttestationStepRevisionEssential} controlAttestationStepRevisionEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationStepRevisionControllerCreateEntity: async (controlAttestationStepRevisionEssential: ControlAttestationStepRevisionEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlAttestationStepRevisionEssential' is not null or undefined
            assertParamExists('controlAttestationStepRevisionControllerCreateEntity', 'controlAttestationStepRevisionEssential', controlAttestationStepRevisionEssential)
            const localVarPath = `/control-attestation-step-revision/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(controlAttestationStepRevisionEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationStepRevisionControllerDeleteEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('controlAttestationStepRevisionControllerDeleteEntity', 'id', id)
            const localVarPath = `/control-attestation-step-revision/delete/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationStepRevisionControllerGetAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/control-attestation-step-revision`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} controlAttestationId 
         * @param {string} stepRevisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationStepRevisionControllerGetByControlAttestationAndStepRevisionIds: async (controlAttestationId: string, stepRevisionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlAttestationId' is not null or undefined
            assertParamExists('controlAttestationStepRevisionControllerGetByControlAttestationAndStepRevisionIds', 'controlAttestationId', controlAttestationId)
            // verify required parameter 'stepRevisionId' is not null or undefined
            assertParamExists('controlAttestationStepRevisionControllerGetByControlAttestationAndStepRevisionIds', 'stepRevisionId', stepRevisionId)
            const localVarPath = `/control-attestation-step-revision/controlAttestation/{controlAttestationId}/step-revision/{stepRevisionId}`
                .replace('{controlAttestationId}', encodeURIComponent(String(controlAttestationId)))
                .replace('{stepRevisionId}', encodeURIComponent(String(stepRevisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationStepRevisionControllerGetById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('controlAttestationStepRevisionControllerGetById', 'id', id)
            const localVarPath = `/control-attestation-step-revision/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ControlAttestationStepRevisionIdEssential} controlAttestationStepRevisionIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationStepRevisionControllerUpdateEntity: async (controlAttestationStepRevisionIdEssential: ControlAttestationStepRevisionIdEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlAttestationStepRevisionIdEssential' is not null or undefined
            assertParamExists('controlAttestationStepRevisionControllerUpdateEntity', 'controlAttestationStepRevisionIdEssential', controlAttestationStepRevisionIdEssential)
            const localVarPath = `/control-attestation-step-revision/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(controlAttestationStepRevisionIdEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlControllerCreateEntity: async (body: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('controlControllerCreateEntity', 'body', body)
            const localVarPath = `/control/control/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlControllerDeleteEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('controlControllerDeleteEntity', 'id', id)
            const localVarPath = `/control/control/delete/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlControllerGetAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/control/control`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlControllerGetById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('controlControllerGetById', 'id', id)
            const localVarPath = `/control/control/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ControlIdEssential} controlIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlControllerUpdateEntity: async (controlIdEssential: ControlIdEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlIdEssential' is not null or undefined
            assertParamExists('controlControllerUpdateEntity', 'controlIdEssential', controlIdEssential)
            const localVarPath = `/control/control/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(controlIdEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ControlRevisionEssential} controlRevisionEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlRevisionControllerCreateEntity: async (controlRevisionEssential: ControlRevisionEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlRevisionEssential' is not null or undefined
            assertParamExists('controlRevisionControllerCreateEntity', 'controlRevisionEssential', controlRevisionEssential)
            const localVarPath = `/control/control-revision/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(controlRevisionEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlRevisionControllerDeleteEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('controlRevisionControllerDeleteEntity', 'id', id)
            const localVarPath = `/control/control-revision/delete/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DomainFilter} domainFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlRevisionControllerFindByDomainFilter: async (domainFilter: DomainFilter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'domainFilter' is not null or undefined
            assertParamExists('controlRevisionControllerFindByDomainFilter', 'domainFilter', domainFilter)
            const localVarPath = `/control/control-revision/domain/filter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(domainFilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} instant 
         * @param {DomainFilter} domainFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlRevisionControllerFindByDomainFilterAndInstant: async (instant: string, domainFilter: DomainFilter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instant' is not null or undefined
            assertParamExists('controlRevisionControllerFindByDomainFilterAndInstant', 'instant', instant)
            // verify required parameter 'domainFilter' is not null or undefined
            assertParamExists('controlRevisionControllerFindByDomainFilterAndInstant', 'domainFilter', domainFilter)
            const localVarPath = `/control/control-revision/domain/filter/{instant}`
                .replace('{instant}', encodeURIComponent(String(instant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(domainFilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} controlId 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlRevisionControllerFindRevisionByControl: async (controlId: string, instant: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlId' is not null or undefined
            assertParamExists('controlRevisionControllerFindRevisionByControl', 'controlId', controlId)
            // verify required parameter 'instant' is not null or undefined
            assertParamExists('controlRevisionControllerFindRevisionByControl', 'instant', instant)
            const localVarPath = `/control/control-revision/controlId/{controlId}`
                .replace('{controlId}', encodeURIComponent(String(controlId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (instant !== undefined) {
                localVarQueryParameter['instant'] = (instant as any instanceof Date) ?
                    (instant as any).toISOString() :
                    instant;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlRevisionControllerGetAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/control/control-revision`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlRevisionControllerGetAllEntities: async (instant: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instant' is not null or undefined
            assertParamExists('controlRevisionControllerGetAllEntities', 'instant', instant)
            const localVarPath = `/control/control-revision/get/all/{instant}`
                .replace('{instant}', encodeURIComponent(String(instant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlRevisionControllerGetById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('controlRevisionControllerGetById', 'id', id)
            const localVarPath = `/control/control-revision/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlRevisionControllerGetDistinctValues: async (columnName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'columnName' is not null or undefined
            assertParamExists('controlRevisionControllerGetDistinctValues', 'columnName', columnName)
            const localVarPath = `/control/control-revision/distinct-values`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (columnName !== undefined) {
                localVarQueryParameter['columnName'] = columnName;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlRevisionControllerGetSelectableValues: async (columnName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'columnName' is not null or undefined
            assertParamExists('controlRevisionControllerGetSelectableValues', 'columnName', columnName)
            const localVarPath = `/control/control-revision/selectable-values`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (columnName !== undefined) {
                localVarQueryParameter['columnName'] = columnName;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlRevisionControllerRemoveEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('controlRevisionControllerRemoveEntity', 'id', id)
            const localVarPath = `/control/control-revision/remove/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlRevisionControllerRestoreEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('controlRevisionControllerRestoreEntity', 'id', id)
            const localVarPath = `/control/control-revision/restore/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} removedBy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlRevisionControllerRestoreEntityGroup: async (removedBy: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'removedBy' is not null or undefined
            assertParamExists('controlRevisionControllerRestoreEntityGroup', 'removedBy', removedBy)
            const localVarPath = `/control/control-revision/restore-group/{removedBy}`
                .replace('{removedBy}', encodeURIComponent(String(removedBy)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ControlRevisionIdEssential} controlRevisionIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlRevisionControllerUpdateEntity: async (controlRevisionIdEssential: ControlRevisionIdEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlRevisionIdEssential' is not null or undefined
            assertParamExists('controlRevisionControllerUpdateEntity', 'controlRevisionIdEssential', controlRevisionIdEssential)
            const localVarPath = `/control/control-revision/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(controlRevisionIdEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ControlStepEssential} controlStepEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlStepControllerCreateEntity: async (controlStepEssential: ControlStepEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlStepEssential' is not null or undefined
            assertParamExists('controlStepControllerCreateEntity', 'controlStepEssential', controlStepEssential)
            const localVarPath = `/control/control-step/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(controlStepEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlStepControllerDeleteEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('controlStepControllerDeleteEntity', 'id', id)
            const localVarPath = `/control/control-step/delete/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlStepControllerFindControlRevisionWithLinkedStep: async (instant: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instant' is not null or undefined
            assertParamExists('controlStepControllerFindControlRevisionWithLinkedStep', 'instant', instant)
            const localVarPath = `/control/control-step/control-revision/with-linked-step`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (instant !== undefined) {
                localVarQueryParameter['instant'] = (instant as any instanceof Date) ?
                    (instant as any).toISOString() :
                    instant;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlStepControllerGetAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/control/control-step`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlStepControllerGetAllEntities: async (instant: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instant' is not null or undefined
            assertParamExists('controlStepControllerGetAllEntities', 'instant', instant)
            const localVarPath = `/control/control-step/get/all/{instant}`
                .replace('{instant}', encodeURIComponent(String(instant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlStepControllerGetById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('controlStepControllerGetById', 'id', id)
            const localVarPath = `/control/control-step/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} controlId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlStepControllerGetControlStepsByControl: async (controlId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlId' is not null or undefined
            assertParamExists('controlStepControllerGetControlStepsByControl', 'controlId', controlId)
            const localVarPath = `/control/control-step/by-control/{controlId}`
                .replace('{controlId}', encodeURIComponent(String(controlId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlStepControllerGetControlStepsByStep: async (stepId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('controlStepControllerGetControlStepsByStep', 'stepId', stepId)
            const localVarPath = `/control/control-step/by-step/{stepId}`
                .replace('{stepId}', encodeURIComponent(String(stepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlStepControllerGetDistinctValues: async (columnName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'columnName' is not null or undefined
            assertParamExists('controlStepControllerGetDistinctValues', 'columnName', columnName)
            const localVarPath = `/control/control-step/distinct-values`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (columnName !== undefined) {
                localVarQueryParameter['columnName'] = columnName;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlStepControllerGetEditsByStep: async (stepId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('controlStepControllerGetEditsByStep', 'stepId', stepId)
            const localVarPath = `/control/control-step/edits/by-step/{stepId}`
                .replace('{stepId}', encodeURIComponent(String(stepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlStepControllerGetSelectableValues: async (columnName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'columnName' is not null or undefined
            assertParamExists('controlStepControllerGetSelectableValues', 'columnName', columnName)
            const localVarPath = `/control/control-step/selectable-values`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (columnName !== undefined) {
                localVarQueryParameter['columnName'] = columnName;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlStepControllerRemoveEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('controlStepControllerRemoveEntity', 'id', id)
            const localVarPath = `/control/control-step/remove/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlStepControllerRestoreEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('controlStepControllerRestoreEntity', 'id', id)
            const localVarPath = `/control/control-step/restore/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} removedBy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlStepControllerRestoreEntityGroup: async (removedBy: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'removedBy' is not null or undefined
            assertParamExists('controlStepControllerRestoreEntityGroup', 'removedBy', removedBy)
            const localVarPath = `/control/control-step/restore-group/{removedBy}`
                .replace('{removedBy}', encodeURIComponent(String(removedBy)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ControlStepIdEssential} controlStepIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlStepControllerUpdateEntity: async (controlStepIdEssential: ControlStepIdEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlStepIdEssential' is not null or undefined
            assertParamExists('controlStepControllerUpdateEntity', 'controlStepIdEssential', controlStepIdEssential)
            const localVarPath = `/control/control-step/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(controlStepIdEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coreTasksApiApplicationPing: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} to 
         * @param {string} subject 
         * @param {EmailParams} emailParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailControllerSendEmail: async (to: Array<string>, subject: string, emailParams: EmailParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'to' is not null or undefined
            assertParamExists('emailControllerSendEmail', 'to', to)
            // verify required parameter 'subject' is not null or undefined
            assertParamExists('emailControllerSendEmail', 'subject', subject)
            // verify required parameter 'emailParams' is not null or undefined
            assertParamExists('emailControllerSendEmail', 'emailParams', emailParams)
            const localVarPath = `/notification/email/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (to) {
                localVarQueryParameter['to'] = to;
            }

            if (subject !== undefined) {
                localVarQueryParameter['subject'] = subject;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeDataControllerGetAllEmployeeData: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/workday/employee/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeDataControllerGetEmployeeByEmail: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('employeeDataControllerGetEmployeeByEmail', 'email', email)
            const localVarPath = `/workday/employee/byEmail/{email}`
                .replace('{email}', encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeDataControllerGetEmployeeByEmployeeId: async (employeeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('employeeDataControllerGetEmployeeByEmployeeId', 'employeeId', employeeId)
            const localVarPath = `/workday/employee/byEmployeeId/{employeeId}`
                .replace('{employeeId}', encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeDataControllerGetEmployeeLayout: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/workday/employee/layout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeDataControllerGetManagers: async (employeeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('employeeDataControllerGetManagers', 'employeeId', employeeId)
            const localVarPath = `/workday/employee/managers/{employeeId}`
                .replace('{employeeId}', encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeDataControllerGetPossibleDelegates: async (employeeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('employeeDataControllerGetPossibleDelegates', 'employeeId', employeeId)
            const localVarPath = `/workday/employee/possible-delegates/{employeeId}`
                .replace('{employeeId}', encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stepLinkId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeDataControllerIsOwnerOfStepLink: async (stepLinkId: string, employeeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepLinkId' is not null or undefined
            assertParamExists('employeeDataControllerIsOwnerOfStepLink', 'stepLinkId', stepLinkId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('employeeDataControllerIsOwnerOfStepLink', 'employeeId', employeeId)
            const localVarPath = `/workday/employee/is-owner-of-step-link/{stepLinkId}/{employeeId}`
                .replace('{stepLinkId}', encodeURIComponent(String(stepLinkId)))
                .replace('{employeeId}', encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} instant 
         * @param {string} level 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphControllerGetLayoutData: async (instant: string, level: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instant' is not null or undefined
            assertParamExists('graphControllerGetLayoutData', 'instant', instant)
            // verify required parameter 'level' is not null or undefined
            assertParamExists('graphControllerGetLayoutData', 'level', level)
            const localVarPath = `/graph/data/atlas-utility-api/{instant}`
                .replace('{instant}', encodeURIComponent(String(instant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (level !== undefined) {
                localVarQueryParameter['level'] = level;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LayoutBodyDTO} layoutBodyDTO 
         * @param {string} [algoType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphControllerGetNestedLayout: async (layoutBodyDTO: LayoutBodyDTO, algoType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'layoutBodyDTO' is not null or undefined
            assertParamExists('graphControllerGetNestedLayout', 'layoutBodyDTO', layoutBodyDTO)
            const localVarPath = `/graph/layout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (algoType !== undefined) {
                localVarQueryParameter['algoType'] = algoType;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(layoutBodyDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} instant 
         * @param {LayoutBodyDTO} layoutBodyDTO 
         * @param {string} [algoType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphControllerGetNestedLayoutByInstant: async (instant: string, layoutBodyDTO: LayoutBodyDTO, algoType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instant' is not null or undefined
            assertParamExists('graphControllerGetNestedLayoutByInstant', 'instant', instant)
            // verify required parameter 'layoutBodyDTO' is not null or undefined
            assertParamExists('graphControllerGetNestedLayoutByInstant', 'layoutBodyDTO', layoutBodyDTO)
            const localVarPath = `/graph/layout/{instant}`
                .replace('{instant}', encodeURIComponent(String(instant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (algoType !== undefined) {
                localVarQueryParameter['algoType'] = algoType;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(layoutBodyDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LayoutBodyDTO} layoutBodyDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphControllerGetRenderedEdges: async (layoutBodyDTO: LayoutBodyDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'layoutBodyDTO' is not null or undefined
            assertParamExists('graphControllerGetRenderedEdges', 'layoutBodyDTO', layoutBodyDTO)
            const localVarPath = `/graph/edges`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(layoutBodyDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} instant 
         * @param {LayoutBodyDTO} layoutBodyDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphControllerGetRenderedEdgesByInstant: async (instant: string, layoutBodyDTO: LayoutBodyDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instant' is not null or undefined
            assertParamExists('graphControllerGetRenderedEdgesByInstant', 'instant', instant)
            // verify required parameter 'layoutBodyDTO' is not null or undefined
            assertParamExists('graphControllerGetRenderedEdgesByInstant', 'layoutBodyDTO', layoutBodyDTO)
            const localVarPath = `/graph/edges/{instant}`
                .replace('{instant}', encodeURIComponent(String(instant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(layoutBodyDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GraphStateEssential} graphStateEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphStateControllerCreateEntity: async (graphStateEssential: GraphStateEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'graphStateEssential' is not null or undefined
            assertParamExists('graphStateControllerCreateEntity', 'graphStateEssential', graphStateEssential)
            const localVarPath = `/graph-state/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(graphStateEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphStateControllerDeleteEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('graphStateControllerDeleteEntity', 'id', id)
            const localVarPath = `/graph-state/delete/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphStateControllerGetAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/graph-state`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphStateControllerGetById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('graphStateControllerGetById', 'id', id)
            const localVarPath = `/graph-state/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} department 
         * @param {string} processName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphStateControllerGetGraphState: async (department: string, processName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'department' is not null or undefined
            assertParamExists('graphStateControllerGetGraphState', 'department', department)
            // verify required parameter 'processName' is not null or undefined
            assertParamExists('graphStateControllerGetGraphState', 'processName', processName)
            const localVarPath = `/graph-state/by-department-and-process-name`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (department !== undefined) {
                localVarQueryParameter['department'] = department;
            }

            if (processName !== undefined) {
                localVarQueryParameter['processName'] = processName;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GraphStateIdEssential} graphStateIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphStateControllerUpdateEntity: async (graphStateIdEssential: GraphStateIdEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'graphStateIdEssential' is not null or undefined
            assertParamExists('graphStateControllerUpdateEntity', 'graphStateIdEssential', graphStateIdEssential)
            const localVarPath = `/graph-state/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(graphStateIdEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GraphState} graphState 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphStateControllerUpsertGraphState: async (graphState: GraphState, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'graphState' is not null or undefined
            assertParamExists('graphStateControllerUpsertGraphState', 'graphState', graphState)
            const localVarPath = `/graph-state/upsert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(graphState, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobAidControllerGetFromUrl: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/workday/jobaid/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MitigationStepEssential} mitigationStepEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mitigationStepControllerCreateEntity: async (mitigationStepEssential: MitigationStepEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mitigationStepEssential' is not null or undefined
            assertParamExists('mitigationStepControllerCreateEntity', 'mitigationStepEssential', mitigationStepEssential)
            const localVarPath = `/risk/mitigation-step/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mitigationStepEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mitigationStepControllerDeleteEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('mitigationStepControllerDeleteEntity', 'id', id)
            const localVarPath = `/risk/mitigation-step/delete/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mitigationStepControllerGetAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/risk/mitigation-step`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mitigationStepControllerGetAllEntities: async (instant: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instant' is not null or undefined
            assertParamExists('mitigationStepControllerGetAllEntities', 'instant', instant)
            const localVarPath = `/risk/mitigation-step/get/all/{instant}`
                .replace('{instant}', encodeURIComponent(String(instant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mitigationStepControllerGetById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('mitigationStepControllerGetById', 'id', id)
            const localVarPath = `/risk/mitigation-step/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} riskSourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mitigationStepControllerGetByRiskSource: async (riskSourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'riskSourceId' is not null or undefined
            assertParamExists('mitigationStepControllerGetByRiskSource', 'riskSourceId', riskSourceId)
            const localVarPath = `/risk/mitigation-step/by-risk-source/{riskSourceId}`
                .replace('{riskSourceId}', encodeURIComponent(String(riskSourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mitigationStepControllerGetByStep: async (stepId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('mitigationStepControllerGetByStep', 'stepId', stepId)
            const localVarPath = `/risk/mitigation-step/by-step/{stepId}`
                .replace('{stepId}', encodeURIComponent(String(stepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mitigationStepControllerGetDistinctValues: async (columnName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'columnName' is not null or undefined
            assertParamExists('mitigationStepControllerGetDistinctValues', 'columnName', columnName)
            const localVarPath = `/risk/mitigation-step/distinct-values`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (columnName !== undefined) {
                localVarQueryParameter['columnName'] = columnName;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mitigationStepControllerGetSelectableValues: async (columnName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'columnName' is not null or undefined
            assertParamExists('mitigationStepControllerGetSelectableValues', 'columnName', columnName)
            const localVarPath = `/risk/mitigation-step/selectable-values`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (columnName !== undefined) {
                localVarQueryParameter['columnName'] = columnName;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mitigationStepControllerRemoveEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('mitigationStepControllerRemoveEntity', 'id', id)
            const localVarPath = `/risk/mitigation-step/remove/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mitigationStepControllerRestoreEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('mitigationStepControllerRestoreEntity', 'id', id)
            const localVarPath = `/risk/mitigation-step/restore/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} removedBy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mitigationStepControllerRestoreEntityGroup: async (removedBy: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'removedBy' is not null or undefined
            assertParamExists('mitigationStepControllerRestoreEntityGroup', 'removedBy', removedBy)
            const localVarPath = `/risk/mitigation-step/restore-group/{removedBy}`
                .replace('{removedBy}', encodeURIComponent(String(removedBy)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MitigationStepIdEssential} mitigationStepIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mitigationStepControllerUpdateEntity: async (mitigationStepIdEssential: MitigationStepIdEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mitigationStepIdEssential' is not null or undefined
            assertParamExists('mitigationStepControllerUpdateEntity', 'mitigationStepIdEssential', mitigationStepIdEssential)
            const localVarPath = `/risk/mitigation-step/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mitigationStepIdEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {OwnershipEssential} ownershipEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ownershipControllerCreateEntity: async (ownershipEssential: OwnershipEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ownershipEssential' is not null or undefined
            assertParamExists('ownershipControllerCreateEntity', 'ownershipEssential', ownershipEssential)
            const localVarPath = `/ownership/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ownershipEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ownershipControllerDeleteEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('ownershipControllerDeleteEntity', 'id', id)
            const localVarPath = `/ownership/delete/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ownershipControllerGetAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ownership`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ownershipControllerGetById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('ownershipControllerGetById', 'id', id)
            const localVarPath = `/ownership/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ownershipControllerGetDelegations: async (employeeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('ownershipControllerGetDelegations', 'employeeId', employeeId)
            const localVarPath = `/ownership/delegations/{employeeId}`
                .replace('{employeeId}', encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ownershipControllerGetOwnerships: async (employeeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('ownershipControllerGetOwnerships', 'employeeId', employeeId)
            const localVarPath = `/ownership/owner/{employeeId}`
                .replace('{employeeId}', encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {OwnershipIdEssential} ownershipIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ownershipControllerUpdateEntity: async (ownershipIdEssential: OwnershipIdEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ownershipIdEssential' is not null or undefined
            assertParamExists('ownershipControllerUpdateEntity', 'ownershipIdEssential', ownershipIdEssential)
            const localVarPath = `/ownership/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ownershipIdEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReviewPeriodEssential} reviewPeriodEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewPeriodControllerCreateEntity: async (reviewPeriodEssential: ReviewPeriodEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reviewPeriodEssential' is not null or undefined
            assertParamExists('reviewPeriodControllerCreateEntity', 'reviewPeriodEssential', reviewPeriodEssential)
            const localVarPath = `/review/period/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reviewPeriodEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewPeriodControllerDeleteEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('reviewPeriodControllerDeleteEntity', 'id', id)
            const localVarPath = `/review/period/delete/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewPeriodControllerFindReviewPeriodForDate: async (date: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'date' is not null or undefined
            assertParamExists('reviewPeriodControllerFindReviewPeriodForDate', 'date', date)
            const localVarPath = `/review/period/review-period-for-date`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString().substring(0,10) :
                    date;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewPeriodControllerGetAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/review/period`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewPeriodControllerGetAllAndSortByStartDate: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/review/period/sorted`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewPeriodControllerGetById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('reviewPeriodControllerGetById', 'id', id)
            const localVarPath = `/review/period/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReviewPeriodIdEssential} reviewPeriodIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewPeriodControllerUpdateEntity: async (reviewPeriodIdEssential: ReviewPeriodIdEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reviewPeriodIdEssential' is not null or undefined
            assertParamExists('reviewPeriodControllerUpdateEntity', 'reviewPeriodIdEssential', reviewPeriodIdEssential)
            const localVarPath = `/review/period/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reviewPeriodIdEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskControllerCreateEntity: async (body: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('riskControllerCreateEntity', 'body', body)
            const localVarPath = `/risk/risk/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskControllerDeleteEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('riskControllerDeleteEntity', 'id', id)
            const localVarPath = `/risk/risk/delete/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DomainFilter} domainFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskControllerEnterpriseRiskByDomainFilter: async (domainFilter: DomainFilter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'domainFilter' is not null or undefined
            assertParamExists('riskControllerEnterpriseRiskByDomainFilter', 'domainFilter', domainFilter)
            const localVarPath = `/risk/risk/enterprise-risk/domain/filter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(domainFilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} instant 
         * @param {DomainFilter} domainFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskControllerEnterpriseRiskByDomainFilterAndInstant: async (instant: string, domainFilter: DomainFilter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instant' is not null or undefined
            assertParamExists('riskControllerEnterpriseRiskByDomainFilterAndInstant', 'instant', instant)
            // verify required parameter 'domainFilter' is not null or undefined
            assertParamExists('riskControllerEnterpriseRiskByDomainFilterAndInstant', 'domainFilter', domainFilter)
            const localVarPath = `/risk/risk/enterprise-risk/domain/filter/{instant}`
                .replace('{instant}', encodeURIComponent(String(instant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(domainFilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} riskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskControllerGetAggregateRiskReportAverages: async (riskId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'riskId' is not null or undefined
            assertParamExists('riskControllerGetAggregateRiskReportAverages', 'riskId', riskId)
            const localVarPath = `/risk/risk/aggregated-report/average/{riskId}`
                .replace('{riskId}', encodeURIComponent(String(riskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} riskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskControllerGetAggregateRiskReportMedians: async (riskId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'riskId' is not null or undefined
            assertParamExists('riskControllerGetAggregateRiskReportMedians', 'riskId', riskId)
            const localVarPath = `/risk/risk/aggregated-report/median/{riskId}`
                .replace('{riskId}', encodeURIComponent(String(riskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskControllerGetAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/risk/risk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskControllerGetById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('riskControllerGetById', 'id', id)
            const localVarPath = `/risk/risk/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RiskIdEssential} riskIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskControllerUpdateEntity: async (riskIdEssential: RiskIdEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'riskIdEssential' is not null or undefined
            assertParamExists('riskControllerUpdateEntity', 'riskIdEssential', riskIdEssential)
            const localVarPath = `/risk/risk/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(riskIdEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RiskRevisionEssential} riskRevisionEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskRevisionControllerCreateEntity: async (riskRevisionEssential: RiskRevisionEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'riskRevisionEssential' is not null or undefined
            assertParamExists('riskRevisionControllerCreateEntity', 'riskRevisionEssential', riskRevisionEssential)
            const localVarPath = `/risk/risk-revision/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(riskRevisionEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskRevisionControllerDeleteEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('riskRevisionControllerDeleteEntity', 'id', id)
            const localVarPath = `/risk/risk-revision/delete/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DomainFilter} domainFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskRevisionControllerFindByDomainFilter: async (domainFilter: DomainFilter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'domainFilter' is not null or undefined
            assertParamExists('riskRevisionControllerFindByDomainFilter', 'domainFilter', domainFilter)
            const localVarPath = `/risk/risk-revision/domain/filter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(domainFilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} instant 
         * @param {DomainFilter} domainFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskRevisionControllerFindByDomainFilterAndInstant: async (instant: string, domainFilter: DomainFilter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instant' is not null or undefined
            assertParamExists('riskRevisionControllerFindByDomainFilterAndInstant', 'instant', instant)
            // verify required parameter 'domainFilter' is not null or undefined
            assertParamExists('riskRevisionControllerFindByDomainFilterAndInstant', 'domainFilter', domainFilter)
            const localVarPath = `/risk/risk-revision/domain/filter/{instant}`
                .replace('{instant}', encodeURIComponent(String(instant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(domainFilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskRevisionControllerGetAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/risk/risk-revision`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskRevisionControllerGetAllEntities: async (instant: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instant' is not null or undefined
            assertParamExists('riskRevisionControllerGetAllEntities', 'instant', instant)
            const localVarPath = `/risk/risk-revision/get/all/{instant}`
                .replace('{instant}', encodeURIComponent(String(instant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskRevisionControllerGetById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('riskRevisionControllerGetById', 'id', id)
            const localVarPath = `/risk/risk-revision/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskRevisionControllerGetDistinctValues: async (columnName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'columnName' is not null or undefined
            assertParamExists('riskRevisionControllerGetDistinctValues', 'columnName', columnName)
            const localVarPath = `/risk/risk-revision/distinct-values`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (columnName !== undefined) {
                localVarQueryParameter['columnName'] = columnName;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} instant 
         * @param {GroupedRiskFilters} groupedRiskFilters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskRevisionControllerGetRiskConnectionsData: async (instant: string, groupedRiskFilters: GroupedRiskFilters, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instant' is not null or undefined
            assertParamExists('riskRevisionControllerGetRiskConnectionsData', 'instant', instant)
            // verify required parameter 'groupedRiskFilters' is not null or undefined
            assertParamExists('riskRevisionControllerGetRiskConnectionsData', 'groupedRiskFilters', groupedRiskFilters)
            const localVarPath = `/risk/risk-revision/connections/{instant}`
                .replace('{instant}', encodeURIComponent(String(instant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(groupedRiskFilters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {string} [instant] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskRevisionControllerGetRiskSourceConnectionCountsBatch: async (requestBody: Array<string>, instant?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('riskRevisionControllerGetRiskSourceConnectionCountsBatch', 'requestBody', requestBody)
            const localVarPath = `/risk/risk-revision/risk-source-connections/counts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (instant !== undefined) {
                localVarQueryParameter['instant'] = (instant as any instanceof Date) ?
                    (instant as any).toISOString() :
                    instant;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskRevisionControllerGetSelectableValues: async (columnName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'columnName' is not null or undefined
            assertParamExists('riskRevisionControllerGetSelectableValues', 'columnName', columnName)
            const localVarPath = `/risk/risk-revision/selectable-values`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (columnName !== undefined) {
                localVarQueryParameter['columnName'] = columnName;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskRevisionControllerRemoveEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('riskRevisionControllerRemoveEntity', 'id', id)
            const localVarPath = `/risk/risk-revision/remove/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskRevisionControllerRestoreEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('riskRevisionControllerRestoreEntity', 'id', id)
            const localVarPath = `/risk/risk-revision/restore/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} removedBy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskRevisionControllerRestoreEntityGroup: async (removedBy: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'removedBy' is not null or undefined
            assertParamExists('riskRevisionControllerRestoreEntityGroup', 'removedBy', removedBy)
            const localVarPath = `/risk/risk-revision/restore-group/{removedBy}`
                .replace('{removedBy}', encodeURIComponent(String(removedBy)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RiskRevisionIdEssential} riskRevisionIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskRevisionControllerUpdateEntity: async (riskRevisionIdEssential: RiskRevisionIdEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'riskRevisionIdEssential' is not null or undefined
            assertParamExists('riskRevisionControllerUpdateEntity', 'riskRevisionIdEssential', riskRevisionIdEssential)
            const localVarPath = `/risk/risk-revision/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(riskRevisionIdEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RiskSourceAggregateCreateRequest} riskSourceAggregateCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceAggregateControllerCreate: async (riskSourceAggregateCreateRequest: RiskSourceAggregateCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'riskSourceAggregateCreateRequest' is not null or undefined
            assertParamExists('riskSourceAggregateControllerCreate', 'riskSourceAggregateCreateRequest', riskSourceAggregateCreateRequest)
            const localVarPath = `/risk/risk-source-aggregate/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(riskSourceAggregateCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DomainFilter} domainFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceAggregateControllerFindAggregatesByDomainFilter: async (domainFilter: DomainFilter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'domainFilter' is not null or undefined
            assertParamExists('riskSourceAggregateControllerFindAggregatesByDomainFilter', 'domainFilter', domainFilter)
            const localVarPath = `/risk/risk-source-aggregate/aggregates/domain/filter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(domainFilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} instant 
         * @param {DomainFilter} domainFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceAggregateControllerFindAggregatesByDomainFilterAndInstant: async (instant: string, domainFilter: DomainFilter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instant' is not null or undefined
            assertParamExists('riskSourceAggregateControllerFindAggregatesByDomainFilterAndInstant', 'instant', instant)
            // verify required parameter 'domainFilter' is not null or undefined
            assertParamExists('riskSourceAggregateControllerFindAggregatesByDomainFilterAndInstant', 'domainFilter', domainFilter)
            const localVarPath = `/risk/risk-source-aggregate/aggregates/domain/filter/{instant}`
                .replace('{instant}', encodeURIComponent(String(instant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(domainFilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} step 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceAggregateControllerGetByStep: async (step: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'step' is not null or undefined
            assertParamExists('riskSourceAggregateControllerGetByStep', 'step', step)
            const localVarPath = `/risk/risk-source-aggregate/by-step/{step}`
                .replace('{step}', encodeURIComponent(String(step)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceAggregateControllerGetLinkOptionsByStep: async (stepId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('riskSourceAggregateControllerGetLinkOptionsByStep', 'stepId', stepId)
            const localVarPath = `/risk/risk-source-aggregate/link-options/by-step/{stepId}`
                .replace('{stepId}', encodeURIComponent(String(stepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} riskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceAggregateControllerReadByRisk: async (riskId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'riskId' is not null or undefined
            assertParamExists('riskSourceAggregateControllerReadByRisk', 'riskId', riskId)
            const localVarPath = `/risk/risk-source-aggregate/by-risk/{riskId}`
                .replace('{riskId}', encodeURIComponent(String(riskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} riskSourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceAggregateControllerReadByRiskSource: async (riskSourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'riskSourceId' is not null or undefined
            assertParamExists('riskSourceAggregateControllerReadByRiskSource', 'riskSourceId', riskSourceId)
            const localVarPath = `/risk/risk-source-aggregate/by-risk-source/{riskSourceId}`
                .replace('{riskSourceId}', encodeURIComponent(String(riskSourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} riskSourceId 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceAggregateControllerRemoveStepRelationship: async (riskSourceId: string, stepId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'riskSourceId' is not null or undefined
            assertParamExists('riskSourceAggregateControllerRemoveStepRelationship', 'riskSourceId', riskSourceId)
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('riskSourceAggregateControllerRemoveStepRelationship', 'stepId', stepId)
            const localVarPath = `/risk/risk-source-aggregate/by-risk-source/{riskSourceId}/step/{stepId}`
                .replace('{riskSourceId}', encodeURIComponent(String(riskSourceId)))
                .replace('{stepId}', encodeURIComponent(String(stepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RiskSourceAggregateUpdateRequest} riskSourceAggregateUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceAggregateControllerUpdate: async (riskSourceAggregateUpdateRequest: RiskSourceAggregateUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'riskSourceAggregateUpdateRequest' is not null or undefined
            assertParamExists('riskSourceAggregateControllerUpdate', 'riskSourceAggregateUpdateRequest', riskSourceAggregateUpdateRequest)
            const localVarPath = `/risk/risk-source-aggregate/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(riskSourceAggregateUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RiskSourceEssential} riskSourceEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceControllerCreateEntity: async (riskSourceEssential: RiskSourceEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'riskSourceEssential' is not null or undefined
            assertParamExists('riskSourceControllerCreateEntity', 'riskSourceEssential', riskSourceEssential)
            const localVarPath = `/risk/risk-source/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(riskSourceEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceControllerDeleteEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('riskSourceControllerDeleteEntity', 'id', id)
            const localVarPath = `/risk/risk-source/delete/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceControllerGetAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/risk/risk-source`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceControllerGetById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('riskSourceControllerGetById', 'id', id)
            const localVarPath = `/risk/risk-source/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} riskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceControllerGetByRisk: async (riskId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'riskId' is not null or undefined
            assertParamExists('riskSourceControllerGetByRisk', 'riskId', riskId)
            const localVarPath = `/risk/risk-source/by-risk/{riskId}`
                .replace('{riskId}', encodeURIComponent(String(riskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RiskSourceIdEssential} riskSourceIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceControllerUpdateEntity: async (riskSourceIdEssential: RiskSourceIdEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'riskSourceIdEssential' is not null or undefined
            assertParamExists('riskSourceControllerUpdateEntity', 'riskSourceIdEssential', riskSourceIdEssential)
            const localVarPath = `/risk/risk-source/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(riskSourceIdEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RiskSourceRevisionEssential} riskSourceRevisionEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceRevisionControllerCreateEntity: async (riskSourceRevisionEssential: RiskSourceRevisionEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'riskSourceRevisionEssential' is not null or undefined
            assertParamExists('riskSourceRevisionControllerCreateEntity', 'riskSourceRevisionEssential', riskSourceRevisionEssential)
            const localVarPath = `/risk/risk-source-revision/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(riskSourceRevisionEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceRevisionControllerDeleteEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('riskSourceRevisionControllerDeleteEntity', 'id', id)
            const localVarPath = `/risk/risk-source-revision/delete/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DomainFilter} domainFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceRevisionControllerFindByDomainFilter: async (domainFilter: DomainFilter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'domainFilter' is not null or undefined
            assertParamExists('riskSourceRevisionControllerFindByDomainFilter', 'domainFilter', domainFilter)
            const localVarPath = `/risk/risk-source-revision/domain/filter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(domainFilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} instant 
         * @param {DomainFilter} domainFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceRevisionControllerFindByDomainFilterAndInstant: async (instant: string, domainFilter: DomainFilter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instant' is not null or undefined
            assertParamExists('riskSourceRevisionControllerFindByDomainFilterAndInstant', 'instant', instant)
            // verify required parameter 'domainFilter' is not null or undefined
            assertParamExists('riskSourceRevisionControllerFindByDomainFilterAndInstant', 'domainFilter', domainFilter)
            const localVarPath = `/risk/risk-source-revision/domain/filter/{instant}`
                .replace('{instant}', encodeURIComponent(String(instant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(domainFilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceRevisionControllerGetAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/risk/risk-source-revision`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceRevisionControllerGetAllEntities: async (instant: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instant' is not null or undefined
            assertParamExists('riskSourceRevisionControllerGetAllEntities', 'instant', instant)
            const localVarPath = `/risk/risk-source-revision/get/all/{instant}`
                .replace('{instant}', encodeURIComponent(String(instant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceRevisionControllerGetById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('riskSourceRevisionControllerGetById', 'id', id)
            const localVarPath = `/risk/risk-source-revision/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} riskSourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceRevisionControllerGetByRiskSource: async (riskSourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'riskSourceId' is not null or undefined
            assertParamExists('riskSourceRevisionControllerGetByRiskSource', 'riskSourceId', riskSourceId)
            const localVarPath = `/risk/risk-source-revision/by-risk-source/{riskSourceId}`
                .replace('{riskSourceId}', encodeURIComponent(String(riskSourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceRevisionControllerGetDistinctValues: async (columnName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'columnName' is not null or undefined
            assertParamExists('riskSourceRevisionControllerGetDistinctValues', 'columnName', columnName)
            const localVarPath = `/risk/risk-source-revision/distinct-values`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (columnName !== undefined) {
                localVarQueryParameter['columnName'] = columnName;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceRevisionControllerGetSelectableValues: async (columnName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'columnName' is not null or undefined
            assertParamExists('riskSourceRevisionControllerGetSelectableValues', 'columnName', columnName)
            const localVarPath = `/risk/risk-source-revision/selectable-values`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (columnName !== undefined) {
                localVarQueryParameter['columnName'] = columnName;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceRevisionControllerRemoveEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('riskSourceRevisionControllerRemoveEntity', 'id', id)
            const localVarPath = `/risk/risk-source-revision/remove/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceRevisionControllerRestoreEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('riskSourceRevisionControllerRestoreEntity', 'id', id)
            const localVarPath = `/risk/risk-source-revision/restore/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} removedBy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceRevisionControllerRestoreEntityGroup: async (removedBy: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'removedBy' is not null or undefined
            assertParamExists('riskSourceRevisionControllerRestoreEntityGroup', 'removedBy', removedBy)
            const localVarPath = `/risk/risk-source-revision/restore-group/{removedBy}`
                .replace('{removedBy}', encodeURIComponent(String(removedBy)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RiskSourceRevisionIdEssential} riskSourceRevisionIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceRevisionControllerUpdateEntity: async (riskSourceRevisionIdEssential: RiskSourceRevisionIdEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'riskSourceRevisionIdEssential' is not null or undefined
            assertParamExists('riskSourceRevisionControllerUpdateEntity', 'riskSourceRevisionIdEssential', riskSourceRevisionIdEssential)
            const localVarPath = `/risk/risk-source-revision/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(riskSourceRevisionIdEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {TaskActionRequest} taskActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootTaskControllerClaimTask: async (id: string, taskActionRequest: TaskActionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rootTaskControllerClaimTask', 'id', id)
            // verify required parameter 'taskActionRequest' is not null or undefined
            assertParamExists('rootTaskControllerClaimTask', 'taskActionRequest', taskActionRequest)
            const localVarPath = `/task/root-task/{id}/claim`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(taskActionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RootTaskEssential} rootTaskEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootTaskControllerCreateEntity: async (rootTaskEssential: RootTaskEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rootTaskEssential' is not null or undefined
            assertParamExists('rootTaskControllerCreateEntity', 'rootTaskEssential', rootTaskEssential)
            const localVarPath = `/task/root-task/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rootTaskEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateTaskRequest} createTaskRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootTaskControllerCreateTaskWithLogs: async (createTaskRequest: CreateTaskRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createTaskRequest' is not null or undefined
            assertParamExists('rootTaskControllerCreateTaskWithLogs', 'createTaskRequest', createTaskRequest)
            const localVarPath = `/task/root-task/create-with-logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTaskRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {TaskActionRequest} taskActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootTaskControllerDeclineTask: async (id: string, taskActionRequest: TaskActionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rootTaskControllerDeclineTask', 'id', id)
            // verify required parameter 'taskActionRequest' is not null or undefined
            assertParamExists('rootTaskControllerDeclineTask', 'taskActionRequest', taskActionRequest)
            const localVarPath = `/task/root-task/{id}/decline`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(taskActionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootTaskControllerDeleteEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rootTaskControllerDeleteEntity', 'id', id)
            const localVarPath = `/task/root-task/delete/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {TaskActionRequest} taskActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootTaskControllerDeleteTask: async (id: string, taskActionRequest: TaskActionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rootTaskControllerDeleteTask', 'id', id)
            // verify required parameter 'taskActionRequest' is not null or undefined
            assertParamExists('rootTaskControllerDeleteTask', 'taskActionRequest', taskActionRequest)
            const localVarPath = `/task/root-task/{id}/delete`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(taskActionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootTaskControllerGetAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/task/root-task`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootTaskControllerGetById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rootTaskControllerGetById', 'id', id)
            const localVarPath = `/task/root-task/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootTaskControllerGetClaimed: async (employeeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('rootTaskControllerGetClaimed', 'employeeId', employeeId)
            const localVarPath = `/task/root-task/claimed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootTaskControllerGetDone: async (employeeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('rootTaskControllerGetDone', 'employeeId', employeeId)
            const localVarPath = `/task/root-task/done`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootTaskControllerGetGenerated: async (employeeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('rootTaskControllerGetGenerated', 'employeeId', employeeId)
            const localVarPath = `/task/root-task/generated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootTaskControllerGetNeedsReview: async (employeeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('rootTaskControllerGetNeedsReview', 'employeeId', employeeId)
            const localVarPath = `/task/root-task/reviews`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MarkTaskCompleteRequest} markTaskCompleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootTaskControllerMarkComplete: async (markTaskCompleteRequest: MarkTaskCompleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'markTaskCompleteRequest' is not null or undefined
            assertParamExists('rootTaskControllerMarkComplete', 'markTaskCompleteRequest', markTaskCompleteRequest)
            const localVarPath = `/task/root-task/mark-complete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markTaskCompleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {TaskActionRequest} taskActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootTaskControllerRevertTask: async (id: string, taskActionRequest: TaskActionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rootTaskControllerRevertTask', 'id', id)
            // verify required parameter 'taskActionRequest' is not null or undefined
            assertParamExists('rootTaskControllerRevertTask', 'taskActionRequest', taskActionRequest)
            const localVarPath = `/task/root-task/{id}/revert`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(taskActionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [description] 
         * @param {TaskTypeEnum} [sourceType] 
         * @param {string} [sourceId] 
         * @param {TaskTypeEnum} [targetType] 
         * @param {string} [targetId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootTaskControllerSearch: async (description?: string, sourceType?: TaskTypeEnum, sourceId?: string, targetType?: TaskTypeEnum, targetId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/task/root-task/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (description !== undefined) {
                localVarQueryParameter['description'] = description;
            }

            if (sourceType !== undefined) {
                localVarQueryParameter['sourceType'] = sourceType;
            }

            if (sourceId !== undefined) {
                localVarQueryParameter['sourceId'] = sourceId;
            }

            if (targetType !== undefined) {
                localVarQueryParameter['targetType'] = targetType;
            }

            if (targetId !== undefined) {
                localVarQueryParameter['targetId'] = targetId;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {TaskActionRequest} taskActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootTaskControllerUnclaimTask: async (id: string, taskActionRequest: TaskActionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rootTaskControllerUnclaimTask', 'id', id)
            // verify required parameter 'taskActionRequest' is not null or undefined
            assertParamExists('rootTaskControllerUnclaimTask', 'taskActionRequest', taskActionRequest)
            const localVarPath = `/task/root-task/{id}/unclaim`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(taskActionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RootTaskIdEssential} rootTaskIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootTaskControllerUpdateEntity: async (rootTaskIdEssential: RootTaskIdEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rootTaskIdEssential' is not null or undefined
            assertParamExists('rootTaskControllerUpdateEntity', 'rootTaskIdEssential', rootTaskIdEssential)
            const localVarPath = `/task/root-task/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rootTaskIdEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SignOffOwners} signOffOwners 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signOffOwnersControllerCreateOwner: async (signOffOwners: SignOffOwners, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'signOffOwners' is not null or undefined
            assertParamExists('signOffOwnersControllerCreateOwner', 'signOffOwners', signOffOwners)
            const localVarPath = `/sign-off-owners/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(signOffOwners, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SignOffInsertDTO} signOffInsertDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signOffOwnersControllerDeleteAndInsert: async (signOffInsertDTO: SignOffInsertDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'signOffInsertDTO' is not null or undefined
            assertParamExists('signOffOwnersControllerDeleteAndInsert', 'signOffInsertDTO', signOffInsertDTO)
            const localVarPath = `/sign-off-owners/delete-and-insert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(signOffInsertDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signOffOwnersControllerDeleteOwner: async (employeeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('signOffOwnersControllerDeleteOwner', 'employeeId', employeeId)
            const localVarPath = `/sign-off-owners/delete/{employeeId}`
                .replace('{employeeId}', encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signOffOwnersControllerGetAllOwners: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sign-off-owners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signOffOwnersControllerIsSignOffOwner: async (employeeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('signOffOwnersControllerIsSignOffOwner', 'employeeId', employeeId)
            const localVarPath = `/sign-off-owners/is-sign-off-owner/{employeeId}`
                .replace('{employeeId}', encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        slackSenderControllerHealthCheck: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/slack/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        slackSenderControllerTriggerReminderMessage: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/slack/send-reminder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        slackSenderControllerTriggerReminderMessageForEmail: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('slackSenderControllerTriggerReminderMessageForEmail', 'email', email)
            const localVarPath = `/slack/send-reminder/email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SourceStepEssential} sourceStepEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sourceStepControllerCreateEntity: async (sourceStepEssential: SourceStepEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceStepEssential' is not null or undefined
            assertParamExists('sourceStepControllerCreateEntity', 'sourceStepEssential', sourceStepEssential)
            const localVarPath = `/risk/source-step/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sourceStepEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sourceStepControllerDeleteEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('sourceStepControllerDeleteEntity', 'id', id)
            const localVarPath = `/risk/source-step/delete/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sourceStepControllerGetAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/risk/source-step`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sourceStepControllerGetAllEntities: async (instant: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instant' is not null or undefined
            assertParamExists('sourceStepControllerGetAllEntities', 'instant', instant)
            const localVarPath = `/risk/source-step/get/all/{instant}`
                .replace('{instant}', encodeURIComponent(String(instant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sourceStepControllerGetById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('sourceStepControllerGetById', 'id', id)
            const localVarPath = `/risk/source-step/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} riskSourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sourceStepControllerGetByRiskSource: async (riskSourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'riskSourceId' is not null or undefined
            assertParamExists('sourceStepControllerGetByRiskSource', 'riskSourceId', riskSourceId)
            const localVarPath = `/risk/source-step/by-risk-source/{riskSourceId}`
                .replace('{riskSourceId}', encodeURIComponent(String(riskSourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sourceStepControllerGetByStep: async (stepId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('sourceStepControllerGetByStep', 'stepId', stepId)
            const localVarPath = `/risk/source-step/by-step/{stepId}`
                .replace('{stepId}', encodeURIComponent(String(stepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sourceStepControllerGetDistinctValues: async (columnName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'columnName' is not null or undefined
            assertParamExists('sourceStepControllerGetDistinctValues', 'columnName', columnName)
            const localVarPath = `/risk/source-step/distinct-values`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (columnName !== undefined) {
                localVarQueryParameter['columnName'] = columnName;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sourceStepControllerGetSelectableValues: async (columnName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'columnName' is not null or undefined
            assertParamExists('sourceStepControllerGetSelectableValues', 'columnName', columnName)
            const localVarPath = `/risk/source-step/selectable-values`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (columnName !== undefined) {
                localVarQueryParameter['columnName'] = columnName;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sourceStepControllerRemoveEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('sourceStepControllerRemoveEntity', 'id', id)
            const localVarPath = `/risk/source-step/remove/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sourceStepControllerRestoreEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('sourceStepControllerRestoreEntity', 'id', id)
            const localVarPath = `/risk/source-step/restore/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} removedBy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sourceStepControllerRestoreEntityGroup: async (removedBy: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'removedBy' is not null or undefined
            assertParamExists('sourceStepControllerRestoreEntityGroup', 'removedBy', removedBy)
            const localVarPath = `/risk/source-step/restore-group/{removedBy}`
                .replace('{removedBy}', encodeURIComponent(String(removedBy)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SourceStepIdEssential} sourceStepIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sourceStepControllerUpdateEntity: async (sourceStepIdEssential: SourceStepIdEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceStepIdEssential' is not null or undefined
            assertParamExists('sourceStepControllerUpdateEntity', 'sourceStepIdEssential', sourceStepIdEssential)
            const localVarPath = `/risk/source-step/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sourceStepIdEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StepConfirmationEssential} stepConfirmationEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepConfirmationControllerCreateEntity: async (stepConfirmationEssential: StepConfirmationEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepConfirmationEssential' is not null or undefined
            assertParamExists('stepConfirmationControllerCreateEntity', 'stepConfirmationEssential', stepConfirmationEssential)
            const localVarPath = `/step-confirmation/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stepConfirmationEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepConfirmationControllerDeleteEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('stepConfirmationControllerDeleteEntity', 'id', id)
            const localVarPath = `/step-confirmation/delete/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stepId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepConfirmationControllerFindByStepInRange: async (stepId: string, startDate: string, endDate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('stepConfirmationControllerFindByStepInRange', 'stepId', stepId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('stepConfirmationControllerFindByStepInRange', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('stepConfirmationControllerFindByStepInRange', 'endDate', endDate)
            const localVarPath = `/step-confirmation/step/in-range`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (stepId !== undefined) {
                localVarQueryParameter['stepId'] = stepId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepConfirmationControllerGetAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/step-confirmation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} asOfDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepConfirmationControllerGetAllUnconfirmedStepRevisions: async (asOfDate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'asOfDate' is not null or undefined
            assertParamExists('stepConfirmationControllerGetAllUnconfirmedStepRevisions', 'asOfDate', asOfDate)
            const localVarPath = `/step-confirmation/step/unconfirmed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (asOfDate !== undefined) {
                localVarQueryParameter['asOfDate'] = (asOfDate as any instanceof Date) ?
                    (asOfDate as any).toISOString() :
                    asOfDate;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepConfirmationControllerGetById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('stepConfirmationControllerGetById', 'id', id)
            const localVarPath = `/step-confirmation/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {string} asOfDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepConfirmationControllerGetUnconfirmedStepRevisionsByOwner: async (employeeId: string, asOfDate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('stepConfirmationControllerGetUnconfirmedStepRevisionsByOwner', 'employeeId', employeeId)
            // verify required parameter 'asOfDate' is not null or undefined
            assertParamExists('stepConfirmationControllerGetUnconfirmedStepRevisionsByOwner', 'asOfDate', asOfDate)
            const localVarPath = `/step-confirmation/step/unconfirmed/{employeeId}`
                .replace('{employeeId}', encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (asOfDate !== undefined) {
                localVarQueryParameter['asOfDate'] = (asOfDate as any instanceof Date) ?
                    (asOfDate as any).toISOString() :
                    asOfDate;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepConfirmationControllerSubmitNewConfirmation: async (employeeId: string, requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('stepConfirmationControllerSubmitNewConfirmation', 'employeeId', employeeId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('stepConfirmationControllerSubmitNewConfirmation', 'requestBody', requestBody)
            const localVarPath = `/step-confirmation/submit/{employeeId}`
                .replace('{employeeId}', encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StepConfirmationIdEssential} stepConfirmationIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepConfirmationControllerUpdateEntity: async (stepConfirmationIdEssential: StepConfirmationIdEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepConfirmationIdEssential' is not null or undefined
            assertParamExists('stepConfirmationControllerUpdateEntity', 'stepConfirmationIdEssential', stepConfirmationIdEssential)
            const localVarPath = `/step-confirmation/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stepConfirmationIdEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StepConfirmationLinkEssential} stepConfirmationLinkEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepConfirmationLinkControllerCreateEntity: async (stepConfirmationLinkEssential: StepConfirmationLinkEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepConfirmationLinkEssential' is not null or undefined
            assertParamExists('stepConfirmationLinkControllerCreateEntity', 'stepConfirmationLinkEssential', stepConfirmationLinkEssential)
            const localVarPath = `/step-confirmation-link/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stepConfirmationLinkEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepConfirmationLinkControllerDeleteEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('stepConfirmationLinkControllerDeleteEntity', 'id', id)
            const localVarPath = `/step-confirmation-link/delete/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepConfirmationLinkControllerFindAllByEmployeeIdAndDateRange: async (employeeId: string, startDate: string, endDate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('stepConfirmationLinkControllerFindAllByEmployeeIdAndDateRange', 'employeeId', employeeId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('stepConfirmationLinkControllerFindAllByEmployeeIdAndDateRange', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('stepConfirmationLinkControllerFindAllByEmployeeIdAndDateRange', 'endDate', endDate)
            const localVarPath = `/step-confirmation-link/{employeeId}/in-range`
                .replace('{employeeId}', encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepConfirmationLinkControllerFindByDateRange: async (startDate: string, endDate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('stepConfirmationLinkControllerFindByDateRange', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('stepConfirmationLinkControllerFindByDateRange', 'endDate', endDate)
            const localVarPath = `/step-confirmation-link/in-range`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepConfirmationLinkControllerGetAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/step-confirmation-link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepConfirmationLinkControllerGetById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('stepConfirmationLinkControllerGetById', 'id', id)
            const localVarPath = `/step-confirmation-link/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StepConfirmationLinkIdEssential} stepConfirmationLinkIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepConfirmationLinkControllerUpdateEntity: async (stepConfirmationLinkIdEssential: StepConfirmationLinkIdEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepConfirmationLinkIdEssential' is not null or undefined
            assertParamExists('stepConfirmationLinkControllerUpdateEntity', 'stepConfirmationLinkIdEssential', stepConfirmationLinkIdEssential)
            const localVarPath = `/step-confirmation-link/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stepConfirmationLinkIdEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepControllerCreateEntity: async (body: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('stepControllerCreateEntity', 'body', body)
            const localVarPath = `/process/step/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepControllerDeleteEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('stepControllerDeleteEntity', 'id', id)
            const localVarPath = `/process/step/delete/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepControllerGetAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/process/step`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepControllerGetById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('stepControllerGetById', 'id', id)
            const localVarPath = `/process/step/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StepIdEssential} stepIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepControllerUpdateEntity: async (stepIdEssential: StepIdEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepIdEssential' is not null or undefined
            assertParamExists('stepControllerUpdateEntity', 'stepIdEssential', stepIdEssential)
            const localVarPath = `/process/step/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stepIdEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StepDocumentEssential} stepDocumentEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepDocumentControllerCreateEntity: async (stepDocumentEssential: StepDocumentEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepDocumentEssential' is not null or undefined
            assertParamExists('stepDocumentControllerCreateEntity', 'stepDocumentEssential', stepDocumentEssential)
            const localVarPath = `/step-document/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stepDocumentEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepDocumentControllerDeleteEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('stepDocumentControllerDeleteEntity', 'id', id)
            const localVarPath = `/step-document/delete/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} documentId 
         * @param {string} extension 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepDocumentControllerDownloadDocument: async (documentId: string, extension: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('stepDocumentControllerDownloadDocument', 'documentId', documentId)
            // verify required parameter 'extension' is not null or undefined
            assertParamExists('stepDocumentControllerDownloadDocument', 'extension', extension)
            const localVarPath = `/step-document/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (documentId !== undefined) {
                localVarQueryParameter['documentId'] = documentId;
            }

            if (extension !== undefined) {
                localVarQueryParameter['extension'] = extension;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<StepDocument>} stepDocument 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepDocumentControllerDownloadDocuments: async (stepDocument: Array<StepDocument>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepDocument' is not null or undefined
            assertParamExists('stepDocumentControllerDownloadDocuments', 'stepDocument', stepDocument)
            const localVarPath = `/step-document/download/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stepDocument, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepDocumentControllerFindByDocumentId: async (documentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('stepDocumentControllerFindByDocumentId', 'documentId', documentId)
            const localVarPath = `/step-document/document/{documentId}`
                .replace('{documentId}', encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stepId 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepDocumentControllerFindByStep: async (stepId: string, instant: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('stepDocumentControllerFindByStep', 'stepId', stepId)
            // verify required parameter 'instant' is not null or undefined
            assertParamExists('stepDocumentControllerFindByStep', 'instant', instant)
            const localVarPath = `/step-document/step/{stepId}/{instant}`
                .replace('{stepId}', encodeURIComponent(String(stepId)))
                .replace('{instant}', encodeURIComponent(String(instant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepDocumentControllerGetAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/step-document`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepDocumentControllerGetAllEntities: async (instant: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instant' is not null or undefined
            assertParamExists('stepDocumentControllerGetAllEntities', 'instant', instant)
            const localVarPath = `/step-document/get/all/{instant}`
                .replace('{instant}', encodeURIComponent(String(instant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepDocumentControllerGetById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('stepDocumentControllerGetById', 'id', id)
            const localVarPath = `/step-document/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepDocumentControllerGetDistinctValues: async (columnName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'columnName' is not null or undefined
            assertParamExists('stepDocumentControllerGetDistinctValues', 'columnName', columnName)
            const localVarPath = `/step-document/distinct-values`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (columnName !== undefined) {
                localVarQueryParameter['columnName'] = columnName;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepDocumentControllerGetEdits: async (stepId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('stepDocumentControllerGetEdits', 'stepId', stepId)
            const localVarPath = `/step-document/edits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (stepId !== undefined) {
                localVarQueryParameter['stepId'] = stepId;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepDocumentControllerGetSelectableValues: async (columnName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'columnName' is not null or undefined
            assertParamExists('stepDocumentControllerGetSelectableValues', 'columnName', columnName)
            const localVarPath = `/step-document/selectable-values`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (columnName !== undefined) {
                localVarQueryParameter['columnName'] = columnName;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepDocumentControllerRemoveEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('stepDocumentControllerRemoveEntity', 'id', id)
            const localVarPath = `/step-document/remove/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepDocumentControllerRestoreEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('stepDocumentControllerRestoreEntity', 'id', id)
            const localVarPath = `/step-document/restore/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} removedBy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepDocumentControllerRestoreEntityGroup: async (removedBy: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'removedBy' is not null or undefined
            assertParamExists('stepDocumentControllerRestoreEntityGroup', 'removedBy', removedBy)
            const localVarPath = `/step-document/restore-group/{removedBy}`
                .replace('{removedBy}', encodeURIComponent(String(removedBy)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StepDocumentIdEssential} stepDocumentIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepDocumentControllerUpdateEntity: async (stepDocumentIdEssential: StepDocumentIdEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepDocumentIdEssential' is not null or undefined
            assertParamExists('stepDocumentControllerUpdateEntity', 'stepDocumentIdEssential', stepDocumentIdEssential)
            const localVarPath = `/step-document/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stepDocumentIdEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} entityId 
         * @param {File} document 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepDocumentControllerUploadDocument: async (entityId: string, document: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('stepDocumentControllerUploadDocument', 'entityId', entityId)
            // verify required parameter 'document' is not null or undefined
            assertParamExists('stepDocumentControllerUploadDocument', 'document', document)
            const localVarPath = `/step-document/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }


            if (document !== undefined) { 
                localVarFormParams.append('document', document as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} entityId 
         * @param {Array<File>} documents 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepDocumentControllerUploadDocuments: async (entityId: string, documents: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('stepDocumentControllerUploadDocuments', 'entityId', entityId)
            // verify required parameter 'documents' is not null or undefined
            assertParamExists('stepDocumentControllerUploadDocuments', 'documents', documents)
            const localVarPath = `/step-document/upload/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }

            if (documents) {
                documents.forEach((element) => {
                    localVarFormParams.append('documents', element as any);
                })
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StepLinkEssential} stepLinkEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepLinkControllerCreateEntity: async (stepLinkEssential: StepLinkEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepLinkEssential' is not null or undefined
            assertParamExists('stepLinkControllerCreateEntity', 'stepLinkEssential', stepLinkEssential)
            const localVarPath = `/process/step-link/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stepLinkEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepLinkControllerDeleteEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('stepLinkControllerDeleteEntity', 'id', id)
            const localVarPath = `/process/step-link/delete/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stepId 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepLinkControllerFindAllBySource: async (stepId: string, instant: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('stepLinkControllerFindAllBySource', 'stepId', stepId)
            // verify required parameter 'instant' is not null or undefined
            assertParamExists('stepLinkControllerFindAllBySource', 'instant', instant)
            const localVarPath = `/process/step-link/source/{stepId}`
                .replace('{stepId}', encodeURIComponent(String(stepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (instant !== undefined) {
                localVarQueryParameter['instant'] = (instant as any instanceof Date) ?
                    (instant as any).toISOString() :
                    instant;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stepId 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepLinkControllerFindAllByStep: async (stepId: string, instant: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('stepLinkControllerFindAllByStep', 'stepId', stepId)
            // verify required parameter 'instant' is not null or undefined
            assertParamExists('stepLinkControllerFindAllByStep', 'instant', instant)
            const localVarPath = `/process/step-link/all/links/{stepId}`
                .replace('{stepId}', encodeURIComponent(String(stepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (instant !== undefined) {
                localVarQueryParameter['instant'] = (instant as any instanceof Date) ?
                    (instant as any).toISOString() :
                    instant;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stepId 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepLinkControllerFindAllByTarget: async (stepId: string, instant: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('stepLinkControllerFindAllByTarget', 'stepId', stepId)
            // verify required parameter 'instant' is not null or undefined
            assertParamExists('stepLinkControllerFindAllByTarget', 'instant', instant)
            const localVarPath = `/process/step-link/target/{stepId}`
                .replace('{stepId}', encodeURIComponent(String(stepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (instant !== undefined) {
                localVarQueryParameter['instant'] = (instant as any instanceof Date) ?
                    (instant as any).toISOString() :
                    instant;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepLinkControllerGetAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/process/step-link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepLinkControllerGetAllEntities: async (instant: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instant' is not null or undefined
            assertParamExists('stepLinkControllerGetAllEntities', 'instant', instant)
            const localVarPath = `/process/step-link/get/all/{instant}`
                .replace('{instant}', encodeURIComponent(String(instant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepLinkControllerGetById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('stepLinkControllerGetById', 'id', id)
            const localVarPath = `/process/step-link/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepLinkControllerGetDistinctValues: async (columnName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'columnName' is not null or undefined
            assertParamExists('stepLinkControllerGetDistinctValues', 'columnName', columnName)
            const localVarPath = `/process/step-link/distinct-values`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (columnName !== undefined) {
                localVarQueryParameter['columnName'] = columnName;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepLinkControllerGetEdits: async (stepId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('stepLinkControllerGetEdits', 'stepId', stepId)
            const localVarPath = `/process/step-link/edits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (stepId !== undefined) {
                localVarQueryParameter['stepId'] = stepId;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepLinkControllerGetSelectableValues: async (columnName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'columnName' is not null or undefined
            assertParamExists('stepLinkControllerGetSelectableValues', 'columnName', columnName)
            const localVarPath = `/process/step-link/selectable-values`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (columnName !== undefined) {
                localVarQueryParameter['columnName'] = columnName;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepLinkControllerGetStepLinksMap: async (requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('stepLinkControllerGetStepLinksMap', 'requestBody', requestBody)
            const localVarPath = `/process/step-link/map`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} instant 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepLinkControllerGetStepLinksMapByInstant: async (instant: string, requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instant' is not null or undefined
            assertParamExists('stepLinkControllerGetStepLinksMapByInstant', 'instant', instant)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('stepLinkControllerGetStepLinksMapByInstant', 'requestBody', requestBody)
            const localVarPath = `/process/step-link/map/{instant}`
                .replace('{instant}', encodeURIComponent(String(instant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepLinkControllerRemoveEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('stepLinkControllerRemoveEntity', 'id', id)
            const localVarPath = `/process/step-link/remove/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} source 
         * @param {string} target 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepLinkControllerRemoveStepLinksBySourceAndTarget: async (source: string, target: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'source' is not null or undefined
            assertParamExists('stepLinkControllerRemoveStepLinksBySourceAndTarget', 'source', source)
            // verify required parameter 'target' is not null or undefined
            assertParamExists('stepLinkControllerRemoveStepLinksBySourceAndTarget', 'target', target)
            const localVarPath = `/process/step-link/delete/{source}/{target}`
                .replace('{source}', encodeURIComponent(String(source)))
                .replace('{target}', encodeURIComponent(String(target)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepLinkControllerRestoreEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('stepLinkControllerRestoreEntity', 'id', id)
            const localVarPath = `/process/step-link/restore/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} removedBy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepLinkControllerRestoreEntityGroup: async (removedBy: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'removedBy' is not null or undefined
            assertParamExists('stepLinkControllerRestoreEntityGroup', 'removedBy', removedBy)
            const localVarPath = `/process/step-link/restore-group/{removedBy}`
                .replace('{removedBy}', encodeURIComponent(String(removedBy)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StepLinkIdEssential} stepLinkIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepLinkControllerUpdateEntity: async (stepLinkIdEssential: StepLinkIdEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepLinkIdEssential' is not null or undefined
            assertParamExists('stepLinkControllerUpdateEntity', 'stepLinkIdEssential', stepLinkIdEssential)
            const localVarPath = `/process/step-link/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stepLinkIdEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<StepRevision>} stepRevision 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerCreateBulkEntityForce: async (stepRevision: Array<StepRevision>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepRevision' is not null or undefined
            assertParamExists('stepRevisionControllerCreateBulkEntityForce', 'stepRevision', stepRevision)
            const localVarPath = `/process/step-revision/create/bulk/force`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stepRevision, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StepRevisionEssential} stepRevisionEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerCreateEntity: async (stepRevisionEssential: StepRevisionEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepRevisionEssential' is not null or undefined
            assertParamExists('stepRevisionControllerCreateEntity', 'stepRevisionEssential', stepRevisionEssential)
            const localVarPath = `/process/step-revision/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stepRevisionEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StepRevision} stepRevision 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerCreateEntityForce: async (stepRevision: StepRevision, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepRevision' is not null or undefined
            assertParamExists('stepRevisionControllerCreateEntityForce', 'stepRevision', stepRevision)
            const localVarPath = `/process/step-revision/create/force`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stepRevision, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerDeleteEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('stepRevisionControllerDeleteEntity', 'id', id)
            const localVarPath = `/process/step-revision/delete/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FilterDTO} filterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerFindAllGivenFilter: async (filterDTO: FilterDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'filterDTO' is not null or undefined
            assertParamExists('stepRevisionControllerFindAllGivenFilter', 'filterDTO', filterDTO)
            const localVarPath = `/process/step-revision/filter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(filterDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} instant 
         * @param {FilterDTO} filterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerFindAllGivenFilterByInstant: async (instant: string, filterDTO: FilterDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instant' is not null or undefined
            assertParamExists('stepRevisionControllerFindAllGivenFilterByInstant', 'instant', instant)
            // verify required parameter 'filterDTO' is not null or undefined
            assertParamExists('stepRevisionControllerFindAllGivenFilterByInstant', 'filterDTO', filterDTO)
            const localVarPath = `/process/step-revision/filter/{instant}`
                .replace('{instant}', encodeURIComponent(String(instant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(filterDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stepId 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerFindAllSources: async (stepId: string, instant: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('stepRevisionControllerFindAllSources', 'stepId', stepId)
            // verify required parameter 'instant' is not null or undefined
            assertParamExists('stepRevisionControllerFindAllSources', 'instant', instant)
            const localVarPath = `/process/step-revision/links/sources`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (stepId !== undefined) {
                localVarQueryParameter['stepId'] = stepId;
            }

            if (instant !== undefined) {
                localVarQueryParameter['instant'] = (instant as any instanceof Date) ?
                    (instant as any).toISOString() :
                    instant;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stepId 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerFindAllTargets: async (stepId: string, instant: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('stepRevisionControllerFindAllTargets', 'stepId', stepId)
            // verify required parameter 'instant' is not null or undefined
            assertParamExists('stepRevisionControllerFindAllTargets', 'instant', instant)
            const localVarPath = `/process/step-revision/links/targets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (stepId !== undefined) {
                localVarQueryParameter['stepId'] = stepId;
            }

            if (instant !== undefined) {
                localVarQueryParameter['instant'] = (instant as any instanceof Date) ?
                    (instant as any).toISOString() :
                    instant;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DomainFilter} domainFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerFindByDomainFilter: async (domainFilter: DomainFilter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'domainFilter' is not null or undefined
            assertParamExists('stepRevisionControllerFindByDomainFilter', 'domainFilter', domainFilter)
            const localVarPath = `/process/step-revision/domain/filter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(domainFilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} instant 
         * @param {DomainFilter} domainFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerFindByDomainFilterAndInstant: async (instant: string, domainFilter: DomainFilter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instant' is not null or undefined
            assertParamExists('stepRevisionControllerFindByDomainFilterAndInstant', 'instant', instant)
            // verify required parameter 'domainFilter' is not null or undefined
            assertParamExists('stepRevisionControllerFindByDomainFilterAndInstant', 'domainFilter', domainFilter)
            const localVarPath = `/process/step-revision/domain/filter/{instant}`
                .replace('{instant}', encodeURIComponent(String(instant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(domainFilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerFindByOwnerNested: async (employeeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('stepRevisionControllerFindByOwnerNested', 'employeeId', employeeId)
            const localVarPath = `/process/step-revision/owner/nested/{employeeId}`
                .replace('{employeeId}', encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerFindByResponsibleUser: async (employeeId: string, instant: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('stepRevisionControllerFindByResponsibleUser', 'employeeId', employeeId)
            // verify required parameter 'instant' is not null or undefined
            assertParamExists('stepRevisionControllerFindByResponsibleUser', 'instant', instant)
            const localVarPath = `/process/step-revision/responsibleUser/{employeeId}/{instant}`
                .replace('{employeeId}', encodeURIComponent(String(employeeId)))
                .replace('{instant}', encodeURIComponent(String(instant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerFindByStepId: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('stepRevisionControllerFindByStepId', 'id', id)
            const localVarPath = `/process/step-revision/step/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stepName 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerFindByStepName: async (stepName: string, instant: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepName' is not null or undefined
            assertParamExists('stepRevisionControllerFindByStepName', 'stepName', stepName)
            // verify required parameter 'instant' is not null or undefined
            assertParamExists('stepRevisionControllerFindByStepName', 'instant', instant)
            const localVarPath = `/process/step-revision/distinct-find-by-step-name/{instant}`
                .replace('{instant}', encodeURIComponent(String(instant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (stepName !== undefined) {
                localVarQueryParameter['stepName'] = stepName;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<StepRevision>} stepRevision 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerFindNewValues: async (stepRevision: Array<StepRevision>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepRevision' is not null or undefined
            assertParamExists('stepRevisionControllerFindNewValues', 'stepRevision', stepRevision)
            const localVarPath = `/process/step-revision/check-new`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stepRevision, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} instant 
         * @param {string} nodeId 
         * @param {Array<string>} filterLevels 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerFindOneMatching: async (instant: string, nodeId: string, filterLevels: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instant' is not null or undefined
            assertParamExists('stepRevisionControllerFindOneMatching', 'instant', instant)
            // verify required parameter 'nodeId' is not null or undefined
            assertParamExists('stepRevisionControllerFindOneMatching', 'nodeId', nodeId)
            // verify required parameter 'filterLevels' is not null or undefined
            assertParamExists('stepRevisionControllerFindOneMatching', 'filterLevels', filterLevels)
            const localVarPath = `/process/step-revision/find-one-matching/{instant}`
                .replace('{instant}', encodeURIComponent(String(instant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (nodeId !== undefined) {
                localVarQueryParameter['nodeId'] = nodeId;
            }

            if (filterLevels) {
                localVarQueryParameter['filterLevels'] = filterLevels;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerGetAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/process/step-revision`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerGetAllEntities: async (instant: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instant' is not null or undefined
            assertParamExists('stepRevisionControllerGetAllEntities', 'instant', instant)
            const localVarPath = `/process/step-revision/get/all/{instant}`
                .replace('{instant}', encodeURIComponent(String(instant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerGetById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('stepRevisionControllerGetById', 'id', id)
            const localVarPath = `/process/step-revision/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerGetDistinctValues: async (columnName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'columnName' is not null or undefined
            assertParamExists('stepRevisionControllerGetDistinctValues', 'columnName', columnName)
            const localVarPath = `/process/step-revision/distinct-values`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (columnName !== undefined) {
                localVarQueryParameter['columnName'] = columnName;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} fieldName 
         * @param {FilterDTO} filterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerGetDistinctValuesGivenFilter: async (fieldName: string, filterDTO: FilterDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fieldName' is not null or undefined
            assertParamExists('stepRevisionControllerGetDistinctValuesGivenFilter', 'fieldName', fieldName)
            // verify required parameter 'filterDTO' is not null or undefined
            assertParamExists('stepRevisionControllerGetDistinctValuesGivenFilter', 'filterDTO', filterDTO)
            const localVarPath = `/process/step-revision/distinct-values-filtered`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (fieldName !== undefined) {
                localVarQueryParameter['fieldName'] = fieldName;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(filterDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StepRevision} stepRevision 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerGetEdits: async (stepRevision: StepRevision, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepRevision' is not null or undefined
            assertParamExists('stepRevisionControllerGetEdits', 'stepRevision', stepRevision)
            const localVarPath = `/process/step-revision/edits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stepRevision, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Set<string>} stepIds 
         * @param {string} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerGetExternalNodes: async (stepIds: Set<string>, type: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepIds' is not null or undefined
            assertParamExists('stepRevisionControllerGetExternalNodes', 'stepIds', stepIds)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('stepRevisionControllerGetExternalNodes', 'type', type)
            const localVarPath = `/process/step-revision/get-external-nodes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (stepIds) {
                localVarQueryParameter['stepIds'] = Array.from(stepIds);
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GraphNodeFilterRequest} graphNodeFilterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerGetInboundConnectionCountsByGraphNode: async (graphNodeFilterRequest: GraphNodeFilterRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'graphNodeFilterRequest' is not null or undefined
            assertParamExists('stepRevisionControllerGetInboundConnectionCountsByGraphNode', 'graphNodeFilterRequest', graphNodeFilterRequest)
            const localVarPath = `/process/step-revision/get-inbound-counts-by-graph-nodes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(graphNodeFilterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerGetJobAidLinkEdits: async (stepId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('stepRevisionControllerGetJobAidLinkEdits', 'stepId', stepId)
            const localVarPath = `/process/step-revision/{stepId}/job-aid-edits`
                .replace('{stepId}', encodeURIComponent(String(stepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GraphNodeFilterRequest} graphNodeFilterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerGetOutboundConnectionCountsByGraphNode: async (graphNodeFilterRequest: GraphNodeFilterRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'graphNodeFilterRequest' is not null or undefined
            assertParamExists('stepRevisionControllerGetOutboundConnectionCountsByGraphNode', 'graphNodeFilterRequest', graphNodeFilterRequest)
            const localVarPath = `/process/step-revision/get-outbound-counts-by-graph-nodes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(graphNodeFilterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} department 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerGetProcessesByDepartment: async (department: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'department' is not null or undefined
            assertParamExists('stepRevisionControllerGetProcessesByDepartment', 'department', department)
            const localVarPath = `/process/step-revision/get-processes-by-department`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (department !== undefined) {
                localVarQueryParameter['department'] = department;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerGetRemovedSteps: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/process/step-revision/get-removed-steps`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerGetSelectableValues: async (columnName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'columnName' is not null or undefined
            assertParamExists('stepRevisionControllerGetSelectableValues', 'columnName', columnName)
            const localVarPath = `/process/step-revision/selectable-values`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (columnName !== undefined) {
                localVarQueryParameter['columnName'] = columnName;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerGetStepCountsByDepartment: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/process/step-revision/step-counts-by-department`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GraphNodeFilterRequest} graphNodeFilterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerGetStepCountsByGraphNode: async (graphNodeFilterRequest: GraphNodeFilterRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'graphNodeFilterRequest' is not null or undefined
            assertParamExists('stepRevisionControllerGetStepCountsByGraphNode', 'graphNodeFilterRequest', graphNodeFilterRequest)
            const localVarPath = `/process/step-revision/get-step-counts-by-graph-nodes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(graphNodeFilterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerGetUpdateAuthor: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('stepRevisionControllerGetUpdateAuthor', 'id', id)
            const localVarPath = `/process/step-revision/audit/updated/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerQueryStepRevisionsRelatedToKeyControls: async (requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('stepRevisionControllerQueryStepRevisionsRelatedToKeyControls', 'requestBody', requestBody)
            const localVarPath = `/process/step-revision/query-step-revisions-related-to-key-controls`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerRemoveEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('stepRevisionControllerRemoveEntity', 'id', id)
            const localVarPath = `/process/step-revision/remove/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerRestoreEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('stepRevisionControllerRestoreEntity', 'id', id)
            const localVarPath = `/process/step-revision/restore/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} removedBy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerRestoreEntityGroup: async (removedBy: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'removedBy' is not null or undefined
            assertParamExists('stepRevisionControllerRestoreEntityGroup', 'removedBy', removedBy)
            const localVarPath = `/process/step-revision/restore-group/{removedBy}`
                .replace('{removedBy}', encodeURIComponent(String(removedBy)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StepRevisionIdEssential} stepRevisionIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerUpdateEntity: async (stepRevisionIdEssential: StepRevisionIdEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepRevisionIdEssential' is not null or undefined
            assertParamExists('stepRevisionControllerUpdateEntity', 'stepRevisionIdEssential', stepRevisionIdEssential)
            const localVarPath = `/process/step-revision/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stepRevisionIdEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StepRevision} stepRevision 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerUpdateEntityForce: async (stepRevision: StepRevision, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepRevision' is not null or undefined
            assertParamExists('stepRevisionControllerUpdateEntityForce', 'stepRevision', stepRevision)
            const localVarPath = `/process/step-revision/update/force`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stepRevision, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TaskLogEssential} taskLogEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskLogControllerCreateEntity: async (taskLogEssential: TaskLogEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskLogEssential' is not null or undefined
            assertParamExists('taskLogControllerCreateEntity', 'taskLogEssential', taskLogEssential)
            const localVarPath = `/task/task-log/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(taskLogEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskLogControllerDeleteEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('taskLogControllerDeleteEntity', 'id', id)
            const localVarPath = `/task/task-log/delete/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskLogControllerGetAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/task/task-log`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskLogControllerGetById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('taskLogControllerGetById', 'id', id)
            const localVarPath = `/task/task-log/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [rootTask] 
         * @param {string} [employeeId] 
         * @param {string} [relatedLog] 
         * @param {TaskLogActivityEnum} [activity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskLogControllerSearch: async (rootTask?: string, employeeId?: string, relatedLog?: string, activity?: TaskLogActivityEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/task/task-log/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            if (rootTask !== undefined) {
                localVarQueryParameter['rootTask'] = rootTask;
            }

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            if (relatedLog !== undefined) {
                localVarQueryParameter['relatedLog'] = relatedLog;
            }

            if (activity !== undefined) {
                localVarQueryParameter['activity'] = activity;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TaskLogIdEssential} taskLogIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskLogControllerUpdateEntity: async (taskLogIdEssential: TaskLogIdEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskLogIdEssential' is not null or undefined
            assertParamExists('taskLogControllerUpdateEntity', 'taskLogIdEssential', taskLogIdEssential)
            const localVarPath = `/task/task-log/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(taskLogIdEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UserRoleUpdateRequest} userRoleUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerAssignUserRoles: async (userRoleUpdateRequest: UserRoleUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userRoleUpdateRequest' is not null or undefined
            assertParamExists('userControllerAssignUserRoles', 'userRoleUpdateRequest', userRoleUpdateRequest)
            const localVarPath = `/preference/users/employeeId/assign-roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userRoleUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UserIdEssential} userIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerCreateEntity: async (userIdEssential: UserIdEssential, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userIdEssential' is not null or undefined
            assertParamExists('userControllerCreateEntity', 'userIdEssential', userIdEssential)
            const localVarPath = `/preference/users/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userIdEssential, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerDeleteEntity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('userControllerDeleteEntity', 'id', id)
            const localVarPath = `/preference/users/delete/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/preference/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetAllAuth0Roles: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/preference/users/auth0-roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetAuth0Users: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/preference/users/auth0-users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetByEmployeeId: async (employeeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('userControllerGetByEmployeeId', 'employeeId', employeeId)
            const localVarPath = `/preference/users/byEmployeeId/{employeeId}`
                .replace('{employeeId}', encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('userControllerGetById', 'id', id)
            const localVarPath = `/preference/users/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userAuth0Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetUserRoles: async (userAuth0Id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAuth0Id' is not null or undefined
            assertParamExists('userControllerGetUserRoles', 'userAuth0Id', userAuth0Id)
            const localVarPath = `/preference/users/employeeId/get-roles/{userAuth0Id}`
                .replace('{userAuth0Id}', encodeURIComponent(String(userAuth0Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UserRoleUpdateRequest} userRoleUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerRemoveUserRoles: async (userRoleUpdateRequest: UserRoleUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userRoleUpdateRequest' is not null or undefined
            assertParamExists('userControllerRemoveUserRoles', 'userRoleUpdateRequest', userRoleUpdateRequest)
            const localVarPath = `/preference/users/employeeId/remove-roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userRoleUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerSyncUsers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/preference/users/user-sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerUpdatePinnedItems: async (employeeId: string, requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('userControllerUpdatePinnedItems', 'employeeId', employeeId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('userControllerUpdatePinnedItems', 'requestBody', requestBody)
            const localVarPath = `/preference/users/pinned-items/update/{employeeId}`
                .replace('{employeeId}', encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Auth0ImplicitBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Auth0ImplicitBearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AdditionalOptionsEssential} additionalOptionsEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async additionalOptionsControllerCreateEntity(additionalOptionsEssential: AdditionalOptionsEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdditionalOptions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.additionalOptionsControllerCreateEntity(additionalOptionsEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.additionalOptionsControllerCreateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async additionalOptionsControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.additionalOptionsControllerDeleteEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.additionalOptionsControllerDeleteEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async additionalOptionsControllerGetAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdditionalOptions>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.additionalOptionsControllerGetAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.additionalOptionsControllerGetAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async additionalOptionsControllerGetById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdditionalOptions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.additionalOptionsControllerGetById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.additionalOptionsControllerGetById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AdditionalOptionsIdEssential} additionalOptionsIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async additionalOptionsControllerUpdateEntity(additionalOptionsIdEssential: AdditionalOptionsIdEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdditionalOptions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.additionalOptionsControllerUpdateEntity(additionalOptionsIdEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.additionalOptionsControllerUpdateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ControlAttestationEssential} controlAttestationEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlAttestationControllerCreateEntity(controlAttestationEssential: ControlAttestationEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ControlAttestation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlAttestationControllerCreateEntity(controlAttestationEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlAttestationControllerCreateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlAttestationControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlAttestationControllerDeleteEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlAttestationControllerDeleteEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlAttestationControllerGetAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ControlAttestation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlAttestationControllerGetAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlAttestationControllerGetAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlAttestationControllerGetAllEntities(instant: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ControlAttestation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlAttestationControllerGetAllEntities(instant, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlAttestationControllerGetAllEntities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlAttestationControllerGetByControlId(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ControlAttestation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlAttestationControllerGetByControlId(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlAttestationControllerGetByControlId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlAttestationControllerGetById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ControlAttestation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlAttestationControllerGetById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlAttestationControllerGetById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} processName 
         * @param {string} controlId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlAttestationControllerGetControlAttestationByRange(processName: string, controlId: string, startDate: string, endDate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ControlAttestation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlAttestationControllerGetControlAttestationByRange(processName, controlId, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlAttestationControllerGetControlAttestationByRange']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} processName 
         * @param {string} controlId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlAttestationControllerGetControlAttestationsByRange(processName: string, controlId: string, startDate: string, endDate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ControlAttestationListDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlAttestationControllerGetControlAttestationsByRange(processName, controlId, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlAttestationControllerGetControlAttestationsByRange']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlAttestationControllerGetDistinctValues(columnName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Set<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlAttestationControllerGetDistinctValues(columnName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlAttestationControllerGetDistinctValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlAttestationControllerGetSelectableValues(columnName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Set<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlAttestationControllerGetSelectableValues(columnName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlAttestationControllerGetSelectableValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlAttestationControllerRemoveEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ControlAttestation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlAttestationControllerRemoveEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlAttestationControllerRemoveEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlAttestationControllerRestoreEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ControlAttestation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlAttestationControllerRestoreEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlAttestationControllerRestoreEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} removedBy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlAttestationControllerRestoreEntityGroup(removedBy: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlAttestationControllerRestoreEntityGroup(removedBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlAttestationControllerRestoreEntityGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {string} control 
         * @param {Array<string>} stepRevisionIds 
         * @param {Status} status 
         * @param {string} [notes] 
         * @param {Array<File>} [documents] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlAttestationControllerSubmitNewAttestation(employeeId: string, control: string, stepRevisionIds: Array<string>, status: Status, notes?: string, documents?: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ControlAttestation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlAttestationControllerSubmitNewAttestation(employeeId, control, stepRevisionIds, status, notes, documents, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlAttestationControllerSubmitNewAttestation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ControlAttestationIdEssential} controlAttestationIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlAttestationControllerUpdateEntity(controlAttestationIdEssential: ControlAttestationIdEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ControlAttestation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlAttestationControllerUpdateEntity(controlAttestationIdEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlAttestationControllerUpdateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ControlAttestationDocumentEssential} controlAttestationDocumentEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlAttestationDocumentControllerCreateEntity(controlAttestationDocumentEssential: ControlAttestationDocumentEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ControlAttestationDocument>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlAttestationDocumentControllerCreateEntity(controlAttestationDocumentEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlAttestationDocumentControllerCreateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlAttestationDocumentControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlAttestationDocumentControllerDeleteEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlAttestationDocumentControllerDeleteEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} controlAttestationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlAttestationDocumentControllerDownloadAllDocuments(controlAttestationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlAttestationDocumentControllerDownloadAllDocuments(controlAttestationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlAttestationDocumentControllerDownloadAllDocuments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} documentId 
         * @param {string} extension 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlAttestationDocumentControllerDownloadDocument(documentId: string, extension: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlAttestationDocumentControllerDownloadDocument(documentId, extension, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlAttestationDocumentControllerDownloadDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<ControlAttestationDocument>} controlAttestationDocument 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlAttestationDocumentControllerDownloadDocuments(controlAttestationDocument: Array<ControlAttestationDocument>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlAttestationDocumentControllerDownloadDocuments(controlAttestationDocument, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlAttestationDocumentControllerDownloadDocuments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} controlAttestationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlAttestationDocumentControllerFindByControlAttestation(controlAttestationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ControlAttestationDocument>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlAttestationDocumentControllerFindByControlAttestation(controlAttestationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlAttestationDocumentControllerFindByControlAttestation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlAttestationDocumentControllerFindByDocumentId(documentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ControlAttestationDocument>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlAttestationDocumentControllerFindByDocumentId(documentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlAttestationDocumentControllerFindByDocumentId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlAttestationDocumentControllerGetAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ControlAttestationDocument>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlAttestationDocumentControllerGetAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlAttestationDocumentControllerGetAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlAttestationDocumentControllerGetAllEntities(instant: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ControlAttestationDocument>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlAttestationDocumentControllerGetAllEntities(instant, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlAttestationDocumentControllerGetAllEntities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlAttestationDocumentControllerGetById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ControlAttestationDocument>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlAttestationDocumentControllerGetById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlAttestationDocumentControllerGetById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlAttestationDocumentControllerGetDistinctValues(columnName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Set<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlAttestationDocumentControllerGetDistinctValues(columnName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlAttestationDocumentControllerGetDistinctValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlAttestationDocumentControllerGetSelectableValues(columnName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Set<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlAttestationDocumentControllerGetSelectableValues(columnName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlAttestationDocumentControllerGetSelectableValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlAttestationDocumentControllerRemoveEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ControlAttestationDocument>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlAttestationDocumentControllerRemoveEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlAttestationDocumentControllerRemoveEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlAttestationDocumentControllerRestoreEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ControlAttestationDocument>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlAttestationDocumentControllerRestoreEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlAttestationDocumentControllerRestoreEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} removedBy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlAttestationDocumentControllerRestoreEntityGroup(removedBy: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlAttestationDocumentControllerRestoreEntityGroup(removedBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlAttestationDocumentControllerRestoreEntityGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ControlAttestationDocumentIdEssential} controlAttestationDocumentIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlAttestationDocumentControllerUpdateEntity(controlAttestationDocumentIdEssential: ControlAttestationDocumentIdEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ControlAttestationDocument>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlAttestationDocumentControllerUpdateEntity(controlAttestationDocumentIdEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlAttestationDocumentControllerUpdateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} entityId 
         * @param {File} document 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlAttestationDocumentControllerUploadDocument(entityId: string, document: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ControlAttestationDocument>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlAttestationDocumentControllerUploadDocument(entityId, document, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlAttestationDocumentControllerUploadDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} entityId 
         * @param {Array<File>} documents 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlAttestationDocumentControllerUploadDocuments(entityId: string, documents: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ControlAttestationDocument>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlAttestationDocumentControllerUploadDocuments(entityId, documents, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlAttestationDocumentControllerUploadDocuments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ControlAttestationStepRevisionEssential} controlAttestationStepRevisionEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlAttestationStepRevisionControllerCreateEntity(controlAttestationStepRevisionEssential: ControlAttestationStepRevisionEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ControlAttestationStepRevision>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlAttestationStepRevisionControllerCreateEntity(controlAttestationStepRevisionEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlAttestationStepRevisionControllerCreateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlAttestationStepRevisionControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlAttestationStepRevisionControllerDeleteEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlAttestationStepRevisionControllerDeleteEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlAttestationStepRevisionControllerGetAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ControlAttestationStepRevision>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlAttestationStepRevisionControllerGetAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlAttestationStepRevisionControllerGetAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} controlAttestationId 
         * @param {string} stepRevisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlAttestationStepRevisionControllerGetByControlAttestationAndStepRevisionIds(controlAttestationId: string, stepRevisionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ControlAttestationStepRevision>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlAttestationStepRevisionControllerGetByControlAttestationAndStepRevisionIds(controlAttestationId, stepRevisionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlAttestationStepRevisionControllerGetByControlAttestationAndStepRevisionIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlAttestationStepRevisionControllerGetById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ControlAttestationStepRevision>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlAttestationStepRevisionControllerGetById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlAttestationStepRevisionControllerGetById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ControlAttestationStepRevisionIdEssential} controlAttestationStepRevisionIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlAttestationStepRevisionControllerUpdateEntity(controlAttestationStepRevisionIdEssential: ControlAttestationStepRevisionIdEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ControlAttestationStepRevision>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlAttestationStepRevisionControllerUpdateEntity(controlAttestationStepRevisionIdEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlAttestationStepRevisionControllerUpdateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlControllerCreateEntity(body: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Control>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlControllerCreateEntity(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlControllerCreateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlControllerDeleteEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlControllerDeleteEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlControllerGetAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Control>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlControllerGetAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlControllerGetAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlControllerGetById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Control>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlControllerGetById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlControllerGetById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ControlIdEssential} controlIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlControllerUpdateEntity(controlIdEssential: ControlIdEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Control>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlControllerUpdateEntity(controlIdEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlControllerUpdateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ControlRevisionEssential} controlRevisionEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlRevisionControllerCreateEntity(controlRevisionEssential: ControlRevisionEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ControlRevision>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlRevisionControllerCreateEntity(controlRevisionEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlRevisionControllerCreateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlRevisionControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlRevisionControllerDeleteEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlRevisionControllerDeleteEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DomainFilter} domainFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlRevisionControllerFindByDomainFilter(domainFilter: DomainFilter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ControlRevision>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlRevisionControllerFindByDomainFilter(domainFilter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlRevisionControllerFindByDomainFilter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} instant 
         * @param {DomainFilter} domainFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlRevisionControllerFindByDomainFilterAndInstant(instant: string, domainFilter: DomainFilter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ControlRevision>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlRevisionControllerFindByDomainFilterAndInstant(instant, domainFilter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlRevisionControllerFindByDomainFilterAndInstant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} controlId 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlRevisionControllerFindRevisionByControl(controlId: string, instant: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ControlRevision>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlRevisionControllerFindRevisionByControl(controlId, instant, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlRevisionControllerFindRevisionByControl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlRevisionControllerGetAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ControlRevision>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlRevisionControllerGetAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlRevisionControllerGetAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlRevisionControllerGetAllEntities(instant: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ControlRevision>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlRevisionControllerGetAllEntities(instant, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlRevisionControllerGetAllEntities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlRevisionControllerGetById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ControlRevision>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlRevisionControllerGetById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlRevisionControllerGetById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlRevisionControllerGetDistinctValues(columnName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Set<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlRevisionControllerGetDistinctValues(columnName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlRevisionControllerGetDistinctValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlRevisionControllerGetSelectableValues(columnName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Set<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlRevisionControllerGetSelectableValues(columnName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlRevisionControllerGetSelectableValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlRevisionControllerRemoveEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ControlRevision>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlRevisionControllerRemoveEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlRevisionControllerRemoveEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlRevisionControllerRestoreEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ControlRevision>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlRevisionControllerRestoreEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlRevisionControllerRestoreEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} removedBy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlRevisionControllerRestoreEntityGroup(removedBy: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlRevisionControllerRestoreEntityGroup(removedBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlRevisionControllerRestoreEntityGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ControlRevisionIdEssential} controlRevisionIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlRevisionControllerUpdateEntity(controlRevisionIdEssential: ControlRevisionIdEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ControlRevision>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlRevisionControllerUpdateEntity(controlRevisionIdEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlRevisionControllerUpdateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ControlStepEssential} controlStepEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlStepControllerCreateEntity(controlStepEssential: ControlStepEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ControlStep>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlStepControllerCreateEntity(controlStepEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlStepControllerCreateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlStepControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlStepControllerDeleteEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlStepControllerDeleteEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlStepControllerFindControlRevisionWithLinkedStep(instant: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ControlRevision>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlStepControllerFindControlRevisionWithLinkedStep(instant, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlStepControllerFindControlRevisionWithLinkedStep']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlStepControllerGetAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ControlStep>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlStepControllerGetAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlStepControllerGetAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlStepControllerGetAllEntities(instant: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ControlStep>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlStepControllerGetAllEntities(instant, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlStepControllerGetAllEntities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlStepControllerGetById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ControlStep>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlStepControllerGetById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlStepControllerGetById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} controlId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlStepControllerGetControlStepsByControl(controlId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ControlStep>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlStepControllerGetControlStepsByControl(controlId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlStepControllerGetControlStepsByControl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlStepControllerGetControlStepsByStep(stepId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ControlStep>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlStepControllerGetControlStepsByStep(stepId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlStepControllerGetControlStepsByStep']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlStepControllerGetDistinctValues(columnName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Set<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlStepControllerGetDistinctValues(columnName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlStepControllerGetDistinctValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlStepControllerGetEditsByStep(stepId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ControlStepEditsDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlStepControllerGetEditsByStep(stepId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlStepControllerGetEditsByStep']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlStepControllerGetSelectableValues(columnName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Set<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlStepControllerGetSelectableValues(columnName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlStepControllerGetSelectableValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlStepControllerRemoveEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ControlStep>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlStepControllerRemoveEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlStepControllerRemoveEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlStepControllerRestoreEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ControlStep>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlStepControllerRestoreEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlStepControllerRestoreEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} removedBy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlStepControllerRestoreEntityGroup(removedBy: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlStepControllerRestoreEntityGroup(removedBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlStepControllerRestoreEntityGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ControlStepIdEssential} controlStepIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlStepControllerUpdateEntity(controlStepIdEssential: ControlStepIdEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ControlStep>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlStepControllerUpdateEntity(controlStepIdEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.controlStepControllerUpdateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coreTasksApiApplicationPing(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coreTasksApiApplicationPing(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.coreTasksApiApplicationPing']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} to 
         * @param {string} subject 
         * @param {EmailParams} emailParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emailControllerSendEmail(to: Array<string>, subject: string, emailParams: EmailParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emailControllerSendEmail(to, subject, emailParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.emailControllerSendEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeDataControllerGetAllEmployeeData(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeData>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeDataControllerGetAllEmployeeData(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.employeeDataControllerGetAllEmployeeData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeDataControllerGetEmployeeByEmail(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeDataControllerGetEmployeeByEmail(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.employeeDataControllerGetEmployeeByEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeDataControllerGetEmployeeByEmployeeId(employeeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeDataControllerGetEmployeeByEmployeeId(employeeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.employeeDataControllerGetEmployeeByEmployeeId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeDataControllerGetEmployeeLayout(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeLayoutResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeDataControllerGetEmployeeLayout(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.employeeDataControllerGetEmployeeLayout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeDataControllerGetManagers(employeeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeDataControllerGetManagers(employeeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.employeeDataControllerGetManagers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeDataControllerGetPossibleDelegates(employeeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeData>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeDataControllerGetPossibleDelegates(employeeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.employeeDataControllerGetPossibleDelegates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} stepLinkId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeDataControllerIsOwnerOfStepLink(stepLinkId: string, employeeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeDataControllerIsOwnerOfStepLink(stepLinkId, employeeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.employeeDataControllerIsOwnerOfStepLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} instant 
         * @param {string} level 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async graphControllerGetLayoutData(instant: string, level: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.graphControllerGetLayoutData(instant, level, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.graphControllerGetLayoutData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {LayoutBodyDTO} layoutBodyDTO 
         * @param {string} [algoType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async graphControllerGetNestedLayout(layoutBodyDTO: LayoutBodyDTO, algoType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GraphNode>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.graphControllerGetNestedLayout(layoutBodyDTO, algoType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.graphControllerGetNestedLayout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} instant 
         * @param {LayoutBodyDTO} layoutBodyDTO 
         * @param {string} [algoType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async graphControllerGetNestedLayoutByInstant(instant: string, layoutBodyDTO: LayoutBodyDTO, algoType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GraphNode>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.graphControllerGetNestedLayoutByInstant(instant, layoutBodyDTO, algoType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.graphControllerGetNestedLayoutByInstant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {LayoutBodyDTO} layoutBodyDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async graphControllerGetRenderedEdges(layoutBodyDTO: LayoutBodyDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GraphEdge>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.graphControllerGetRenderedEdges(layoutBodyDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.graphControllerGetRenderedEdges']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} instant 
         * @param {LayoutBodyDTO} layoutBodyDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async graphControllerGetRenderedEdgesByInstant(instant: string, layoutBodyDTO: LayoutBodyDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GraphEdge>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.graphControllerGetRenderedEdgesByInstant(instant, layoutBodyDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.graphControllerGetRenderedEdgesByInstant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GraphStateEssential} graphStateEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async graphStateControllerCreateEntity(graphStateEssential: GraphStateEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GraphState>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.graphStateControllerCreateEntity(graphStateEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.graphStateControllerCreateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async graphStateControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.graphStateControllerDeleteEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.graphStateControllerDeleteEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async graphStateControllerGetAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GraphState>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.graphStateControllerGetAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.graphStateControllerGetAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async graphStateControllerGetById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GraphState>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.graphStateControllerGetById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.graphStateControllerGetById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} department 
         * @param {string} processName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async graphStateControllerGetGraphState(department: string, processName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GraphState>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.graphStateControllerGetGraphState(department, processName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.graphStateControllerGetGraphState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GraphStateIdEssential} graphStateIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async graphStateControllerUpdateEntity(graphStateIdEssential: GraphStateIdEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GraphState>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.graphStateControllerUpdateEntity(graphStateIdEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.graphStateControllerUpdateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GraphState} graphState 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async graphStateControllerUpsertGraphState(graphState: GraphState, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GraphState>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.graphStateControllerUpsertGraphState(graphState, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.graphStateControllerUpsertGraphState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobAidControllerGetFromUrl(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<JobAid>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobAidControllerGetFromUrl(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.jobAidControllerGetFromUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {MitigationStepEssential} mitigationStepEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mitigationStepControllerCreateEntity(mitigationStepEssential: MitigationStepEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MitigationStep>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mitigationStepControllerCreateEntity(mitigationStepEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.mitigationStepControllerCreateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mitigationStepControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mitigationStepControllerDeleteEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.mitigationStepControllerDeleteEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mitigationStepControllerGetAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MitigationStep>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mitigationStepControllerGetAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.mitigationStepControllerGetAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mitigationStepControllerGetAllEntities(instant: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MitigationStep>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mitigationStepControllerGetAllEntities(instant, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.mitigationStepControllerGetAllEntities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mitigationStepControllerGetById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MitigationStep>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mitigationStepControllerGetById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.mitigationStepControllerGetById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} riskSourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mitigationStepControllerGetByRiskSource(riskSourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MitigationStep>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mitigationStepControllerGetByRiskSource(riskSourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.mitigationStepControllerGetByRiskSource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mitigationStepControllerGetByStep(stepId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MitigationStep>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mitigationStepControllerGetByStep(stepId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.mitigationStepControllerGetByStep']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mitigationStepControllerGetDistinctValues(columnName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Set<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mitigationStepControllerGetDistinctValues(columnName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.mitigationStepControllerGetDistinctValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mitigationStepControllerGetSelectableValues(columnName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Set<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mitigationStepControllerGetSelectableValues(columnName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.mitigationStepControllerGetSelectableValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mitigationStepControllerRemoveEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MitigationStep>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mitigationStepControllerRemoveEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.mitigationStepControllerRemoveEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mitigationStepControllerRestoreEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MitigationStep>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mitigationStepControllerRestoreEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.mitigationStepControllerRestoreEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} removedBy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mitigationStepControllerRestoreEntityGroup(removedBy: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mitigationStepControllerRestoreEntityGroup(removedBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.mitigationStepControllerRestoreEntityGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {MitigationStepIdEssential} mitigationStepIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mitigationStepControllerUpdateEntity(mitigationStepIdEssential: MitigationStepIdEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MitigationStep>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mitigationStepControllerUpdateEntity(mitigationStepIdEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.mitigationStepControllerUpdateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {OwnershipEssential} ownershipEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ownershipControllerCreateEntity(ownershipEssential: OwnershipEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Ownership>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ownershipControllerCreateEntity(ownershipEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.ownershipControllerCreateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ownershipControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ownershipControllerDeleteEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.ownershipControllerDeleteEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ownershipControllerGetAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Ownership>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ownershipControllerGetAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.ownershipControllerGetAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ownershipControllerGetById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Ownership>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ownershipControllerGetById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.ownershipControllerGetById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ownershipControllerGetDelegations(employeeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Ownership>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ownershipControllerGetDelegations(employeeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.ownershipControllerGetDelegations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ownershipControllerGetOwnerships(employeeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Ownership>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ownershipControllerGetOwnerships(employeeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.ownershipControllerGetOwnerships']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {OwnershipIdEssential} ownershipIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ownershipControllerUpdateEntity(ownershipIdEssential: OwnershipIdEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Ownership>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ownershipControllerUpdateEntity(ownershipIdEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.ownershipControllerUpdateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ReviewPeriodEssential} reviewPeriodEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reviewPeriodControllerCreateEntity(reviewPeriodEssential: ReviewPeriodEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReviewPeriod>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reviewPeriodControllerCreateEntity(reviewPeriodEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.reviewPeriodControllerCreateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reviewPeriodControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reviewPeriodControllerDeleteEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.reviewPeriodControllerDeleteEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reviewPeriodControllerFindReviewPeriodForDate(date: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReviewPeriod>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reviewPeriodControllerFindReviewPeriodForDate(date, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.reviewPeriodControllerFindReviewPeriodForDate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reviewPeriodControllerGetAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReviewPeriod>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reviewPeriodControllerGetAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.reviewPeriodControllerGetAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reviewPeriodControllerGetAllAndSortByStartDate(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReviewPeriod>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reviewPeriodControllerGetAllAndSortByStartDate(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.reviewPeriodControllerGetAllAndSortByStartDate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reviewPeriodControllerGetById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReviewPeriod>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reviewPeriodControllerGetById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.reviewPeriodControllerGetById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ReviewPeriodIdEssential} reviewPeriodIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reviewPeriodControllerUpdateEntity(reviewPeriodIdEssential: ReviewPeriodIdEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReviewPeriod>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reviewPeriodControllerUpdateEntity(reviewPeriodIdEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.reviewPeriodControllerUpdateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskControllerCreateEntity(body: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Risk>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskControllerCreateEntity(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskControllerCreateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskControllerDeleteEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskControllerDeleteEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DomainFilter} domainFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskControllerEnterpriseRiskByDomainFilter(domainFilter: DomainFilter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: EnterpriseRiskDTO; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskControllerEnterpriseRiskByDomainFilter(domainFilter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskControllerEnterpriseRiskByDomainFilter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} instant 
         * @param {DomainFilter} domainFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskControllerEnterpriseRiskByDomainFilterAndInstant(instant: string, domainFilter: DomainFilter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: EnterpriseRiskDTO; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskControllerEnterpriseRiskByDomainFilterAndInstant(instant, domainFilter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskControllerEnterpriseRiskByDomainFilterAndInstant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} riskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskControllerGetAggregateRiskReportAverages(riskId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AggregateRiskReportDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskControllerGetAggregateRiskReportAverages(riskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskControllerGetAggregateRiskReportAverages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} riskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskControllerGetAggregateRiskReportMedians(riskId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AggregateRiskReportDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskControllerGetAggregateRiskReportMedians(riskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskControllerGetAggregateRiskReportMedians']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskControllerGetAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Risk>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskControllerGetAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskControllerGetAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskControllerGetById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Risk>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskControllerGetById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskControllerGetById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RiskIdEssential} riskIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskControllerUpdateEntity(riskIdEssential: RiskIdEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Risk>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskControllerUpdateEntity(riskIdEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskControllerUpdateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RiskRevisionEssential} riskRevisionEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskRevisionControllerCreateEntity(riskRevisionEssential: RiskRevisionEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RiskRevision>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskRevisionControllerCreateEntity(riskRevisionEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskRevisionControllerCreateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskRevisionControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskRevisionControllerDeleteEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskRevisionControllerDeleteEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DomainFilter} domainFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskRevisionControllerFindByDomainFilter(domainFilter: DomainFilter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RiskWithAggregateFieldsDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskRevisionControllerFindByDomainFilter(domainFilter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskRevisionControllerFindByDomainFilter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} instant 
         * @param {DomainFilter} domainFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskRevisionControllerFindByDomainFilterAndInstant(instant: string, domainFilter: DomainFilter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RiskWithAggregateFieldsDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskRevisionControllerFindByDomainFilterAndInstant(instant, domainFilter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskRevisionControllerFindByDomainFilterAndInstant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskRevisionControllerGetAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RiskRevision>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskRevisionControllerGetAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskRevisionControllerGetAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskRevisionControllerGetAllEntities(instant: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RiskRevision>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskRevisionControllerGetAllEntities(instant, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskRevisionControllerGetAllEntities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskRevisionControllerGetById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RiskRevision>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskRevisionControllerGetById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskRevisionControllerGetById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskRevisionControllerGetDistinctValues(columnName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Set<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskRevisionControllerGetDistinctValues(columnName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskRevisionControllerGetDistinctValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} instant 
         * @param {GroupedRiskFilters} groupedRiskFilters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskRevisionControllerGetRiskConnectionsData(instant: string, groupedRiskFilters: GroupedRiskFilters, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RiskConnectionsDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskRevisionControllerGetRiskConnectionsData(instant, groupedRiskFilters, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskRevisionControllerGetRiskConnectionsData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {string} [instant] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskRevisionControllerGetRiskSourceConnectionCountsBatch(requestBody: Array<string>, instant?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: RiskSourceConnectionCounts; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskRevisionControllerGetRiskSourceConnectionCountsBatch(requestBody, instant, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskRevisionControllerGetRiskSourceConnectionCountsBatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskRevisionControllerGetSelectableValues(columnName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Set<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskRevisionControllerGetSelectableValues(columnName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskRevisionControllerGetSelectableValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskRevisionControllerRemoveEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RiskRevision>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskRevisionControllerRemoveEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskRevisionControllerRemoveEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskRevisionControllerRestoreEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RiskRevision>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskRevisionControllerRestoreEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskRevisionControllerRestoreEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} removedBy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskRevisionControllerRestoreEntityGroup(removedBy: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskRevisionControllerRestoreEntityGroup(removedBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskRevisionControllerRestoreEntityGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RiskRevisionIdEssential} riskRevisionIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskRevisionControllerUpdateEntity(riskRevisionIdEssential: RiskRevisionIdEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RiskRevision>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskRevisionControllerUpdateEntity(riskRevisionIdEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskRevisionControllerUpdateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RiskSourceAggregateCreateRequest} riskSourceAggregateCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskSourceAggregateControllerCreate(riskSourceAggregateCreateRequest: RiskSourceAggregateCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RiskSourceAggregateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskSourceAggregateControllerCreate(riskSourceAggregateCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskSourceAggregateControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DomainFilter} domainFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskSourceAggregateControllerFindAggregatesByDomainFilter(domainFilter: DomainFilter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RiskSourceAggregateDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskSourceAggregateControllerFindAggregatesByDomainFilter(domainFilter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskSourceAggregateControllerFindAggregatesByDomainFilter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} instant 
         * @param {DomainFilter} domainFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskSourceAggregateControllerFindAggregatesByDomainFilterAndInstant(instant: string, domainFilter: DomainFilter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RiskSourceAggregateDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskSourceAggregateControllerFindAggregatesByDomainFilterAndInstant(instant, domainFilter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskSourceAggregateControllerFindAggregatesByDomainFilterAndInstant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} step 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskSourceAggregateControllerGetByStep(step: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CompactRiskSourceResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskSourceAggregateControllerGetByStep(step, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskSourceAggregateControllerGetByStep']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskSourceAggregateControllerGetLinkOptionsByStep(stepId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RiskSourceLinkOptionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskSourceAggregateControllerGetLinkOptionsByStep(stepId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskSourceAggregateControllerGetLinkOptionsByStep']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} riskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskSourceAggregateControllerReadByRisk(riskId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RiskSourceAggregateReadResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskSourceAggregateControllerReadByRisk(riskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskSourceAggregateControllerReadByRisk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} riskSourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskSourceAggregateControllerReadByRiskSource(riskSourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RiskSourceAggregateReadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskSourceAggregateControllerReadByRiskSource(riskSourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskSourceAggregateControllerReadByRiskSource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} riskSourceId 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskSourceAggregateControllerRemoveStepRelationship(riskSourceId: string, stepId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskSourceAggregateControllerRemoveStepRelationship(riskSourceId, stepId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskSourceAggregateControllerRemoveStepRelationship']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RiskSourceAggregateUpdateRequest} riskSourceAggregateUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskSourceAggregateControllerUpdate(riskSourceAggregateUpdateRequest: RiskSourceAggregateUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RiskSourceAggregateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskSourceAggregateControllerUpdate(riskSourceAggregateUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskSourceAggregateControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RiskSourceEssential} riskSourceEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskSourceControllerCreateEntity(riskSourceEssential: RiskSourceEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RiskSource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskSourceControllerCreateEntity(riskSourceEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskSourceControllerCreateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskSourceControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskSourceControllerDeleteEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskSourceControllerDeleteEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskSourceControllerGetAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RiskSource>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskSourceControllerGetAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskSourceControllerGetAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskSourceControllerGetById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RiskSource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskSourceControllerGetById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskSourceControllerGetById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} riskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskSourceControllerGetByRisk(riskId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RiskSource>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskSourceControllerGetByRisk(riskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskSourceControllerGetByRisk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RiskSourceIdEssential} riskSourceIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskSourceControllerUpdateEntity(riskSourceIdEssential: RiskSourceIdEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RiskSource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskSourceControllerUpdateEntity(riskSourceIdEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskSourceControllerUpdateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RiskSourceRevisionEssential} riskSourceRevisionEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskSourceRevisionControllerCreateEntity(riskSourceRevisionEssential: RiskSourceRevisionEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RiskSourceRevision>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskSourceRevisionControllerCreateEntity(riskSourceRevisionEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskSourceRevisionControllerCreateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskSourceRevisionControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskSourceRevisionControllerDeleteEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskSourceRevisionControllerDeleteEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DomainFilter} domainFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskSourceRevisionControllerFindByDomainFilter(domainFilter: DomainFilter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RiskSourceRevision>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskSourceRevisionControllerFindByDomainFilter(domainFilter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskSourceRevisionControllerFindByDomainFilter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} instant 
         * @param {DomainFilter} domainFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskSourceRevisionControllerFindByDomainFilterAndInstant(instant: string, domainFilter: DomainFilter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RiskSourceRevision>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskSourceRevisionControllerFindByDomainFilterAndInstant(instant, domainFilter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskSourceRevisionControllerFindByDomainFilterAndInstant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskSourceRevisionControllerGetAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RiskSourceRevision>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskSourceRevisionControllerGetAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskSourceRevisionControllerGetAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskSourceRevisionControllerGetAllEntities(instant: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RiskSourceRevision>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskSourceRevisionControllerGetAllEntities(instant, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskSourceRevisionControllerGetAllEntities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskSourceRevisionControllerGetById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RiskSourceRevision>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskSourceRevisionControllerGetById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskSourceRevisionControllerGetById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} riskSourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskSourceRevisionControllerGetByRiskSource(riskSourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RiskSourceRevision>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskSourceRevisionControllerGetByRiskSource(riskSourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskSourceRevisionControllerGetByRiskSource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskSourceRevisionControllerGetDistinctValues(columnName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Set<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskSourceRevisionControllerGetDistinctValues(columnName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskSourceRevisionControllerGetDistinctValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskSourceRevisionControllerGetSelectableValues(columnName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Set<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskSourceRevisionControllerGetSelectableValues(columnName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskSourceRevisionControllerGetSelectableValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskSourceRevisionControllerRemoveEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RiskSourceRevision>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskSourceRevisionControllerRemoveEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskSourceRevisionControllerRemoveEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskSourceRevisionControllerRestoreEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RiskSourceRevision>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskSourceRevisionControllerRestoreEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskSourceRevisionControllerRestoreEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} removedBy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskSourceRevisionControllerRestoreEntityGroup(removedBy: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskSourceRevisionControllerRestoreEntityGroup(removedBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskSourceRevisionControllerRestoreEntityGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RiskSourceRevisionIdEssential} riskSourceRevisionIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async riskSourceRevisionControllerUpdateEntity(riskSourceRevisionIdEssential: RiskSourceRevisionIdEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RiskSourceRevision>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.riskSourceRevisionControllerUpdateEntity(riskSourceRevisionIdEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.riskSourceRevisionControllerUpdateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {TaskActionRequest} taskActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rootTaskControllerClaimTask(id: string, taskActionRequest: TaskActionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rootTaskControllerClaimTask(id, taskActionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.rootTaskControllerClaimTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RootTaskEssential} rootTaskEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rootTaskControllerCreateEntity(rootTaskEssential: RootTaskEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RootTask>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rootTaskControllerCreateEntity(rootTaskEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.rootTaskControllerCreateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateTaskRequest} createTaskRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rootTaskControllerCreateTaskWithLogs(createTaskRequest: CreateTaskRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RootTask>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rootTaskControllerCreateTaskWithLogs(createTaskRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.rootTaskControllerCreateTaskWithLogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {TaskActionRequest} taskActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rootTaskControllerDeclineTask(id: string, taskActionRequest: TaskActionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rootTaskControllerDeclineTask(id, taskActionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.rootTaskControllerDeclineTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rootTaskControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rootTaskControllerDeleteEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.rootTaskControllerDeleteEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {TaskActionRequest} taskActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rootTaskControllerDeleteTask(id: string, taskActionRequest: TaskActionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rootTaskControllerDeleteTask(id, taskActionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.rootTaskControllerDeleteTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rootTaskControllerGetAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RootTask>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rootTaskControllerGetAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.rootTaskControllerGetAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rootTaskControllerGetById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RootTask>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rootTaskControllerGetById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.rootTaskControllerGetById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rootTaskControllerGetClaimed(employeeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RootTaskSummaryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rootTaskControllerGetClaimed(employeeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.rootTaskControllerGetClaimed']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rootTaskControllerGetDone(employeeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RootTaskSummaryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rootTaskControllerGetDone(employeeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.rootTaskControllerGetDone']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rootTaskControllerGetGenerated(employeeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RootTaskSummaryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rootTaskControllerGetGenerated(employeeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.rootTaskControllerGetGenerated']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rootTaskControllerGetNeedsReview(employeeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RootTaskSummaryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rootTaskControllerGetNeedsReview(employeeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.rootTaskControllerGetNeedsReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {MarkTaskCompleteRequest} markTaskCompleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rootTaskControllerMarkComplete(markTaskCompleteRequest: MarkTaskCompleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskLog>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rootTaskControllerMarkComplete(markTaskCompleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.rootTaskControllerMarkComplete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {TaskActionRequest} taskActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rootTaskControllerRevertTask(id: string, taskActionRequest: TaskActionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rootTaskControllerRevertTask(id, taskActionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.rootTaskControllerRevertTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [description] 
         * @param {TaskTypeEnum} [sourceType] 
         * @param {string} [sourceId] 
         * @param {TaskTypeEnum} [targetType] 
         * @param {string} [targetId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rootTaskControllerSearch(description?: string, sourceType?: TaskTypeEnum, sourceId?: string, targetType?: TaskTypeEnum, targetId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RootTask>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rootTaskControllerSearch(description, sourceType, sourceId, targetType, targetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.rootTaskControllerSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {TaskActionRequest} taskActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rootTaskControllerUnclaimTask(id: string, taskActionRequest: TaskActionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rootTaskControllerUnclaimTask(id, taskActionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.rootTaskControllerUnclaimTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RootTaskIdEssential} rootTaskIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rootTaskControllerUpdateEntity(rootTaskIdEssential: RootTaskIdEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RootTask>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rootTaskControllerUpdateEntity(rootTaskIdEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.rootTaskControllerUpdateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SignOffOwners} signOffOwners 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signOffOwnersControllerCreateOwner(signOffOwners: SignOffOwners, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignOffOwners>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signOffOwnersControllerCreateOwner(signOffOwners, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.signOffOwnersControllerCreateOwner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SignOffInsertDTO} signOffInsertDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signOffOwnersControllerDeleteAndInsert(signOffInsertDTO: SignOffInsertDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signOffOwnersControllerDeleteAndInsert(signOffInsertDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.signOffOwnersControllerDeleteAndInsert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signOffOwnersControllerDeleteOwner(employeeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signOffOwnersControllerDeleteOwner(employeeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.signOffOwnersControllerDeleteOwner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signOffOwnersControllerGetAllOwners(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SignOffOwners>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signOffOwnersControllerGetAllOwners(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.signOffOwnersControllerGetAllOwners']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signOffOwnersControllerIsSignOffOwner(employeeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signOffOwnersControllerIsSignOffOwner(employeeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.signOffOwnersControllerIsSignOffOwner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async slackSenderControllerHealthCheck(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.slackSenderControllerHealthCheck(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.slackSenderControllerHealthCheck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async slackSenderControllerTriggerReminderMessage(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.slackSenderControllerTriggerReminderMessage(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.slackSenderControllerTriggerReminderMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async slackSenderControllerTriggerReminderMessageForEmail(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.slackSenderControllerTriggerReminderMessageForEmail(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.slackSenderControllerTriggerReminderMessageForEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SourceStepEssential} sourceStepEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sourceStepControllerCreateEntity(sourceStepEssential: SourceStepEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SourceStep>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sourceStepControllerCreateEntity(sourceStepEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.sourceStepControllerCreateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sourceStepControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sourceStepControllerDeleteEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.sourceStepControllerDeleteEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sourceStepControllerGetAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SourceStep>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sourceStepControllerGetAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.sourceStepControllerGetAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sourceStepControllerGetAllEntities(instant: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SourceStep>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sourceStepControllerGetAllEntities(instant, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.sourceStepControllerGetAllEntities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sourceStepControllerGetById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SourceStep>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sourceStepControllerGetById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.sourceStepControllerGetById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} riskSourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sourceStepControllerGetByRiskSource(riskSourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SourceStep>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sourceStepControllerGetByRiskSource(riskSourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.sourceStepControllerGetByRiskSource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sourceStepControllerGetByStep(stepId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SourceStep>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sourceStepControllerGetByStep(stepId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.sourceStepControllerGetByStep']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sourceStepControllerGetDistinctValues(columnName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Set<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sourceStepControllerGetDistinctValues(columnName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.sourceStepControllerGetDistinctValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sourceStepControllerGetSelectableValues(columnName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Set<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sourceStepControllerGetSelectableValues(columnName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.sourceStepControllerGetSelectableValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sourceStepControllerRemoveEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SourceStep>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sourceStepControllerRemoveEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.sourceStepControllerRemoveEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sourceStepControllerRestoreEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SourceStep>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sourceStepControllerRestoreEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.sourceStepControllerRestoreEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} removedBy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sourceStepControllerRestoreEntityGroup(removedBy: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sourceStepControllerRestoreEntityGroup(removedBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.sourceStepControllerRestoreEntityGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SourceStepIdEssential} sourceStepIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sourceStepControllerUpdateEntity(sourceStepIdEssential: SourceStepIdEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SourceStep>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sourceStepControllerUpdateEntity(sourceStepIdEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.sourceStepControllerUpdateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {StepConfirmationEssential} stepConfirmationEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepConfirmationControllerCreateEntity(stepConfirmationEssential: StepConfirmationEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StepConfirmation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepConfirmationControllerCreateEntity(stepConfirmationEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepConfirmationControllerCreateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepConfirmationControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepConfirmationControllerDeleteEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepConfirmationControllerDeleteEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} stepId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepConfirmationControllerFindByStepInRange(stepId: string, startDate: string, endDate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StepConfirmation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepConfirmationControllerFindByStepInRange(stepId, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepConfirmationControllerFindByStepInRange']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepConfirmationControllerGetAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StepConfirmation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepConfirmationControllerGetAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepConfirmationControllerGetAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} asOfDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepConfirmationControllerGetAllUnconfirmedStepRevisions(asOfDate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StepRevision>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepConfirmationControllerGetAllUnconfirmedStepRevisions(asOfDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepConfirmationControllerGetAllUnconfirmedStepRevisions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepConfirmationControllerGetById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StepConfirmation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepConfirmationControllerGetById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepConfirmationControllerGetById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {string} asOfDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepConfirmationControllerGetUnconfirmedStepRevisionsByOwner(employeeId: string, asOfDate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StepRevision>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepConfirmationControllerGetUnconfirmedStepRevisionsByOwner(employeeId, asOfDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepConfirmationControllerGetUnconfirmedStepRevisionsByOwner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepConfirmationControllerSubmitNewConfirmation(employeeId: string, requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StepConfirmation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepConfirmationControllerSubmitNewConfirmation(employeeId, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepConfirmationControllerSubmitNewConfirmation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {StepConfirmationIdEssential} stepConfirmationIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepConfirmationControllerUpdateEntity(stepConfirmationIdEssential: StepConfirmationIdEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StepConfirmation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepConfirmationControllerUpdateEntity(stepConfirmationIdEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepConfirmationControllerUpdateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {StepConfirmationLinkEssential} stepConfirmationLinkEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepConfirmationLinkControllerCreateEntity(stepConfirmationLinkEssential: StepConfirmationLinkEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StepConfirmationLink>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepConfirmationLinkControllerCreateEntity(stepConfirmationLinkEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepConfirmationLinkControllerCreateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepConfirmationLinkControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepConfirmationLinkControllerDeleteEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepConfirmationLinkControllerDeleteEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepConfirmationLinkControllerFindAllByEmployeeIdAndDateRange(employeeId: string, startDate: string, endDate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StepConfirmationLink>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepConfirmationLinkControllerFindAllByEmployeeIdAndDateRange(employeeId, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepConfirmationLinkControllerFindAllByEmployeeIdAndDateRange']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepConfirmationLinkControllerFindByDateRange(startDate: string, endDate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StepConfirmationLinkDetailed>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepConfirmationLinkControllerFindByDateRange(startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepConfirmationLinkControllerFindByDateRange']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepConfirmationLinkControllerGetAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StepConfirmationLink>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepConfirmationLinkControllerGetAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepConfirmationLinkControllerGetAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepConfirmationLinkControllerGetById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StepConfirmationLink>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepConfirmationLinkControllerGetById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepConfirmationLinkControllerGetById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {StepConfirmationLinkIdEssential} stepConfirmationLinkIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepConfirmationLinkControllerUpdateEntity(stepConfirmationLinkIdEssential: StepConfirmationLinkIdEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StepConfirmationLink>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepConfirmationLinkControllerUpdateEntity(stepConfirmationLinkIdEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepConfirmationLinkControllerUpdateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepControllerCreateEntity(body: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Step>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepControllerCreateEntity(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepControllerCreateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepControllerDeleteEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepControllerDeleteEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepControllerGetAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Step>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepControllerGetAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepControllerGetAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepControllerGetById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Step>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepControllerGetById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepControllerGetById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {StepIdEssential} stepIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepControllerUpdateEntity(stepIdEssential: StepIdEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Step>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepControllerUpdateEntity(stepIdEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepControllerUpdateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {StepDocumentEssential} stepDocumentEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepDocumentControllerCreateEntity(stepDocumentEssential: StepDocumentEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StepDocument>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepDocumentControllerCreateEntity(stepDocumentEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepDocumentControllerCreateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepDocumentControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepDocumentControllerDeleteEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepDocumentControllerDeleteEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} documentId 
         * @param {string} extension 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepDocumentControllerDownloadDocument(documentId: string, extension: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepDocumentControllerDownloadDocument(documentId, extension, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepDocumentControllerDownloadDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<StepDocument>} stepDocument 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepDocumentControllerDownloadDocuments(stepDocument: Array<StepDocument>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepDocumentControllerDownloadDocuments(stepDocument, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepDocumentControllerDownloadDocuments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepDocumentControllerFindByDocumentId(documentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StepDocument>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepDocumentControllerFindByDocumentId(documentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepDocumentControllerFindByDocumentId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} stepId 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepDocumentControllerFindByStep(stepId: string, instant: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StepDocument>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepDocumentControllerFindByStep(stepId, instant, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepDocumentControllerFindByStep']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepDocumentControllerGetAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StepDocument>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepDocumentControllerGetAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepDocumentControllerGetAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepDocumentControllerGetAllEntities(instant: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StepDocument>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepDocumentControllerGetAllEntities(instant, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepDocumentControllerGetAllEntities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepDocumentControllerGetById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StepDocument>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepDocumentControllerGetById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepDocumentControllerGetById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepDocumentControllerGetDistinctValues(columnName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Set<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepDocumentControllerGetDistinctValues(columnName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepDocumentControllerGetDistinctValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepDocumentControllerGetEdits(stepId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StepDocumentEditDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepDocumentControllerGetEdits(stepId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepDocumentControllerGetEdits']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepDocumentControllerGetSelectableValues(columnName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Set<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepDocumentControllerGetSelectableValues(columnName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepDocumentControllerGetSelectableValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepDocumentControllerRemoveEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StepDocument>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepDocumentControllerRemoveEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepDocumentControllerRemoveEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepDocumentControllerRestoreEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StepDocument>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepDocumentControllerRestoreEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepDocumentControllerRestoreEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} removedBy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepDocumentControllerRestoreEntityGroup(removedBy: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepDocumentControllerRestoreEntityGroup(removedBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepDocumentControllerRestoreEntityGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {StepDocumentIdEssential} stepDocumentIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepDocumentControllerUpdateEntity(stepDocumentIdEssential: StepDocumentIdEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StepDocument>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepDocumentControllerUpdateEntity(stepDocumentIdEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepDocumentControllerUpdateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} entityId 
         * @param {File} document 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepDocumentControllerUploadDocument(entityId: string, document: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StepDocument>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepDocumentControllerUploadDocument(entityId, document, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepDocumentControllerUploadDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} entityId 
         * @param {Array<File>} documents 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepDocumentControllerUploadDocuments(entityId: string, documents: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StepDocument>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepDocumentControllerUploadDocuments(entityId, documents, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepDocumentControllerUploadDocuments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {StepLinkEssential} stepLinkEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepLinkControllerCreateEntity(stepLinkEssential: StepLinkEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StepLink>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepLinkControllerCreateEntity(stepLinkEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepLinkControllerCreateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepLinkControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepLinkControllerDeleteEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepLinkControllerDeleteEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} stepId 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepLinkControllerFindAllBySource(stepId: string, instant: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StepLink>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepLinkControllerFindAllBySource(stepId, instant, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepLinkControllerFindAllBySource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} stepId 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepLinkControllerFindAllByStep(stepId: string, instant: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StepLink>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepLinkControllerFindAllByStep(stepId, instant, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepLinkControllerFindAllByStep']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} stepId 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepLinkControllerFindAllByTarget(stepId: string, instant: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StepLink>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepLinkControllerFindAllByTarget(stepId, instant, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepLinkControllerFindAllByTarget']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepLinkControllerGetAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StepLink>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepLinkControllerGetAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepLinkControllerGetAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepLinkControllerGetAllEntities(instant: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StepLink>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepLinkControllerGetAllEntities(instant, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepLinkControllerGetAllEntities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepLinkControllerGetById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StepLink>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepLinkControllerGetById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepLinkControllerGetById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepLinkControllerGetDistinctValues(columnName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Set<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepLinkControllerGetDistinctValues(columnName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepLinkControllerGetDistinctValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepLinkControllerGetEdits(stepId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StepLinkEditDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepLinkControllerGetEdits(stepId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepLinkControllerGetEdits']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepLinkControllerGetSelectableValues(columnName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Set<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepLinkControllerGetSelectableValues(columnName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepLinkControllerGetSelectableValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepLinkControllerGetStepLinksMap(requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: LinkedStepsDTO; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepLinkControllerGetStepLinksMap(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepLinkControllerGetStepLinksMap']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} instant 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepLinkControllerGetStepLinksMapByInstant(instant: string, requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: LinkedStepsDTO; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepLinkControllerGetStepLinksMapByInstant(instant, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepLinkControllerGetStepLinksMapByInstant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepLinkControllerRemoveEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StepLink>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepLinkControllerRemoveEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepLinkControllerRemoveEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} source 
         * @param {string} target 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepLinkControllerRemoveStepLinksBySourceAndTarget(source: string, target: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepLinkControllerRemoveStepLinksBySourceAndTarget(source, target, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepLinkControllerRemoveStepLinksBySourceAndTarget']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepLinkControllerRestoreEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StepLink>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepLinkControllerRestoreEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepLinkControllerRestoreEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} removedBy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepLinkControllerRestoreEntityGroup(removedBy: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepLinkControllerRestoreEntityGroup(removedBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepLinkControllerRestoreEntityGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {StepLinkIdEssential} stepLinkIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepLinkControllerUpdateEntity(stepLinkIdEssential: StepLinkIdEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StepLink>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepLinkControllerUpdateEntity(stepLinkIdEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepLinkControllerUpdateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<StepRevision>} stepRevision 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepRevisionControllerCreateBulkEntityForce(stepRevision: Array<StepRevision>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkStepRevisionResultDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepRevisionControllerCreateBulkEntityForce(stepRevision, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepRevisionControllerCreateBulkEntityForce']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {StepRevisionEssential} stepRevisionEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepRevisionControllerCreateEntity(stepRevisionEssential: StepRevisionEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StepRevision>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepRevisionControllerCreateEntity(stepRevisionEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepRevisionControllerCreateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {StepRevision} stepRevision 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepRevisionControllerCreateEntityForce(stepRevision: StepRevision, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StepRevision>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepRevisionControllerCreateEntityForce(stepRevision, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepRevisionControllerCreateEntityForce']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepRevisionControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepRevisionControllerDeleteEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepRevisionControllerDeleteEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {FilterDTO} filterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepRevisionControllerFindAllGivenFilter(filterDTO: FilterDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StepRevision>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepRevisionControllerFindAllGivenFilter(filterDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepRevisionControllerFindAllGivenFilter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} instant 
         * @param {FilterDTO} filterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepRevisionControllerFindAllGivenFilterByInstant(instant: string, filterDTO: FilterDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StepRevision>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepRevisionControllerFindAllGivenFilterByInstant(instant, filterDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepRevisionControllerFindAllGivenFilterByInstant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} stepId 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepRevisionControllerFindAllSources(stepId: string, instant: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StepRevision>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepRevisionControllerFindAllSources(stepId, instant, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepRevisionControllerFindAllSources']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} stepId 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepRevisionControllerFindAllTargets(stepId: string, instant: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StepRevision>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepRevisionControllerFindAllTargets(stepId, instant, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepRevisionControllerFindAllTargets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DomainFilter} domainFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepRevisionControllerFindByDomainFilter(domainFilter: DomainFilter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StepRevision>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepRevisionControllerFindByDomainFilter(domainFilter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepRevisionControllerFindByDomainFilter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} instant 
         * @param {DomainFilter} domainFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepRevisionControllerFindByDomainFilterAndInstant(instant: string, domainFilter: DomainFilter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StepRevision>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepRevisionControllerFindByDomainFilterAndInstant(instant, domainFilter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepRevisionControllerFindByDomainFilterAndInstant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepRevisionControllerFindByOwnerNested(employeeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: { [key: string]: Array<StepRevision>; }; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepRevisionControllerFindByOwnerNested(employeeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepRevisionControllerFindByOwnerNested']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepRevisionControllerFindByResponsibleUser(employeeId: string, instant: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StepRevision>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepRevisionControllerFindByResponsibleUser(employeeId, instant, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepRevisionControllerFindByResponsibleUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepRevisionControllerFindByStepId(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StepRevision>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepRevisionControllerFindByStepId(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepRevisionControllerFindByStepId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} stepName 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepRevisionControllerFindByStepName(stepName: string, instant: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StepRevision>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepRevisionControllerFindByStepName(stepName, instant, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepRevisionControllerFindByStepName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<StepRevision>} stepRevision 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepRevisionControllerFindNewValues(stepRevision: Array<StepRevision>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FilterDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepRevisionControllerFindNewValues(stepRevision, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepRevisionControllerFindNewValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} instant 
         * @param {string} nodeId 
         * @param {Array<string>} filterLevels 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepRevisionControllerFindOneMatching(instant: string, nodeId: string, filterLevels: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StepRevision>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepRevisionControllerFindOneMatching(instant, nodeId, filterLevels, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepRevisionControllerFindOneMatching']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepRevisionControllerGetAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StepRevision>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepRevisionControllerGetAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepRevisionControllerGetAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepRevisionControllerGetAllEntities(instant: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StepRevision>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepRevisionControllerGetAllEntities(instant, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepRevisionControllerGetAllEntities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepRevisionControllerGetById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StepRevision>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepRevisionControllerGetById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepRevisionControllerGetById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepRevisionControllerGetDistinctValues(columnName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Set<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepRevisionControllerGetDistinctValues(columnName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepRevisionControllerGetDistinctValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} fieldName 
         * @param {FilterDTO} filterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepRevisionControllerGetDistinctValuesGivenFilter(fieldName: string, filterDTO: FilterDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Set<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepRevisionControllerGetDistinctValuesGivenFilter(fieldName, filterDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepRevisionControllerGetDistinctValuesGivenFilter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {StepRevision} stepRevision 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepRevisionControllerGetEdits(stepRevision: StepRevision, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StepRevisionEditDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepRevisionControllerGetEdits(stepRevision, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepRevisionControllerGetEdits']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Set<string>} stepIds 
         * @param {string} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepRevisionControllerGetExternalNodes(stepIds: Set<string>, type: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: Array<ExternalNodeDTO>; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepRevisionControllerGetExternalNodes(stepIds, type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepRevisionControllerGetExternalNodes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GraphNodeFilterRequest} graphNodeFilterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepRevisionControllerGetInboundConnectionCountsByGraphNode(graphNodeFilterRequest: GraphNodeFilterRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: number; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepRevisionControllerGetInboundConnectionCountsByGraphNode(graphNodeFilterRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepRevisionControllerGetInboundConnectionCountsByGraphNode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepRevisionControllerGetJobAidLinkEdits(stepId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<JobAidLinkEditDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepRevisionControllerGetJobAidLinkEdits(stepId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepRevisionControllerGetJobAidLinkEdits']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GraphNodeFilterRequest} graphNodeFilterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepRevisionControllerGetOutboundConnectionCountsByGraphNode(graphNodeFilterRequest: GraphNodeFilterRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: number; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepRevisionControllerGetOutboundConnectionCountsByGraphNode(graphNodeFilterRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepRevisionControllerGetOutboundConnectionCountsByGraphNode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} department 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepRevisionControllerGetProcessesByDepartment(department: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: Array<string>; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepRevisionControllerGetProcessesByDepartment(department, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepRevisionControllerGetProcessesByDepartment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepRevisionControllerGetRemovedSteps(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StepRevision>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepRevisionControllerGetRemovedSteps(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepRevisionControllerGetRemovedSteps']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepRevisionControllerGetSelectableValues(columnName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Set<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepRevisionControllerGetSelectableValues(columnName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepRevisionControllerGetSelectableValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepRevisionControllerGetStepCountsByDepartment(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: number; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepRevisionControllerGetStepCountsByDepartment(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepRevisionControllerGetStepCountsByDepartment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GraphNodeFilterRequest} graphNodeFilterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepRevisionControllerGetStepCountsByGraphNode(graphNodeFilterRequest: GraphNodeFilterRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: number; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepRevisionControllerGetStepCountsByGraphNode(graphNodeFilterRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepRevisionControllerGetStepCountsByGraphNode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepRevisionControllerGetUpdateAuthor(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepRevisionControllerGetUpdateAuthor(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepRevisionControllerGetUpdateAuthor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepRevisionControllerQueryStepRevisionsRelatedToKeyControls(requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepRevisionControllerQueryStepRevisionsRelatedToKeyControls(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepRevisionControllerQueryStepRevisionsRelatedToKeyControls']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepRevisionControllerRemoveEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StepRevision>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepRevisionControllerRemoveEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepRevisionControllerRemoveEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepRevisionControllerRestoreEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StepRevision>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepRevisionControllerRestoreEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepRevisionControllerRestoreEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} removedBy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepRevisionControllerRestoreEntityGroup(removedBy: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepRevisionControllerRestoreEntityGroup(removedBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepRevisionControllerRestoreEntityGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {StepRevisionIdEssential} stepRevisionIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepRevisionControllerUpdateEntity(stepRevisionIdEssential: StepRevisionIdEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StepRevision>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepRevisionControllerUpdateEntity(stepRevisionIdEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepRevisionControllerUpdateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {StepRevision} stepRevision 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepRevisionControllerUpdateEntityForce(stepRevision: StepRevision, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StepRevision>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepRevisionControllerUpdateEntityForce(stepRevision, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stepRevisionControllerUpdateEntityForce']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {TaskLogEssential} taskLogEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async taskLogControllerCreateEntity(taskLogEssential: TaskLogEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskLog>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.taskLogControllerCreateEntity(taskLogEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.taskLogControllerCreateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async taskLogControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.taskLogControllerDeleteEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.taskLogControllerDeleteEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async taskLogControllerGetAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TaskLog>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.taskLogControllerGetAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.taskLogControllerGetAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async taskLogControllerGetById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskLog>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.taskLogControllerGetById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.taskLogControllerGetById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [rootTask] 
         * @param {string} [employeeId] 
         * @param {string} [relatedLog] 
         * @param {TaskLogActivityEnum} [activity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async taskLogControllerSearch(rootTask?: string, employeeId?: string, relatedLog?: string, activity?: TaskLogActivityEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TaskLog>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.taskLogControllerSearch(rootTask, employeeId, relatedLog, activity, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.taskLogControllerSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {TaskLogIdEssential} taskLogIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async taskLogControllerUpdateEntity(taskLogIdEssential: TaskLogIdEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskLog>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.taskLogControllerUpdateEntity(taskLogIdEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.taskLogControllerUpdateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UserRoleUpdateRequest} userRoleUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerAssignUserRoles(userRoleUpdateRequest: UserRoleUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerAssignUserRoles(userRoleUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.userControllerAssignUserRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UserIdEssential} userIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerCreateEntity(userIdEssential: UserIdEssential, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerCreateEntity(userIdEssential, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.userControllerCreateEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerDeleteEntity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.userControllerDeleteEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerGetAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<User>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerGetAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.userControllerGetAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerGetAllAuth0Roles(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Auth0RoleDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerGetAllAuth0Roles(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.userControllerGetAllAuth0Roles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerGetAuth0Users(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Auth0UserDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerGetAuth0Users(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.userControllerGetAuth0Users']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerGetByEmployeeId(employeeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerGetByEmployeeId(employeeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.userControllerGetByEmployeeId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerGetById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerGetById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.userControllerGetById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userAuth0Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerGetUserRoles(userAuth0Id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Auth0RoleDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerGetUserRoles(userAuth0Id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.userControllerGetUserRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UserRoleUpdateRequest} userRoleUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerRemoveUserRoles(userRoleUpdateRequest: UserRoleUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerRemoveUserRoles(userRoleUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.userControllerRemoveUserRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerSyncUsers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<User>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerSyncUsers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.userControllerSyncUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerUpdatePinnedItems(employeeId: string, requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerUpdatePinnedItems(employeeId, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.userControllerUpdatePinnedItems']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * 
         * @param {AdditionalOptionsEssential} additionalOptionsEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        additionalOptionsControllerCreateEntity(additionalOptionsEssential: AdditionalOptionsEssential, options?: RawAxiosRequestConfig): AxiosPromise<AdditionalOptions> {
            return localVarFp.additionalOptionsControllerCreateEntity(additionalOptionsEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        additionalOptionsControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.additionalOptionsControllerDeleteEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        additionalOptionsControllerGetAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<AdditionalOptions>> {
            return localVarFp.additionalOptionsControllerGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        additionalOptionsControllerGetById(id: string, options?: RawAxiosRequestConfig): AxiosPromise<AdditionalOptions> {
            return localVarFp.additionalOptionsControllerGetById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdditionalOptionsIdEssential} additionalOptionsIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        additionalOptionsControllerUpdateEntity(additionalOptionsIdEssential: AdditionalOptionsIdEssential, options?: RawAxiosRequestConfig): AxiosPromise<AdditionalOptions> {
            return localVarFp.additionalOptionsControllerUpdateEntity(additionalOptionsIdEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ControlAttestationEssential} controlAttestationEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationControllerCreateEntity(controlAttestationEssential: ControlAttestationEssential, options?: RawAxiosRequestConfig): AxiosPromise<ControlAttestation> {
            return localVarFp.controlAttestationControllerCreateEntity(controlAttestationEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.controlAttestationControllerDeleteEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationControllerGetAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<ControlAttestation>> {
            return localVarFp.controlAttestationControllerGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationControllerGetAllEntities(instant: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ControlAttestation>> {
            return localVarFp.controlAttestationControllerGetAllEntities(instant, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationControllerGetByControlId(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ControlAttestation> {
            return localVarFp.controlAttestationControllerGetByControlId(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationControllerGetById(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ControlAttestation> {
            return localVarFp.controlAttestationControllerGetById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} processName 
         * @param {string} controlId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationControllerGetControlAttestationByRange(processName: string, controlId: string, startDate: string, endDate: string, options?: RawAxiosRequestConfig): AxiosPromise<ControlAttestation> {
            return localVarFp.controlAttestationControllerGetControlAttestationByRange(processName, controlId, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} processName 
         * @param {string} controlId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationControllerGetControlAttestationsByRange(processName: string, controlId: string, startDate: string, endDate: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ControlAttestationListDTO>> {
            return localVarFp.controlAttestationControllerGetControlAttestationsByRange(processName, controlId, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationControllerGetDistinctValues(columnName: string, options?: RawAxiosRequestConfig): AxiosPromise<Set<string>> {
            return localVarFp.controlAttestationControllerGetDistinctValues(columnName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationControllerGetSelectableValues(columnName: string, options?: RawAxiosRequestConfig): AxiosPromise<Set<string>> {
            return localVarFp.controlAttestationControllerGetSelectableValues(columnName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationControllerRemoveEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ControlAttestation> {
            return localVarFp.controlAttestationControllerRemoveEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationControllerRestoreEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ControlAttestation> {
            return localVarFp.controlAttestationControllerRestoreEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} removedBy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationControllerRestoreEntityGroup(removedBy: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.controlAttestationControllerRestoreEntityGroup(removedBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {string} control 
         * @param {Array<string>} stepRevisionIds 
         * @param {Status} status 
         * @param {string} [notes] 
         * @param {Array<File>} [documents] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationControllerSubmitNewAttestation(employeeId: string, control: string, stepRevisionIds: Array<string>, status: Status, notes?: string, documents?: Array<File>, options?: RawAxiosRequestConfig): AxiosPromise<ControlAttestation> {
            return localVarFp.controlAttestationControllerSubmitNewAttestation(employeeId, control, stepRevisionIds, status, notes, documents, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ControlAttestationIdEssential} controlAttestationIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationControllerUpdateEntity(controlAttestationIdEssential: ControlAttestationIdEssential, options?: RawAxiosRequestConfig): AxiosPromise<ControlAttestation> {
            return localVarFp.controlAttestationControllerUpdateEntity(controlAttestationIdEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ControlAttestationDocumentEssential} controlAttestationDocumentEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationDocumentControllerCreateEntity(controlAttestationDocumentEssential: ControlAttestationDocumentEssential, options?: RawAxiosRequestConfig): AxiosPromise<ControlAttestationDocument> {
            return localVarFp.controlAttestationDocumentControllerCreateEntity(controlAttestationDocumentEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationDocumentControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.controlAttestationDocumentControllerDeleteEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} controlAttestationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationDocumentControllerDownloadAllDocuments(controlAttestationId: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.controlAttestationDocumentControllerDownloadAllDocuments(controlAttestationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} documentId 
         * @param {string} extension 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationDocumentControllerDownloadDocument(documentId: string, extension: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.controlAttestationDocumentControllerDownloadDocument(documentId, extension, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<ControlAttestationDocument>} controlAttestationDocument 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationDocumentControllerDownloadDocuments(controlAttestationDocument: Array<ControlAttestationDocument>, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.controlAttestationDocumentControllerDownloadDocuments(controlAttestationDocument, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} controlAttestationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationDocumentControllerFindByControlAttestation(controlAttestationId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ControlAttestationDocument>> {
            return localVarFp.controlAttestationDocumentControllerFindByControlAttestation(controlAttestationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationDocumentControllerFindByDocumentId(documentId: string, options?: RawAxiosRequestConfig): AxiosPromise<ControlAttestationDocument> {
            return localVarFp.controlAttestationDocumentControllerFindByDocumentId(documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationDocumentControllerGetAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<ControlAttestationDocument>> {
            return localVarFp.controlAttestationDocumentControllerGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationDocumentControllerGetAllEntities(instant: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ControlAttestationDocument>> {
            return localVarFp.controlAttestationDocumentControllerGetAllEntities(instant, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationDocumentControllerGetById(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ControlAttestationDocument> {
            return localVarFp.controlAttestationDocumentControllerGetById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationDocumentControllerGetDistinctValues(columnName: string, options?: RawAxiosRequestConfig): AxiosPromise<Set<string>> {
            return localVarFp.controlAttestationDocumentControllerGetDistinctValues(columnName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationDocumentControllerGetSelectableValues(columnName: string, options?: RawAxiosRequestConfig): AxiosPromise<Set<string>> {
            return localVarFp.controlAttestationDocumentControllerGetSelectableValues(columnName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationDocumentControllerRemoveEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ControlAttestationDocument> {
            return localVarFp.controlAttestationDocumentControllerRemoveEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationDocumentControllerRestoreEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ControlAttestationDocument> {
            return localVarFp.controlAttestationDocumentControllerRestoreEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} removedBy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationDocumentControllerRestoreEntityGroup(removedBy: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.controlAttestationDocumentControllerRestoreEntityGroup(removedBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ControlAttestationDocumentIdEssential} controlAttestationDocumentIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationDocumentControllerUpdateEntity(controlAttestationDocumentIdEssential: ControlAttestationDocumentIdEssential, options?: RawAxiosRequestConfig): AxiosPromise<ControlAttestationDocument> {
            return localVarFp.controlAttestationDocumentControllerUpdateEntity(controlAttestationDocumentIdEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} entityId 
         * @param {File} document 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationDocumentControllerUploadDocument(entityId: string, document: File, options?: RawAxiosRequestConfig): AxiosPromise<ControlAttestationDocument> {
            return localVarFp.controlAttestationDocumentControllerUploadDocument(entityId, document, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} entityId 
         * @param {Array<File>} documents 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationDocumentControllerUploadDocuments(entityId: string, documents: Array<File>, options?: RawAxiosRequestConfig): AxiosPromise<Array<ControlAttestationDocument>> {
            return localVarFp.controlAttestationDocumentControllerUploadDocuments(entityId, documents, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ControlAttestationStepRevisionEssential} controlAttestationStepRevisionEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationStepRevisionControllerCreateEntity(controlAttestationStepRevisionEssential: ControlAttestationStepRevisionEssential, options?: RawAxiosRequestConfig): AxiosPromise<ControlAttestationStepRevision> {
            return localVarFp.controlAttestationStepRevisionControllerCreateEntity(controlAttestationStepRevisionEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationStepRevisionControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.controlAttestationStepRevisionControllerDeleteEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationStepRevisionControllerGetAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<ControlAttestationStepRevision>> {
            return localVarFp.controlAttestationStepRevisionControllerGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} controlAttestationId 
         * @param {string} stepRevisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationStepRevisionControllerGetByControlAttestationAndStepRevisionIds(controlAttestationId: string, stepRevisionId: string, options?: RawAxiosRequestConfig): AxiosPromise<ControlAttestationStepRevision> {
            return localVarFp.controlAttestationStepRevisionControllerGetByControlAttestationAndStepRevisionIds(controlAttestationId, stepRevisionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationStepRevisionControllerGetById(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ControlAttestationStepRevision> {
            return localVarFp.controlAttestationStepRevisionControllerGetById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ControlAttestationStepRevisionIdEssential} controlAttestationStepRevisionIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlAttestationStepRevisionControllerUpdateEntity(controlAttestationStepRevisionIdEssential: ControlAttestationStepRevisionIdEssential, options?: RawAxiosRequestConfig): AxiosPromise<ControlAttestationStepRevision> {
            return localVarFp.controlAttestationStepRevisionControllerUpdateEntity(controlAttestationStepRevisionIdEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlControllerCreateEntity(body: any, options?: RawAxiosRequestConfig): AxiosPromise<Control> {
            return localVarFp.controlControllerCreateEntity(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.controlControllerDeleteEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlControllerGetAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<Control>> {
            return localVarFp.controlControllerGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlControllerGetById(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Control> {
            return localVarFp.controlControllerGetById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ControlIdEssential} controlIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlControllerUpdateEntity(controlIdEssential: ControlIdEssential, options?: RawAxiosRequestConfig): AxiosPromise<Control> {
            return localVarFp.controlControllerUpdateEntity(controlIdEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ControlRevisionEssential} controlRevisionEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlRevisionControllerCreateEntity(controlRevisionEssential: ControlRevisionEssential, options?: RawAxiosRequestConfig): AxiosPromise<ControlRevision> {
            return localVarFp.controlRevisionControllerCreateEntity(controlRevisionEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlRevisionControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.controlRevisionControllerDeleteEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DomainFilter} domainFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlRevisionControllerFindByDomainFilter(domainFilter: DomainFilter, options?: RawAxiosRequestConfig): AxiosPromise<Array<ControlRevision>> {
            return localVarFp.controlRevisionControllerFindByDomainFilter(domainFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} instant 
         * @param {DomainFilter} domainFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlRevisionControllerFindByDomainFilterAndInstant(instant: string, domainFilter: DomainFilter, options?: RawAxiosRequestConfig): AxiosPromise<Array<ControlRevision>> {
            return localVarFp.controlRevisionControllerFindByDomainFilterAndInstant(instant, domainFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} controlId 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlRevisionControllerFindRevisionByControl(controlId: string, instant: string, options?: RawAxiosRequestConfig): AxiosPromise<ControlRevision> {
            return localVarFp.controlRevisionControllerFindRevisionByControl(controlId, instant, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlRevisionControllerGetAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<ControlRevision>> {
            return localVarFp.controlRevisionControllerGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlRevisionControllerGetAllEntities(instant: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ControlRevision>> {
            return localVarFp.controlRevisionControllerGetAllEntities(instant, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlRevisionControllerGetById(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ControlRevision> {
            return localVarFp.controlRevisionControllerGetById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlRevisionControllerGetDistinctValues(columnName: string, options?: RawAxiosRequestConfig): AxiosPromise<Set<string>> {
            return localVarFp.controlRevisionControllerGetDistinctValues(columnName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlRevisionControllerGetSelectableValues(columnName: string, options?: RawAxiosRequestConfig): AxiosPromise<Set<string>> {
            return localVarFp.controlRevisionControllerGetSelectableValues(columnName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlRevisionControllerRemoveEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ControlRevision> {
            return localVarFp.controlRevisionControllerRemoveEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlRevisionControllerRestoreEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ControlRevision> {
            return localVarFp.controlRevisionControllerRestoreEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} removedBy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlRevisionControllerRestoreEntityGroup(removedBy: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.controlRevisionControllerRestoreEntityGroup(removedBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ControlRevisionIdEssential} controlRevisionIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlRevisionControllerUpdateEntity(controlRevisionIdEssential: ControlRevisionIdEssential, options?: RawAxiosRequestConfig): AxiosPromise<ControlRevision> {
            return localVarFp.controlRevisionControllerUpdateEntity(controlRevisionIdEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ControlStepEssential} controlStepEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlStepControllerCreateEntity(controlStepEssential: ControlStepEssential, options?: RawAxiosRequestConfig): AxiosPromise<ControlStep> {
            return localVarFp.controlStepControllerCreateEntity(controlStepEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlStepControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.controlStepControllerDeleteEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlStepControllerFindControlRevisionWithLinkedStep(instant: string, options?: RawAxiosRequestConfig): AxiosPromise<ControlRevision> {
            return localVarFp.controlStepControllerFindControlRevisionWithLinkedStep(instant, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlStepControllerGetAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<ControlStep>> {
            return localVarFp.controlStepControllerGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlStepControllerGetAllEntities(instant: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ControlStep>> {
            return localVarFp.controlStepControllerGetAllEntities(instant, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlStepControllerGetById(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ControlStep> {
            return localVarFp.controlStepControllerGetById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} controlId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlStepControllerGetControlStepsByControl(controlId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ControlStep>> {
            return localVarFp.controlStepControllerGetControlStepsByControl(controlId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlStepControllerGetControlStepsByStep(stepId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ControlStep>> {
            return localVarFp.controlStepControllerGetControlStepsByStep(stepId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlStepControllerGetDistinctValues(columnName: string, options?: RawAxiosRequestConfig): AxiosPromise<Set<string>> {
            return localVarFp.controlStepControllerGetDistinctValues(columnName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlStepControllerGetEditsByStep(stepId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ControlStepEditsDTO>> {
            return localVarFp.controlStepControllerGetEditsByStep(stepId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlStepControllerGetSelectableValues(columnName: string, options?: RawAxiosRequestConfig): AxiosPromise<Set<string>> {
            return localVarFp.controlStepControllerGetSelectableValues(columnName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlStepControllerRemoveEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ControlStep> {
            return localVarFp.controlStepControllerRemoveEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlStepControllerRestoreEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ControlStep> {
            return localVarFp.controlStepControllerRestoreEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} removedBy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlStepControllerRestoreEntityGroup(removedBy: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.controlStepControllerRestoreEntityGroup(removedBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ControlStepIdEssential} controlStepIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlStepControllerUpdateEntity(controlStepIdEssential: ControlStepIdEssential, options?: RawAxiosRequestConfig): AxiosPromise<ControlStep> {
            return localVarFp.controlStepControllerUpdateEntity(controlStepIdEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coreTasksApiApplicationPing(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.coreTasksApiApplicationPing(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} to 
         * @param {string} subject 
         * @param {EmailParams} emailParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailControllerSendEmail(to: Array<string>, subject: string, emailParams: EmailParams, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.emailControllerSendEmail(to, subject, emailParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeDataControllerGetAllEmployeeData(options?: RawAxiosRequestConfig): AxiosPromise<Array<EmployeeData>> {
            return localVarFp.employeeDataControllerGetAllEmployeeData(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeDataControllerGetEmployeeByEmail(email: string, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeData> {
            return localVarFp.employeeDataControllerGetEmployeeByEmail(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeDataControllerGetEmployeeByEmployeeId(employeeId: string, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeData> {
            return localVarFp.employeeDataControllerGetEmployeeByEmployeeId(employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeDataControllerGetEmployeeLayout(options?: RawAxiosRequestConfig): AxiosPromise<EmployeeLayoutResult> {
            return localVarFp.employeeDataControllerGetEmployeeLayout(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeDataControllerGetManagers(employeeId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.employeeDataControllerGetManagers(employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeDataControllerGetPossibleDelegates(employeeId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<EmployeeData>> {
            return localVarFp.employeeDataControllerGetPossibleDelegates(employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} stepLinkId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeDataControllerIsOwnerOfStepLink(stepLinkId: string, employeeId: string, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.employeeDataControllerIsOwnerOfStepLink(stepLinkId, employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} instant 
         * @param {string} level 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphControllerGetLayoutData(instant: string, level: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.graphControllerGetLayoutData(instant, level, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LayoutBodyDTO} layoutBodyDTO 
         * @param {string} [algoType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphControllerGetNestedLayout(layoutBodyDTO: LayoutBodyDTO, algoType?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GraphNode>> {
            return localVarFp.graphControllerGetNestedLayout(layoutBodyDTO, algoType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} instant 
         * @param {LayoutBodyDTO} layoutBodyDTO 
         * @param {string} [algoType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphControllerGetNestedLayoutByInstant(instant: string, layoutBodyDTO: LayoutBodyDTO, algoType?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GraphNode>> {
            return localVarFp.graphControllerGetNestedLayoutByInstant(instant, layoutBodyDTO, algoType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LayoutBodyDTO} layoutBodyDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphControllerGetRenderedEdges(layoutBodyDTO: LayoutBodyDTO, options?: RawAxiosRequestConfig): AxiosPromise<Array<GraphEdge>> {
            return localVarFp.graphControllerGetRenderedEdges(layoutBodyDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} instant 
         * @param {LayoutBodyDTO} layoutBodyDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphControllerGetRenderedEdgesByInstant(instant: string, layoutBodyDTO: LayoutBodyDTO, options?: RawAxiosRequestConfig): AxiosPromise<Array<GraphEdge>> {
            return localVarFp.graphControllerGetRenderedEdgesByInstant(instant, layoutBodyDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GraphStateEssential} graphStateEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphStateControllerCreateEntity(graphStateEssential: GraphStateEssential, options?: RawAxiosRequestConfig): AxiosPromise<GraphState> {
            return localVarFp.graphStateControllerCreateEntity(graphStateEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphStateControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.graphStateControllerDeleteEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphStateControllerGetAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<GraphState>> {
            return localVarFp.graphStateControllerGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphStateControllerGetById(id: string, options?: RawAxiosRequestConfig): AxiosPromise<GraphState> {
            return localVarFp.graphStateControllerGetById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} department 
         * @param {string} processName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphStateControllerGetGraphState(department: string, processName: string, options?: RawAxiosRequestConfig): AxiosPromise<GraphState> {
            return localVarFp.graphStateControllerGetGraphState(department, processName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GraphStateIdEssential} graphStateIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphStateControllerUpdateEntity(graphStateIdEssential: GraphStateIdEssential, options?: RawAxiosRequestConfig): AxiosPromise<GraphState> {
            return localVarFp.graphStateControllerUpdateEntity(graphStateIdEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GraphState} graphState 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphStateControllerUpsertGraphState(graphState: GraphState, options?: RawAxiosRequestConfig): AxiosPromise<GraphState> {
            return localVarFp.graphStateControllerUpsertGraphState(graphState, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobAidControllerGetFromUrl(options?: RawAxiosRequestConfig): AxiosPromise<Array<JobAid>> {
            return localVarFp.jobAidControllerGetFromUrl(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MitigationStepEssential} mitigationStepEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mitigationStepControllerCreateEntity(mitigationStepEssential: MitigationStepEssential, options?: RawAxiosRequestConfig): AxiosPromise<MitigationStep> {
            return localVarFp.mitigationStepControllerCreateEntity(mitigationStepEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mitigationStepControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.mitigationStepControllerDeleteEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mitigationStepControllerGetAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<MitigationStep>> {
            return localVarFp.mitigationStepControllerGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mitigationStepControllerGetAllEntities(instant: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<MitigationStep>> {
            return localVarFp.mitigationStepControllerGetAllEntities(instant, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mitigationStepControllerGetById(id: string, options?: RawAxiosRequestConfig): AxiosPromise<MitigationStep> {
            return localVarFp.mitigationStepControllerGetById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} riskSourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mitigationStepControllerGetByRiskSource(riskSourceId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<MitigationStep>> {
            return localVarFp.mitigationStepControllerGetByRiskSource(riskSourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mitigationStepControllerGetByStep(stepId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<MitigationStep>> {
            return localVarFp.mitigationStepControllerGetByStep(stepId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mitigationStepControllerGetDistinctValues(columnName: string, options?: RawAxiosRequestConfig): AxiosPromise<Set<string>> {
            return localVarFp.mitigationStepControllerGetDistinctValues(columnName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mitigationStepControllerGetSelectableValues(columnName: string, options?: RawAxiosRequestConfig): AxiosPromise<Set<string>> {
            return localVarFp.mitigationStepControllerGetSelectableValues(columnName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mitigationStepControllerRemoveEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<MitigationStep> {
            return localVarFp.mitigationStepControllerRemoveEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mitigationStepControllerRestoreEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<MitigationStep> {
            return localVarFp.mitigationStepControllerRestoreEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} removedBy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mitigationStepControllerRestoreEntityGroup(removedBy: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.mitigationStepControllerRestoreEntityGroup(removedBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MitigationStepIdEssential} mitigationStepIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mitigationStepControllerUpdateEntity(mitigationStepIdEssential: MitigationStepIdEssential, options?: RawAxiosRequestConfig): AxiosPromise<MitigationStep> {
            return localVarFp.mitigationStepControllerUpdateEntity(mitigationStepIdEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OwnershipEssential} ownershipEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ownershipControllerCreateEntity(ownershipEssential: OwnershipEssential, options?: RawAxiosRequestConfig): AxiosPromise<Ownership> {
            return localVarFp.ownershipControllerCreateEntity(ownershipEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ownershipControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.ownershipControllerDeleteEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ownershipControllerGetAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<Ownership>> {
            return localVarFp.ownershipControllerGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ownershipControllerGetById(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Ownership> {
            return localVarFp.ownershipControllerGetById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ownershipControllerGetDelegations(employeeId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Ownership>> {
            return localVarFp.ownershipControllerGetDelegations(employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ownershipControllerGetOwnerships(employeeId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Ownership>> {
            return localVarFp.ownershipControllerGetOwnerships(employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OwnershipIdEssential} ownershipIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ownershipControllerUpdateEntity(ownershipIdEssential: OwnershipIdEssential, options?: RawAxiosRequestConfig): AxiosPromise<Ownership> {
            return localVarFp.ownershipControllerUpdateEntity(ownershipIdEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReviewPeriodEssential} reviewPeriodEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewPeriodControllerCreateEntity(reviewPeriodEssential: ReviewPeriodEssential, options?: RawAxiosRequestConfig): AxiosPromise<ReviewPeriod> {
            return localVarFp.reviewPeriodControllerCreateEntity(reviewPeriodEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewPeriodControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.reviewPeriodControllerDeleteEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewPeriodControllerFindReviewPeriodForDate(date: string, options?: RawAxiosRequestConfig): AxiosPromise<ReviewPeriod> {
            return localVarFp.reviewPeriodControllerFindReviewPeriodForDate(date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewPeriodControllerGetAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<ReviewPeriod>> {
            return localVarFp.reviewPeriodControllerGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewPeriodControllerGetAllAndSortByStartDate(options?: RawAxiosRequestConfig): AxiosPromise<Array<ReviewPeriod>> {
            return localVarFp.reviewPeriodControllerGetAllAndSortByStartDate(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewPeriodControllerGetById(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ReviewPeriod> {
            return localVarFp.reviewPeriodControllerGetById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReviewPeriodIdEssential} reviewPeriodIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewPeriodControllerUpdateEntity(reviewPeriodIdEssential: ReviewPeriodIdEssential, options?: RawAxiosRequestConfig): AxiosPromise<ReviewPeriod> {
            return localVarFp.reviewPeriodControllerUpdateEntity(reviewPeriodIdEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskControllerCreateEntity(body: any, options?: RawAxiosRequestConfig): AxiosPromise<Risk> {
            return localVarFp.riskControllerCreateEntity(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.riskControllerDeleteEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DomainFilter} domainFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskControllerEnterpriseRiskByDomainFilter(domainFilter: DomainFilter, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: EnterpriseRiskDTO; }> {
            return localVarFp.riskControllerEnterpriseRiskByDomainFilter(domainFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} instant 
         * @param {DomainFilter} domainFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskControllerEnterpriseRiskByDomainFilterAndInstant(instant: string, domainFilter: DomainFilter, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: EnterpriseRiskDTO; }> {
            return localVarFp.riskControllerEnterpriseRiskByDomainFilterAndInstant(instant, domainFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} riskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskControllerGetAggregateRiskReportAverages(riskId: string, options?: RawAxiosRequestConfig): AxiosPromise<AggregateRiskReportDTO> {
            return localVarFp.riskControllerGetAggregateRiskReportAverages(riskId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} riskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskControllerGetAggregateRiskReportMedians(riskId: string, options?: RawAxiosRequestConfig): AxiosPromise<AggregateRiskReportDTO> {
            return localVarFp.riskControllerGetAggregateRiskReportMedians(riskId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskControllerGetAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<Risk>> {
            return localVarFp.riskControllerGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskControllerGetById(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Risk> {
            return localVarFp.riskControllerGetById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RiskIdEssential} riskIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskControllerUpdateEntity(riskIdEssential: RiskIdEssential, options?: RawAxiosRequestConfig): AxiosPromise<Risk> {
            return localVarFp.riskControllerUpdateEntity(riskIdEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RiskRevisionEssential} riskRevisionEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskRevisionControllerCreateEntity(riskRevisionEssential: RiskRevisionEssential, options?: RawAxiosRequestConfig): AxiosPromise<RiskRevision> {
            return localVarFp.riskRevisionControllerCreateEntity(riskRevisionEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskRevisionControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.riskRevisionControllerDeleteEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DomainFilter} domainFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskRevisionControllerFindByDomainFilter(domainFilter: DomainFilter, options?: RawAxiosRequestConfig): AxiosPromise<Array<RiskWithAggregateFieldsDTO>> {
            return localVarFp.riskRevisionControllerFindByDomainFilter(domainFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} instant 
         * @param {DomainFilter} domainFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskRevisionControllerFindByDomainFilterAndInstant(instant: string, domainFilter: DomainFilter, options?: RawAxiosRequestConfig): AxiosPromise<Array<RiskWithAggregateFieldsDTO>> {
            return localVarFp.riskRevisionControllerFindByDomainFilterAndInstant(instant, domainFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskRevisionControllerGetAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<RiskRevision>> {
            return localVarFp.riskRevisionControllerGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskRevisionControllerGetAllEntities(instant: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RiskRevision>> {
            return localVarFp.riskRevisionControllerGetAllEntities(instant, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskRevisionControllerGetById(id: string, options?: RawAxiosRequestConfig): AxiosPromise<RiskRevision> {
            return localVarFp.riskRevisionControllerGetById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskRevisionControllerGetDistinctValues(columnName: string, options?: RawAxiosRequestConfig): AxiosPromise<Set<string>> {
            return localVarFp.riskRevisionControllerGetDistinctValues(columnName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} instant 
         * @param {GroupedRiskFilters} groupedRiskFilters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskRevisionControllerGetRiskConnectionsData(instant: string, groupedRiskFilters: GroupedRiskFilters, options?: RawAxiosRequestConfig): AxiosPromise<Array<RiskConnectionsDTO>> {
            return localVarFp.riskRevisionControllerGetRiskConnectionsData(instant, groupedRiskFilters, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {string} [instant] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskRevisionControllerGetRiskSourceConnectionCountsBatch(requestBody: Array<string>, instant?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: RiskSourceConnectionCounts; }> {
            return localVarFp.riskRevisionControllerGetRiskSourceConnectionCountsBatch(requestBody, instant, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskRevisionControllerGetSelectableValues(columnName: string, options?: RawAxiosRequestConfig): AxiosPromise<Set<string>> {
            return localVarFp.riskRevisionControllerGetSelectableValues(columnName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskRevisionControllerRemoveEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<RiskRevision> {
            return localVarFp.riskRevisionControllerRemoveEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskRevisionControllerRestoreEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<RiskRevision> {
            return localVarFp.riskRevisionControllerRestoreEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} removedBy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskRevisionControllerRestoreEntityGroup(removedBy: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.riskRevisionControllerRestoreEntityGroup(removedBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RiskRevisionIdEssential} riskRevisionIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskRevisionControllerUpdateEntity(riskRevisionIdEssential: RiskRevisionIdEssential, options?: RawAxiosRequestConfig): AxiosPromise<RiskRevision> {
            return localVarFp.riskRevisionControllerUpdateEntity(riskRevisionIdEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RiskSourceAggregateCreateRequest} riskSourceAggregateCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceAggregateControllerCreate(riskSourceAggregateCreateRequest: RiskSourceAggregateCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<RiskSourceAggregateResponse> {
            return localVarFp.riskSourceAggregateControllerCreate(riskSourceAggregateCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DomainFilter} domainFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceAggregateControllerFindAggregatesByDomainFilter(domainFilter: DomainFilter, options?: RawAxiosRequestConfig): AxiosPromise<Array<RiskSourceAggregateDTO>> {
            return localVarFp.riskSourceAggregateControllerFindAggregatesByDomainFilter(domainFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} instant 
         * @param {DomainFilter} domainFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceAggregateControllerFindAggregatesByDomainFilterAndInstant(instant: string, domainFilter: DomainFilter, options?: RawAxiosRequestConfig): AxiosPromise<Array<RiskSourceAggregateDTO>> {
            return localVarFp.riskSourceAggregateControllerFindAggregatesByDomainFilterAndInstant(instant, domainFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} step 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceAggregateControllerGetByStep(step: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<CompactRiskSourceResponse>> {
            return localVarFp.riskSourceAggregateControllerGetByStep(step, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceAggregateControllerGetLinkOptionsByStep(stepId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RiskSourceLinkOptionResponse>> {
            return localVarFp.riskSourceAggregateControllerGetLinkOptionsByStep(stepId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} riskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceAggregateControllerReadByRisk(riskId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RiskSourceAggregateReadResponse>> {
            return localVarFp.riskSourceAggregateControllerReadByRisk(riskId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} riskSourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceAggregateControllerReadByRiskSource(riskSourceId: string, options?: RawAxiosRequestConfig): AxiosPromise<RiskSourceAggregateReadResponse> {
            return localVarFp.riskSourceAggregateControllerReadByRiskSource(riskSourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} riskSourceId 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceAggregateControllerRemoveStepRelationship(riskSourceId: string, stepId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.riskSourceAggregateControllerRemoveStepRelationship(riskSourceId, stepId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RiskSourceAggregateUpdateRequest} riskSourceAggregateUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceAggregateControllerUpdate(riskSourceAggregateUpdateRequest: RiskSourceAggregateUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<RiskSourceAggregateResponse> {
            return localVarFp.riskSourceAggregateControllerUpdate(riskSourceAggregateUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RiskSourceEssential} riskSourceEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceControllerCreateEntity(riskSourceEssential: RiskSourceEssential, options?: RawAxiosRequestConfig): AxiosPromise<RiskSource> {
            return localVarFp.riskSourceControllerCreateEntity(riskSourceEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.riskSourceControllerDeleteEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceControllerGetAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<RiskSource>> {
            return localVarFp.riskSourceControllerGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceControllerGetById(id: string, options?: RawAxiosRequestConfig): AxiosPromise<RiskSource> {
            return localVarFp.riskSourceControllerGetById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} riskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceControllerGetByRisk(riskId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RiskSource>> {
            return localVarFp.riskSourceControllerGetByRisk(riskId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RiskSourceIdEssential} riskSourceIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceControllerUpdateEntity(riskSourceIdEssential: RiskSourceIdEssential, options?: RawAxiosRequestConfig): AxiosPromise<RiskSource> {
            return localVarFp.riskSourceControllerUpdateEntity(riskSourceIdEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RiskSourceRevisionEssential} riskSourceRevisionEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceRevisionControllerCreateEntity(riskSourceRevisionEssential: RiskSourceRevisionEssential, options?: RawAxiosRequestConfig): AxiosPromise<RiskSourceRevision> {
            return localVarFp.riskSourceRevisionControllerCreateEntity(riskSourceRevisionEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceRevisionControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.riskSourceRevisionControllerDeleteEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DomainFilter} domainFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceRevisionControllerFindByDomainFilter(domainFilter: DomainFilter, options?: RawAxiosRequestConfig): AxiosPromise<Array<RiskSourceRevision>> {
            return localVarFp.riskSourceRevisionControllerFindByDomainFilter(domainFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} instant 
         * @param {DomainFilter} domainFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceRevisionControllerFindByDomainFilterAndInstant(instant: string, domainFilter: DomainFilter, options?: RawAxiosRequestConfig): AxiosPromise<Array<RiskSourceRevision>> {
            return localVarFp.riskSourceRevisionControllerFindByDomainFilterAndInstant(instant, domainFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceRevisionControllerGetAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<RiskSourceRevision>> {
            return localVarFp.riskSourceRevisionControllerGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceRevisionControllerGetAllEntities(instant: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RiskSourceRevision>> {
            return localVarFp.riskSourceRevisionControllerGetAllEntities(instant, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceRevisionControllerGetById(id: string, options?: RawAxiosRequestConfig): AxiosPromise<RiskSourceRevision> {
            return localVarFp.riskSourceRevisionControllerGetById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} riskSourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceRevisionControllerGetByRiskSource(riskSourceId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RiskSourceRevision>> {
            return localVarFp.riskSourceRevisionControllerGetByRiskSource(riskSourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceRevisionControllerGetDistinctValues(columnName: string, options?: RawAxiosRequestConfig): AxiosPromise<Set<string>> {
            return localVarFp.riskSourceRevisionControllerGetDistinctValues(columnName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceRevisionControllerGetSelectableValues(columnName: string, options?: RawAxiosRequestConfig): AxiosPromise<Set<string>> {
            return localVarFp.riskSourceRevisionControllerGetSelectableValues(columnName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceRevisionControllerRemoveEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<RiskSourceRevision> {
            return localVarFp.riskSourceRevisionControllerRemoveEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceRevisionControllerRestoreEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<RiskSourceRevision> {
            return localVarFp.riskSourceRevisionControllerRestoreEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} removedBy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceRevisionControllerRestoreEntityGroup(removedBy: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.riskSourceRevisionControllerRestoreEntityGroup(removedBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RiskSourceRevisionIdEssential} riskSourceRevisionIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        riskSourceRevisionControllerUpdateEntity(riskSourceRevisionIdEssential: RiskSourceRevisionIdEssential, options?: RawAxiosRequestConfig): AxiosPromise<RiskSourceRevision> {
            return localVarFp.riskSourceRevisionControllerUpdateEntity(riskSourceRevisionIdEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {TaskActionRequest} taskActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootTaskControllerClaimTask(id: string, taskActionRequest: TaskActionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.rootTaskControllerClaimTask(id, taskActionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RootTaskEssential} rootTaskEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootTaskControllerCreateEntity(rootTaskEssential: RootTaskEssential, options?: RawAxiosRequestConfig): AxiosPromise<RootTask> {
            return localVarFp.rootTaskControllerCreateEntity(rootTaskEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateTaskRequest} createTaskRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootTaskControllerCreateTaskWithLogs(createTaskRequest: CreateTaskRequest, options?: RawAxiosRequestConfig): AxiosPromise<RootTask> {
            return localVarFp.rootTaskControllerCreateTaskWithLogs(createTaskRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {TaskActionRequest} taskActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootTaskControllerDeclineTask(id: string, taskActionRequest: TaskActionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.rootTaskControllerDeclineTask(id, taskActionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootTaskControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.rootTaskControllerDeleteEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {TaskActionRequest} taskActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootTaskControllerDeleteTask(id: string, taskActionRequest: TaskActionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.rootTaskControllerDeleteTask(id, taskActionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootTaskControllerGetAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<RootTask>> {
            return localVarFp.rootTaskControllerGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootTaskControllerGetById(id: string, options?: RawAxiosRequestConfig): AxiosPromise<RootTask> {
            return localVarFp.rootTaskControllerGetById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootTaskControllerGetClaimed(employeeId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RootTaskSummaryDto>> {
            return localVarFp.rootTaskControllerGetClaimed(employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootTaskControllerGetDone(employeeId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RootTaskSummaryDto>> {
            return localVarFp.rootTaskControllerGetDone(employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootTaskControllerGetGenerated(employeeId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RootTaskSummaryDto>> {
            return localVarFp.rootTaskControllerGetGenerated(employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootTaskControllerGetNeedsReview(employeeId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RootTaskSummaryDto>> {
            return localVarFp.rootTaskControllerGetNeedsReview(employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MarkTaskCompleteRequest} markTaskCompleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootTaskControllerMarkComplete(markTaskCompleteRequest: MarkTaskCompleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaskLog> {
            return localVarFp.rootTaskControllerMarkComplete(markTaskCompleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {TaskActionRequest} taskActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootTaskControllerRevertTask(id: string, taskActionRequest: TaskActionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.rootTaskControllerRevertTask(id, taskActionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [description] 
         * @param {TaskTypeEnum} [sourceType] 
         * @param {string} [sourceId] 
         * @param {TaskTypeEnum} [targetType] 
         * @param {string} [targetId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootTaskControllerSearch(description?: string, sourceType?: TaskTypeEnum, sourceId?: string, targetType?: TaskTypeEnum, targetId?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RootTask>> {
            return localVarFp.rootTaskControllerSearch(description, sourceType, sourceId, targetType, targetId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {TaskActionRequest} taskActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootTaskControllerUnclaimTask(id: string, taskActionRequest: TaskActionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.rootTaskControllerUnclaimTask(id, taskActionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RootTaskIdEssential} rootTaskIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootTaskControllerUpdateEntity(rootTaskIdEssential: RootTaskIdEssential, options?: RawAxiosRequestConfig): AxiosPromise<RootTask> {
            return localVarFp.rootTaskControllerUpdateEntity(rootTaskIdEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SignOffOwners} signOffOwners 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signOffOwnersControllerCreateOwner(signOffOwners: SignOffOwners, options?: RawAxiosRequestConfig): AxiosPromise<SignOffOwners> {
            return localVarFp.signOffOwnersControllerCreateOwner(signOffOwners, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SignOffInsertDTO} signOffInsertDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signOffOwnersControllerDeleteAndInsert(signOffInsertDTO: SignOffInsertDTO, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.signOffOwnersControllerDeleteAndInsert(signOffInsertDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signOffOwnersControllerDeleteOwner(employeeId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.signOffOwnersControllerDeleteOwner(employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signOffOwnersControllerGetAllOwners(options?: RawAxiosRequestConfig): AxiosPromise<Array<SignOffOwners>> {
            return localVarFp.signOffOwnersControllerGetAllOwners(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signOffOwnersControllerIsSignOffOwner(employeeId: string, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.signOffOwnersControllerIsSignOffOwner(employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        slackSenderControllerHealthCheck(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.slackSenderControllerHealthCheck(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        slackSenderControllerTriggerReminderMessage(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.slackSenderControllerTriggerReminderMessage(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        slackSenderControllerTriggerReminderMessageForEmail(email: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.slackSenderControllerTriggerReminderMessageForEmail(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SourceStepEssential} sourceStepEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sourceStepControllerCreateEntity(sourceStepEssential: SourceStepEssential, options?: RawAxiosRequestConfig): AxiosPromise<SourceStep> {
            return localVarFp.sourceStepControllerCreateEntity(sourceStepEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sourceStepControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.sourceStepControllerDeleteEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sourceStepControllerGetAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<SourceStep>> {
            return localVarFp.sourceStepControllerGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sourceStepControllerGetAllEntities(instant: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<SourceStep>> {
            return localVarFp.sourceStepControllerGetAllEntities(instant, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sourceStepControllerGetById(id: string, options?: RawAxiosRequestConfig): AxiosPromise<SourceStep> {
            return localVarFp.sourceStepControllerGetById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} riskSourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sourceStepControllerGetByRiskSource(riskSourceId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<SourceStep>> {
            return localVarFp.sourceStepControllerGetByRiskSource(riskSourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sourceStepControllerGetByStep(stepId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<SourceStep>> {
            return localVarFp.sourceStepControllerGetByStep(stepId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sourceStepControllerGetDistinctValues(columnName: string, options?: RawAxiosRequestConfig): AxiosPromise<Set<string>> {
            return localVarFp.sourceStepControllerGetDistinctValues(columnName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sourceStepControllerGetSelectableValues(columnName: string, options?: RawAxiosRequestConfig): AxiosPromise<Set<string>> {
            return localVarFp.sourceStepControllerGetSelectableValues(columnName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sourceStepControllerRemoveEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<SourceStep> {
            return localVarFp.sourceStepControllerRemoveEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sourceStepControllerRestoreEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<SourceStep> {
            return localVarFp.sourceStepControllerRestoreEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} removedBy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sourceStepControllerRestoreEntityGroup(removedBy: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sourceStepControllerRestoreEntityGroup(removedBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SourceStepIdEssential} sourceStepIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sourceStepControllerUpdateEntity(sourceStepIdEssential: SourceStepIdEssential, options?: RawAxiosRequestConfig): AxiosPromise<SourceStep> {
            return localVarFp.sourceStepControllerUpdateEntity(sourceStepIdEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StepConfirmationEssential} stepConfirmationEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepConfirmationControllerCreateEntity(stepConfirmationEssential: StepConfirmationEssential, options?: RawAxiosRequestConfig): AxiosPromise<StepConfirmation> {
            return localVarFp.stepConfirmationControllerCreateEntity(stepConfirmationEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepConfirmationControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.stepConfirmationControllerDeleteEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} stepId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepConfirmationControllerFindByStepInRange(stepId: string, startDate: string, endDate: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<StepConfirmation>> {
            return localVarFp.stepConfirmationControllerFindByStepInRange(stepId, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepConfirmationControllerGetAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<StepConfirmation>> {
            return localVarFp.stepConfirmationControllerGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} asOfDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepConfirmationControllerGetAllUnconfirmedStepRevisions(asOfDate: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<StepRevision>> {
            return localVarFp.stepConfirmationControllerGetAllUnconfirmedStepRevisions(asOfDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepConfirmationControllerGetById(id: string, options?: RawAxiosRequestConfig): AxiosPromise<StepConfirmation> {
            return localVarFp.stepConfirmationControllerGetById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {string} asOfDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepConfirmationControllerGetUnconfirmedStepRevisionsByOwner(employeeId: string, asOfDate: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<StepRevision>> {
            return localVarFp.stepConfirmationControllerGetUnconfirmedStepRevisionsByOwner(employeeId, asOfDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepConfirmationControllerSubmitNewConfirmation(employeeId: string, requestBody: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<StepConfirmation> {
            return localVarFp.stepConfirmationControllerSubmitNewConfirmation(employeeId, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StepConfirmationIdEssential} stepConfirmationIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepConfirmationControllerUpdateEntity(stepConfirmationIdEssential: StepConfirmationIdEssential, options?: RawAxiosRequestConfig): AxiosPromise<StepConfirmation> {
            return localVarFp.stepConfirmationControllerUpdateEntity(stepConfirmationIdEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StepConfirmationLinkEssential} stepConfirmationLinkEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepConfirmationLinkControllerCreateEntity(stepConfirmationLinkEssential: StepConfirmationLinkEssential, options?: RawAxiosRequestConfig): AxiosPromise<StepConfirmationLink> {
            return localVarFp.stepConfirmationLinkControllerCreateEntity(stepConfirmationLinkEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepConfirmationLinkControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.stepConfirmationLinkControllerDeleteEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepConfirmationLinkControllerFindAllByEmployeeIdAndDateRange(employeeId: string, startDate: string, endDate: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<StepConfirmationLink>> {
            return localVarFp.stepConfirmationLinkControllerFindAllByEmployeeIdAndDateRange(employeeId, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepConfirmationLinkControllerFindByDateRange(startDate: string, endDate: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<StepConfirmationLinkDetailed>> {
            return localVarFp.stepConfirmationLinkControllerFindByDateRange(startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepConfirmationLinkControllerGetAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<StepConfirmationLink>> {
            return localVarFp.stepConfirmationLinkControllerGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepConfirmationLinkControllerGetById(id: string, options?: RawAxiosRequestConfig): AxiosPromise<StepConfirmationLink> {
            return localVarFp.stepConfirmationLinkControllerGetById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StepConfirmationLinkIdEssential} stepConfirmationLinkIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepConfirmationLinkControllerUpdateEntity(stepConfirmationLinkIdEssential: StepConfirmationLinkIdEssential, options?: RawAxiosRequestConfig): AxiosPromise<StepConfirmationLink> {
            return localVarFp.stepConfirmationLinkControllerUpdateEntity(stepConfirmationLinkIdEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepControllerCreateEntity(body: any, options?: RawAxiosRequestConfig): AxiosPromise<Step> {
            return localVarFp.stepControllerCreateEntity(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.stepControllerDeleteEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepControllerGetAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<Step>> {
            return localVarFp.stepControllerGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepControllerGetById(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Step> {
            return localVarFp.stepControllerGetById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StepIdEssential} stepIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepControllerUpdateEntity(stepIdEssential: StepIdEssential, options?: RawAxiosRequestConfig): AxiosPromise<Step> {
            return localVarFp.stepControllerUpdateEntity(stepIdEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StepDocumentEssential} stepDocumentEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepDocumentControllerCreateEntity(stepDocumentEssential: StepDocumentEssential, options?: RawAxiosRequestConfig): AxiosPromise<StepDocument> {
            return localVarFp.stepDocumentControllerCreateEntity(stepDocumentEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepDocumentControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.stepDocumentControllerDeleteEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} documentId 
         * @param {string} extension 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepDocumentControllerDownloadDocument(documentId: string, extension: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.stepDocumentControllerDownloadDocument(documentId, extension, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<StepDocument>} stepDocument 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepDocumentControllerDownloadDocuments(stepDocument: Array<StepDocument>, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.stepDocumentControllerDownloadDocuments(stepDocument, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepDocumentControllerFindByDocumentId(documentId: string, options?: RawAxiosRequestConfig): AxiosPromise<StepDocument> {
            return localVarFp.stepDocumentControllerFindByDocumentId(documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} stepId 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepDocumentControllerFindByStep(stepId: string, instant: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<StepDocument>> {
            return localVarFp.stepDocumentControllerFindByStep(stepId, instant, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepDocumentControllerGetAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<StepDocument>> {
            return localVarFp.stepDocumentControllerGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepDocumentControllerGetAllEntities(instant: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<StepDocument>> {
            return localVarFp.stepDocumentControllerGetAllEntities(instant, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepDocumentControllerGetById(id: string, options?: RawAxiosRequestConfig): AxiosPromise<StepDocument> {
            return localVarFp.stepDocumentControllerGetById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepDocumentControllerGetDistinctValues(columnName: string, options?: RawAxiosRequestConfig): AxiosPromise<Set<string>> {
            return localVarFp.stepDocumentControllerGetDistinctValues(columnName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepDocumentControllerGetEdits(stepId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<StepDocumentEditDTO>> {
            return localVarFp.stepDocumentControllerGetEdits(stepId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepDocumentControllerGetSelectableValues(columnName: string, options?: RawAxiosRequestConfig): AxiosPromise<Set<string>> {
            return localVarFp.stepDocumentControllerGetSelectableValues(columnName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepDocumentControllerRemoveEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<StepDocument> {
            return localVarFp.stepDocumentControllerRemoveEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepDocumentControllerRestoreEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<StepDocument> {
            return localVarFp.stepDocumentControllerRestoreEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} removedBy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepDocumentControllerRestoreEntityGroup(removedBy: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.stepDocumentControllerRestoreEntityGroup(removedBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StepDocumentIdEssential} stepDocumentIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepDocumentControllerUpdateEntity(stepDocumentIdEssential: StepDocumentIdEssential, options?: RawAxiosRequestConfig): AxiosPromise<StepDocument> {
            return localVarFp.stepDocumentControllerUpdateEntity(stepDocumentIdEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} entityId 
         * @param {File} document 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepDocumentControllerUploadDocument(entityId: string, document: File, options?: RawAxiosRequestConfig): AxiosPromise<StepDocument> {
            return localVarFp.stepDocumentControllerUploadDocument(entityId, document, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} entityId 
         * @param {Array<File>} documents 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepDocumentControllerUploadDocuments(entityId: string, documents: Array<File>, options?: RawAxiosRequestConfig): AxiosPromise<Array<StepDocument>> {
            return localVarFp.stepDocumentControllerUploadDocuments(entityId, documents, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StepLinkEssential} stepLinkEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepLinkControllerCreateEntity(stepLinkEssential: StepLinkEssential, options?: RawAxiosRequestConfig): AxiosPromise<StepLink> {
            return localVarFp.stepLinkControllerCreateEntity(stepLinkEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepLinkControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.stepLinkControllerDeleteEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} stepId 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepLinkControllerFindAllBySource(stepId: string, instant: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<StepLink>> {
            return localVarFp.stepLinkControllerFindAllBySource(stepId, instant, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} stepId 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepLinkControllerFindAllByStep(stepId: string, instant: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<StepLink>> {
            return localVarFp.stepLinkControllerFindAllByStep(stepId, instant, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} stepId 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepLinkControllerFindAllByTarget(stepId: string, instant: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<StepLink>> {
            return localVarFp.stepLinkControllerFindAllByTarget(stepId, instant, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepLinkControllerGetAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<StepLink>> {
            return localVarFp.stepLinkControllerGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepLinkControllerGetAllEntities(instant: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<StepLink>> {
            return localVarFp.stepLinkControllerGetAllEntities(instant, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepLinkControllerGetById(id: string, options?: RawAxiosRequestConfig): AxiosPromise<StepLink> {
            return localVarFp.stepLinkControllerGetById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepLinkControllerGetDistinctValues(columnName: string, options?: RawAxiosRequestConfig): AxiosPromise<Set<string>> {
            return localVarFp.stepLinkControllerGetDistinctValues(columnName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepLinkControllerGetEdits(stepId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<StepLinkEditDTO>> {
            return localVarFp.stepLinkControllerGetEdits(stepId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepLinkControllerGetSelectableValues(columnName: string, options?: RawAxiosRequestConfig): AxiosPromise<Set<string>> {
            return localVarFp.stepLinkControllerGetSelectableValues(columnName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepLinkControllerGetStepLinksMap(requestBody: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: LinkedStepsDTO; }> {
            return localVarFp.stepLinkControllerGetStepLinksMap(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} instant 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepLinkControllerGetStepLinksMapByInstant(instant: string, requestBody: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: LinkedStepsDTO; }> {
            return localVarFp.stepLinkControllerGetStepLinksMapByInstant(instant, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepLinkControllerRemoveEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<StepLink> {
            return localVarFp.stepLinkControllerRemoveEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} source 
         * @param {string} target 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepLinkControllerRemoveStepLinksBySourceAndTarget(source: string, target: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.stepLinkControllerRemoveStepLinksBySourceAndTarget(source, target, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepLinkControllerRestoreEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<StepLink> {
            return localVarFp.stepLinkControllerRestoreEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} removedBy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepLinkControllerRestoreEntityGroup(removedBy: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.stepLinkControllerRestoreEntityGroup(removedBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StepLinkIdEssential} stepLinkIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepLinkControllerUpdateEntity(stepLinkIdEssential: StepLinkIdEssential, options?: RawAxiosRequestConfig): AxiosPromise<StepLink> {
            return localVarFp.stepLinkControllerUpdateEntity(stepLinkIdEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<StepRevision>} stepRevision 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerCreateBulkEntityForce(stepRevision: Array<StepRevision>, options?: RawAxiosRequestConfig): AxiosPromise<BulkStepRevisionResultDTO> {
            return localVarFp.stepRevisionControllerCreateBulkEntityForce(stepRevision, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StepRevisionEssential} stepRevisionEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerCreateEntity(stepRevisionEssential: StepRevisionEssential, options?: RawAxiosRequestConfig): AxiosPromise<StepRevision> {
            return localVarFp.stepRevisionControllerCreateEntity(stepRevisionEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StepRevision} stepRevision 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerCreateEntityForce(stepRevision: StepRevision, options?: RawAxiosRequestConfig): AxiosPromise<StepRevision> {
            return localVarFp.stepRevisionControllerCreateEntityForce(stepRevision, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.stepRevisionControllerDeleteEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FilterDTO} filterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerFindAllGivenFilter(filterDTO: FilterDTO, options?: RawAxiosRequestConfig): AxiosPromise<Array<StepRevision>> {
            return localVarFp.stepRevisionControllerFindAllGivenFilter(filterDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} instant 
         * @param {FilterDTO} filterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerFindAllGivenFilterByInstant(instant: string, filterDTO: FilterDTO, options?: RawAxiosRequestConfig): AxiosPromise<Array<StepRevision>> {
            return localVarFp.stepRevisionControllerFindAllGivenFilterByInstant(instant, filterDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} stepId 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerFindAllSources(stepId: string, instant: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<StepRevision>> {
            return localVarFp.stepRevisionControllerFindAllSources(stepId, instant, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} stepId 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerFindAllTargets(stepId: string, instant: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<StepRevision>> {
            return localVarFp.stepRevisionControllerFindAllTargets(stepId, instant, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DomainFilter} domainFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerFindByDomainFilter(domainFilter: DomainFilter, options?: RawAxiosRequestConfig): AxiosPromise<Array<StepRevision>> {
            return localVarFp.stepRevisionControllerFindByDomainFilter(domainFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} instant 
         * @param {DomainFilter} domainFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerFindByDomainFilterAndInstant(instant: string, domainFilter: DomainFilter, options?: RawAxiosRequestConfig): AxiosPromise<Array<StepRevision>> {
            return localVarFp.stepRevisionControllerFindByDomainFilterAndInstant(instant, domainFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerFindByOwnerNested(employeeId: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: { [key: string]: Array<StepRevision>; }; }> {
            return localVarFp.stepRevisionControllerFindByOwnerNested(employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerFindByResponsibleUser(employeeId: string, instant: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<StepRevision>> {
            return localVarFp.stepRevisionControllerFindByResponsibleUser(employeeId, instant, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerFindByStepId(id: string, options?: RawAxiosRequestConfig): AxiosPromise<StepRevision> {
            return localVarFp.stepRevisionControllerFindByStepId(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} stepName 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerFindByStepName(stepName: string, instant: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<StepRevision>> {
            return localVarFp.stepRevisionControllerFindByStepName(stepName, instant, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<StepRevision>} stepRevision 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerFindNewValues(stepRevision: Array<StepRevision>, options?: RawAxiosRequestConfig): AxiosPromise<FilterDTO> {
            return localVarFp.stepRevisionControllerFindNewValues(stepRevision, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} instant 
         * @param {string} nodeId 
         * @param {Array<string>} filterLevels 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerFindOneMatching(instant: string, nodeId: string, filterLevels: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<StepRevision> {
            return localVarFp.stepRevisionControllerFindOneMatching(instant, nodeId, filterLevels, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerGetAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<StepRevision>> {
            return localVarFp.stepRevisionControllerGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} instant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerGetAllEntities(instant: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<StepRevision>> {
            return localVarFp.stepRevisionControllerGetAllEntities(instant, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerGetById(id: string, options?: RawAxiosRequestConfig): AxiosPromise<StepRevision> {
            return localVarFp.stepRevisionControllerGetById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerGetDistinctValues(columnName: string, options?: RawAxiosRequestConfig): AxiosPromise<Set<string>> {
            return localVarFp.stepRevisionControllerGetDistinctValues(columnName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} fieldName 
         * @param {FilterDTO} filterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerGetDistinctValuesGivenFilter(fieldName: string, filterDTO: FilterDTO, options?: RawAxiosRequestConfig): AxiosPromise<Set<string>> {
            return localVarFp.stepRevisionControllerGetDistinctValuesGivenFilter(fieldName, filterDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StepRevision} stepRevision 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerGetEdits(stepRevision: StepRevision, options?: RawAxiosRequestConfig): AxiosPromise<Array<StepRevisionEditDTO>> {
            return localVarFp.stepRevisionControllerGetEdits(stepRevision, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Set<string>} stepIds 
         * @param {string} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerGetExternalNodes(stepIds: Set<string>, type: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: Array<ExternalNodeDTO>; }> {
            return localVarFp.stepRevisionControllerGetExternalNodes(stepIds, type, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GraphNodeFilterRequest} graphNodeFilterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerGetInboundConnectionCountsByGraphNode(graphNodeFilterRequest: GraphNodeFilterRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: number; }> {
            return localVarFp.stepRevisionControllerGetInboundConnectionCountsByGraphNode(graphNodeFilterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerGetJobAidLinkEdits(stepId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<JobAidLinkEditDTO>> {
            return localVarFp.stepRevisionControllerGetJobAidLinkEdits(stepId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GraphNodeFilterRequest} graphNodeFilterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerGetOutboundConnectionCountsByGraphNode(graphNodeFilterRequest: GraphNodeFilterRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: number; }> {
            return localVarFp.stepRevisionControllerGetOutboundConnectionCountsByGraphNode(graphNodeFilterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} department 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerGetProcessesByDepartment(department: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: Array<string>; }> {
            return localVarFp.stepRevisionControllerGetProcessesByDepartment(department, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerGetRemovedSteps(options?: RawAxiosRequestConfig): AxiosPromise<Array<StepRevision>> {
            return localVarFp.stepRevisionControllerGetRemovedSteps(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} columnName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerGetSelectableValues(columnName: string, options?: RawAxiosRequestConfig): AxiosPromise<Set<string>> {
            return localVarFp.stepRevisionControllerGetSelectableValues(columnName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerGetStepCountsByDepartment(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: number; }> {
            return localVarFp.stepRevisionControllerGetStepCountsByDepartment(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GraphNodeFilterRequest} graphNodeFilterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerGetStepCountsByGraphNode(graphNodeFilterRequest: GraphNodeFilterRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: number; }> {
            return localVarFp.stepRevisionControllerGetStepCountsByGraphNode(graphNodeFilterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerGetUpdateAuthor(id: string, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeData> {
            return localVarFp.stepRevisionControllerGetUpdateAuthor(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerQueryStepRevisionsRelatedToKeyControls(requestBody: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.stepRevisionControllerQueryStepRevisionsRelatedToKeyControls(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerRemoveEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<StepRevision> {
            return localVarFp.stepRevisionControllerRemoveEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerRestoreEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<StepRevision> {
            return localVarFp.stepRevisionControllerRestoreEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} removedBy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerRestoreEntityGroup(removedBy: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.stepRevisionControllerRestoreEntityGroup(removedBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StepRevisionIdEssential} stepRevisionIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerUpdateEntity(stepRevisionIdEssential: StepRevisionIdEssential, options?: RawAxiosRequestConfig): AxiosPromise<StepRevision> {
            return localVarFp.stepRevisionControllerUpdateEntity(stepRevisionIdEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StepRevision} stepRevision 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepRevisionControllerUpdateEntityForce(stepRevision: StepRevision, options?: RawAxiosRequestConfig): AxiosPromise<StepRevision> {
            return localVarFp.stepRevisionControllerUpdateEntityForce(stepRevision, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaskLogEssential} taskLogEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskLogControllerCreateEntity(taskLogEssential: TaskLogEssential, options?: RawAxiosRequestConfig): AxiosPromise<TaskLog> {
            return localVarFp.taskLogControllerCreateEntity(taskLogEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskLogControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.taskLogControllerDeleteEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskLogControllerGetAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<TaskLog>> {
            return localVarFp.taskLogControllerGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskLogControllerGetById(id: string, options?: RawAxiosRequestConfig): AxiosPromise<TaskLog> {
            return localVarFp.taskLogControllerGetById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [rootTask] 
         * @param {string} [employeeId] 
         * @param {string} [relatedLog] 
         * @param {TaskLogActivityEnum} [activity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskLogControllerSearch(rootTask?: string, employeeId?: string, relatedLog?: string, activity?: TaskLogActivityEnum, options?: RawAxiosRequestConfig): AxiosPromise<Array<TaskLog>> {
            return localVarFp.taskLogControllerSearch(rootTask, employeeId, relatedLog, activity, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaskLogIdEssential} taskLogIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskLogControllerUpdateEntity(taskLogIdEssential: TaskLogIdEssential, options?: RawAxiosRequestConfig): AxiosPromise<TaskLog> {
            return localVarFp.taskLogControllerUpdateEntity(taskLogIdEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserRoleUpdateRequest} userRoleUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerAssignUserRoles(userRoleUpdateRequest: UserRoleUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.userControllerAssignUserRoles(userRoleUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserIdEssential} userIdEssential 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerCreateEntity(userIdEssential: UserIdEssential, options?: RawAxiosRequestConfig): AxiosPromise<User> {
            return localVarFp.userControllerCreateEntity(userIdEssential, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.userControllerDeleteEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<User>> {
            return localVarFp.userControllerGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetAllAuth0Roles(options?: RawAxiosRequestConfig): AxiosPromise<Array<Auth0RoleDTO>> {
            return localVarFp.userControllerGetAllAuth0Roles(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetAuth0Users(options?: RawAxiosRequestConfig): AxiosPromise<Array<Auth0UserDTO>> {
            return localVarFp.userControllerGetAuth0Users(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetByEmployeeId(employeeId: string, options?: RawAxiosRequestConfig): AxiosPromise<User> {
            return localVarFp.userControllerGetByEmployeeId(employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetById(id: string, options?: RawAxiosRequestConfig): AxiosPromise<User> {
            return localVarFp.userControllerGetById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userAuth0Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetUserRoles(userAuth0Id: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Auth0RoleDTO>> {
            return localVarFp.userControllerGetUserRoles(userAuth0Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserRoleUpdateRequest} userRoleUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerRemoveUserRoles(userRoleUpdateRequest: UserRoleUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.userControllerRemoveUserRoles(userRoleUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerSyncUsers(options?: RawAxiosRequestConfig): AxiosPromise<Array<User>> {
            return localVarFp.userControllerSyncUsers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerUpdatePinnedItems(employeeId: string, requestBody: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<User> {
            return localVarFp.userControllerUpdatePinnedItems(employeeId, requestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @param {AdditionalOptionsEssential} additionalOptionsEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public additionalOptionsControllerCreateEntity(additionalOptionsEssential: AdditionalOptionsEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).additionalOptionsControllerCreateEntity(additionalOptionsEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public additionalOptionsControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).additionalOptionsControllerDeleteEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public additionalOptionsControllerGetAll(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).additionalOptionsControllerGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public additionalOptionsControllerGetById(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).additionalOptionsControllerGetById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdditionalOptionsIdEssential} additionalOptionsIdEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public additionalOptionsControllerUpdateEntity(additionalOptionsIdEssential: AdditionalOptionsIdEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).additionalOptionsControllerUpdateEntity(additionalOptionsIdEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ControlAttestationEssential} controlAttestationEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlAttestationControllerCreateEntity(controlAttestationEssential: ControlAttestationEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlAttestationControllerCreateEntity(controlAttestationEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlAttestationControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlAttestationControllerDeleteEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlAttestationControllerGetAll(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlAttestationControllerGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} instant 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlAttestationControllerGetAllEntities(instant: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlAttestationControllerGetAllEntities(instant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlAttestationControllerGetByControlId(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlAttestationControllerGetByControlId(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlAttestationControllerGetById(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlAttestationControllerGetById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} processName 
     * @param {string} controlId 
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlAttestationControllerGetControlAttestationByRange(processName: string, controlId: string, startDate: string, endDate: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlAttestationControllerGetControlAttestationByRange(processName, controlId, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} processName 
     * @param {string} controlId 
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlAttestationControllerGetControlAttestationsByRange(processName: string, controlId: string, startDate: string, endDate: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlAttestationControllerGetControlAttestationsByRange(processName, controlId, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} columnName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlAttestationControllerGetDistinctValues(columnName: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlAttestationControllerGetDistinctValues(columnName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} columnName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlAttestationControllerGetSelectableValues(columnName: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlAttestationControllerGetSelectableValues(columnName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlAttestationControllerRemoveEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlAttestationControllerRemoveEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlAttestationControllerRestoreEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlAttestationControllerRestoreEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} removedBy 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlAttestationControllerRestoreEntityGroup(removedBy: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlAttestationControllerRestoreEntityGroup(removedBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} employeeId 
     * @param {string} control 
     * @param {Array<string>} stepRevisionIds 
     * @param {Status} status 
     * @param {string} [notes] 
     * @param {Array<File>} [documents] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlAttestationControllerSubmitNewAttestation(employeeId: string, control: string, stepRevisionIds: Array<string>, status: Status, notes?: string, documents?: Array<File>, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlAttestationControllerSubmitNewAttestation(employeeId, control, stepRevisionIds, status, notes, documents, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ControlAttestationIdEssential} controlAttestationIdEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlAttestationControllerUpdateEntity(controlAttestationIdEssential: ControlAttestationIdEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlAttestationControllerUpdateEntity(controlAttestationIdEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ControlAttestationDocumentEssential} controlAttestationDocumentEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlAttestationDocumentControllerCreateEntity(controlAttestationDocumentEssential: ControlAttestationDocumentEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlAttestationDocumentControllerCreateEntity(controlAttestationDocumentEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlAttestationDocumentControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlAttestationDocumentControllerDeleteEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} controlAttestationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlAttestationDocumentControllerDownloadAllDocuments(controlAttestationId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlAttestationDocumentControllerDownloadAllDocuments(controlAttestationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} documentId 
     * @param {string} extension 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlAttestationDocumentControllerDownloadDocument(documentId: string, extension: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlAttestationDocumentControllerDownloadDocument(documentId, extension, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<ControlAttestationDocument>} controlAttestationDocument 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlAttestationDocumentControllerDownloadDocuments(controlAttestationDocument: Array<ControlAttestationDocument>, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlAttestationDocumentControllerDownloadDocuments(controlAttestationDocument, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} controlAttestationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlAttestationDocumentControllerFindByControlAttestation(controlAttestationId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlAttestationDocumentControllerFindByControlAttestation(controlAttestationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlAttestationDocumentControllerFindByDocumentId(documentId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlAttestationDocumentControllerFindByDocumentId(documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlAttestationDocumentControllerGetAll(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlAttestationDocumentControllerGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} instant 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlAttestationDocumentControllerGetAllEntities(instant: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlAttestationDocumentControllerGetAllEntities(instant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlAttestationDocumentControllerGetById(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlAttestationDocumentControllerGetById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} columnName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlAttestationDocumentControllerGetDistinctValues(columnName: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlAttestationDocumentControllerGetDistinctValues(columnName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} columnName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlAttestationDocumentControllerGetSelectableValues(columnName: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlAttestationDocumentControllerGetSelectableValues(columnName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlAttestationDocumentControllerRemoveEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlAttestationDocumentControllerRemoveEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlAttestationDocumentControllerRestoreEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlAttestationDocumentControllerRestoreEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} removedBy 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlAttestationDocumentControllerRestoreEntityGroup(removedBy: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlAttestationDocumentControllerRestoreEntityGroup(removedBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ControlAttestationDocumentIdEssential} controlAttestationDocumentIdEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlAttestationDocumentControllerUpdateEntity(controlAttestationDocumentIdEssential: ControlAttestationDocumentIdEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlAttestationDocumentControllerUpdateEntity(controlAttestationDocumentIdEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} entityId 
     * @param {File} document 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlAttestationDocumentControllerUploadDocument(entityId: string, document: File, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlAttestationDocumentControllerUploadDocument(entityId, document, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} entityId 
     * @param {Array<File>} documents 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlAttestationDocumentControllerUploadDocuments(entityId: string, documents: Array<File>, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlAttestationDocumentControllerUploadDocuments(entityId, documents, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ControlAttestationStepRevisionEssential} controlAttestationStepRevisionEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlAttestationStepRevisionControllerCreateEntity(controlAttestationStepRevisionEssential: ControlAttestationStepRevisionEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlAttestationStepRevisionControllerCreateEntity(controlAttestationStepRevisionEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlAttestationStepRevisionControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlAttestationStepRevisionControllerDeleteEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlAttestationStepRevisionControllerGetAll(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlAttestationStepRevisionControllerGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} controlAttestationId 
     * @param {string} stepRevisionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlAttestationStepRevisionControllerGetByControlAttestationAndStepRevisionIds(controlAttestationId: string, stepRevisionId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlAttestationStepRevisionControllerGetByControlAttestationAndStepRevisionIds(controlAttestationId, stepRevisionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlAttestationStepRevisionControllerGetById(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlAttestationStepRevisionControllerGetById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ControlAttestationStepRevisionIdEssential} controlAttestationStepRevisionIdEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlAttestationStepRevisionControllerUpdateEntity(controlAttestationStepRevisionIdEssential: ControlAttestationStepRevisionIdEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlAttestationStepRevisionControllerUpdateEntity(controlAttestationStepRevisionIdEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {any} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlControllerCreateEntity(body: any, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlControllerCreateEntity(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlControllerDeleteEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlControllerGetAll(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlControllerGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlControllerGetById(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlControllerGetById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ControlIdEssential} controlIdEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlControllerUpdateEntity(controlIdEssential: ControlIdEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlControllerUpdateEntity(controlIdEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ControlRevisionEssential} controlRevisionEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlRevisionControllerCreateEntity(controlRevisionEssential: ControlRevisionEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlRevisionControllerCreateEntity(controlRevisionEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlRevisionControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlRevisionControllerDeleteEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DomainFilter} domainFilter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlRevisionControllerFindByDomainFilter(domainFilter: DomainFilter, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlRevisionControllerFindByDomainFilter(domainFilter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} instant 
     * @param {DomainFilter} domainFilter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlRevisionControllerFindByDomainFilterAndInstant(instant: string, domainFilter: DomainFilter, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlRevisionControllerFindByDomainFilterAndInstant(instant, domainFilter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} controlId 
     * @param {string} instant 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlRevisionControllerFindRevisionByControl(controlId: string, instant: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlRevisionControllerFindRevisionByControl(controlId, instant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlRevisionControllerGetAll(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlRevisionControllerGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} instant 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlRevisionControllerGetAllEntities(instant: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlRevisionControllerGetAllEntities(instant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlRevisionControllerGetById(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlRevisionControllerGetById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} columnName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlRevisionControllerGetDistinctValues(columnName: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlRevisionControllerGetDistinctValues(columnName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} columnName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlRevisionControllerGetSelectableValues(columnName: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlRevisionControllerGetSelectableValues(columnName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlRevisionControllerRemoveEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlRevisionControllerRemoveEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlRevisionControllerRestoreEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlRevisionControllerRestoreEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} removedBy 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlRevisionControllerRestoreEntityGroup(removedBy: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlRevisionControllerRestoreEntityGroup(removedBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ControlRevisionIdEssential} controlRevisionIdEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlRevisionControllerUpdateEntity(controlRevisionIdEssential: ControlRevisionIdEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlRevisionControllerUpdateEntity(controlRevisionIdEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ControlStepEssential} controlStepEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlStepControllerCreateEntity(controlStepEssential: ControlStepEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlStepControllerCreateEntity(controlStepEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlStepControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlStepControllerDeleteEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} instant 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlStepControllerFindControlRevisionWithLinkedStep(instant: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlStepControllerFindControlRevisionWithLinkedStep(instant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlStepControllerGetAll(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlStepControllerGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} instant 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlStepControllerGetAllEntities(instant: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlStepControllerGetAllEntities(instant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlStepControllerGetById(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlStepControllerGetById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} controlId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlStepControllerGetControlStepsByControl(controlId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlStepControllerGetControlStepsByControl(controlId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} stepId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlStepControllerGetControlStepsByStep(stepId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlStepControllerGetControlStepsByStep(stepId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} columnName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlStepControllerGetDistinctValues(columnName: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlStepControllerGetDistinctValues(columnName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} stepId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlStepControllerGetEditsByStep(stepId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlStepControllerGetEditsByStep(stepId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} columnName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlStepControllerGetSelectableValues(columnName: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlStepControllerGetSelectableValues(columnName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlStepControllerRemoveEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlStepControllerRemoveEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlStepControllerRestoreEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlStepControllerRestoreEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} removedBy 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlStepControllerRestoreEntityGroup(removedBy: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlStepControllerRestoreEntityGroup(removedBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ControlStepIdEssential} controlStepIdEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public controlStepControllerUpdateEntity(controlStepIdEssential: ControlStepIdEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).controlStepControllerUpdateEntity(controlStepIdEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public coreTasksApiApplicationPing(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).coreTasksApiApplicationPing(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} to 
     * @param {string} subject 
     * @param {EmailParams} emailParams 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public emailControllerSendEmail(to: Array<string>, subject: string, emailParams: EmailParams, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).emailControllerSendEmail(to, subject, emailParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public employeeDataControllerGetAllEmployeeData(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).employeeDataControllerGetAllEmployeeData(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public employeeDataControllerGetEmployeeByEmail(email: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).employeeDataControllerGetEmployeeByEmail(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public employeeDataControllerGetEmployeeByEmployeeId(employeeId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).employeeDataControllerGetEmployeeByEmployeeId(employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public employeeDataControllerGetEmployeeLayout(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).employeeDataControllerGetEmployeeLayout(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public employeeDataControllerGetManagers(employeeId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).employeeDataControllerGetManagers(employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public employeeDataControllerGetPossibleDelegates(employeeId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).employeeDataControllerGetPossibleDelegates(employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} stepLinkId 
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public employeeDataControllerIsOwnerOfStepLink(stepLinkId: string, employeeId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).employeeDataControllerIsOwnerOfStepLink(stepLinkId, employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} instant 
     * @param {string} level 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public graphControllerGetLayoutData(instant: string, level: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).graphControllerGetLayoutData(instant, level, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LayoutBodyDTO} layoutBodyDTO 
     * @param {string} [algoType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public graphControllerGetNestedLayout(layoutBodyDTO: LayoutBodyDTO, algoType?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).graphControllerGetNestedLayout(layoutBodyDTO, algoType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} instant 
     * @param {LayoutBodyDTO} layoutBodyDTO 
     * @param {string} [algoType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public graphControllerGetNestedLayoutByInstant(instant: string, layoutBodyDTO: LayoutBodyDTO, algoType?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).graphControllerGetNestedLayoutByInstant(instant, layoutBodyDTO, algoType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LayoutBodyDTO} layoutBodyDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public graphControllerGetRenderedEdges(layoutBodyDTO: LayoutBodyDTO, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).graphControllerGetRenderedEdges(layoutBodyDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} instant 
     * @param {LayoutBodyDTO} layoutBodyDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public graphControllerGetRenderedEdgesByInstant(instant: string, layoutBodyDTO: LayoutBodyDTO, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).graphControllerGetRenderedEdgesByInstant(instant, layoutBodyDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GraphStateEssential} graphStateEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public graphStateControllerCreateEntity(graphStateEssential: GraphStateEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).graphStateControllerCreateEntity(graphStateEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public graphStateControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).graphStateControllerDeleteEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public graphStateControllerGetAll(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).graphStateControllerGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public graphStateControllerGetById(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).graphStateControllerGetById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} department 
     * @param {string} processName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public graphStateControllerGetGraphState(department: string, processName: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).graphStateControllerGetGraphState(department, processName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GraphStateIdEssential} graphStateIdEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public graphStateControllerUpdateEntity(graphStateIdEssential: GraphStateIdEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).graphStateControllerUpdateEntity(graphStateIdEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GraphState} graphState 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public graphStateControllerUpsertGraphState(graphState: GraphState, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).graphStateControllerUpsertGraphState(graphState, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobAidControllerGetFromUrl(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).jobAidControllerGetFromUrl(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MitigationStepEssential} mitigationStepEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mitigationStepControllerCreateEntity(mitigationStepEssential: MitigationStepEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).mitigationStepControllerCreateEntity(mitigationStepEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mitigationStepControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).mitigationStepControllerDeleteEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mitigationStepControllerGetAll(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).mitigationStepControllerGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} instant 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mitigationStepControllerGetAllEntities(instant: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).mitigationStepControllerGetAllEntities(instant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mitigationStepControllerGetById(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).mitigationStepControllerGetById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} riskSourceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mitigationStepControllerGetByRiskSource(riskSourceId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).mitigationStepControllerGetByRiskSource(riskSourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} stepId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mitigationStepControllerGetByStep(stepId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).mitigationStepControllerGetByStep(stepId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} columnName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mitigationStepControllerGetDistinctValues(columnName: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).mitigationStepControllerGetDistinctValues(columnName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} columnName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mitigationStepControllerGetSelectableValues(columnName: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).mitigationStepControllerGetSelectableValues(columnName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mitigationStepControllerRemoveEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).mitigationStepControllerRemoveEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mitigationStepControllerRestoreEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).mitigationStepControllerRestoreEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} removedBy 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mitigationStepControllerRestoreEntityGroup(removedBy: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).mitigationStepControllerRestoreEntityGroup(removedBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MitigationStepIdEssential} mitigationStepIdEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public mitigationStepControllerUpdateEntity(mitigationStepIdEssential: MitigationStepIdEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).mitigationStepControllerUpdateEntity(mitigationStepIdEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OwnershipEssential} ownershipEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public ownershipControllerCreateEntity(ownershipEssential: OwnershipEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).ownershipControllerCreateEntity(ownershipEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public ownershipControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).ownershipControllerDeleteEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public ownershipControllerGetAll(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).ownershipControllerGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public ownershipControllerGetById(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).ownershipControllerGetById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public ownershipControllerGetDelegations(employeeId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).ownershipControllerGetDelegations(employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public ownershipControllerGetOwnerships(employeeId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).ownershipControllerGetOwnerships(employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OwnershipIdEssential} ownershipIdEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public ownershipControllerUpdateEntity(ownershipIdEssential: OwnershipIdEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).ownershipControllerUpdateEntity(ownershipIdEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReviewPeriodEssential} reviewPeriodEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reviewPeriodControllerCreateEntity(reviewPeriodEssential: ReviewPeriodEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).reviewPeriodControllerCreateEntity(reviewPeriodEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reviewPeriodControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).reviewPeriodControllerDeleteEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} date 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reviewPeriodControllerFindReviewPeriodForDate(date: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).reviewPeriodControllerFindReviewPeriodForDate(date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reviewPeriodControllerGetAll(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).reviewPeriodControllerGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reviewPeriodControllerGetAllAndSortByStartDate(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).reviewPeriodControllerGetAllAndSortByStartDate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reviewPeriodControllerGetById(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).reviewPeriodControllerGetById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReviewPeriodIdEssential} reviewPeriodIdEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reviewPeriodControllerUpdateEntity(reviewPeriodIdEssential: ReviewPeriodIdEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).reviewPeriodControllerUpdateEntity(reviewPeriodIdEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {any} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskControllerCreateEntity(body: any, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskControllerCreateEntity(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskControllerDeleteEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DomainFilter} domainFilter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskControllerEnterpriseRiskByDomainFilter(domainFilter: DomainFilter, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskControllerEnterpriseRiskByDomainFilter(domainFilter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} instant 
     * @param {DomainFilter} domainFilter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskControllerEnterpriseRiskByDomainFilterAndInstant(instant: string, domainFilter: DomainFilter, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskControllerEnterpriseRiskByDomainFilterAndInstant(instant, domainFilter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} riskId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskControllerGetAggregateRiskReportAverages(riskId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskControllerGetAggregateRiskReportAverages(riskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} riskId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskControllerGetAggregateRiskReportMedians(riskId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskControllerGetAggregateRiskReportMedians(riskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskControllerGetAll(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskControllerGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskControllerGetById(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskControllerGetById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RiskIdEssential} riskIdEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskControllerUpdateEntity(riskIdEssential: RiskIdEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskControllerUpdateEntity(riskIdEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RiskRevisionEssential} riskRevisionEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskRevisionControllerCreateEntity(riskRevisionEssential: RiskRevisionEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskRevisionControllerCreateEntity(riskRevisionEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskRevisionControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskRevisionControllerDeleteEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DomainFilter} domainFilter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskRevisionControllerFindByDomainFilter(domainFilter: DomainFilter, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskRevisionControllerFindByDomainFilter(domainFilter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} instant 
     * @param {DomainFilter} domainFilter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskRevisionControllerFindByDomainFilterAndInstant(instant: string, domainFilter: DomainFilter, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskRevisionControllerFindByDomainFilterAndInstant(instant, domainFilter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskRevisionControllerGetAll(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskRevisionControllerGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} instant 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskRevisionControllerGetAllEntities(instant: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskRevisionControllerGetAllEntities(instant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskRevisionControllerGetById(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskRevisionControllerGetById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} columnName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskRevisionControllerGetDistinctValues(columnName: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskRevisionControllerGetDistinctValues(columnName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} instant 
     * @param {GroupedRiskFilters} groupedRiskFilters 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskRevisionControllerGetRiskConnectionsData(instant: string, groupedRiskFilters: GroupedRiskFilters, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskRevisionControllerGetRiskConnectionsData(instant, groupedRiskFilters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} requestBody 
     * @param {string} [instant] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskRevisionControllerGetRiskSourceConnectionCountsBatch(requestBody: Array<string>, instant?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskRevisionControllerGetRiskSourceConnectionCountsBatch(requestBody, instant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} columnName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskRevisionControllerGetSelectableValues(columnName: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskRevisionControllerGetSelectableValues(columnName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskRevisionControllerRemoveEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskRevisionControllerRemoveEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskRevisionControllerRestoreEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskRevisionControllerRestoreEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} removedBy 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskRevisionControllerRestoreEntityGroup(removedBy: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskRevisionControllerRestoreEntityGroup(removedBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RiskRevisionIdEssential} riskRevisionIdEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskRevisionControllerUpdateEntity(riskRevisionIdEssential: RiskRevisionIdEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskRevisionControllerUpdateEntity(riskRevisionIdEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RiskSourceAggregateCreateRequest} riskSourceAggregateCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskSourceAggregateControllerCreate(riskSourceAggregateCreateRequest: RiskSourceAggregateCreateRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskSourceAggregateControllerCreate(riskSourceAggregateCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DomainFilter} domainFilter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskSourceAggregateControllerFindAggregatesByDomainFilter(domainFilter: DomainFilter, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskSourceAggregateControllerFindAggregatesByDomainFilter(domainFilter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} instant 
     * @param {DomainFilter} domainFilter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskSourceAggregateControllerFindAggregatesByDomainFilterAndInstant(instant: string, domainFilter: DomainFilter, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskSourceAggregateControllerFindAggregatesByDomainFilterAndInstant(instant, domainFilter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} step 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskSourceAggregateControllerGetByStep(step: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskSourceAggregateControllerGetByStep(step, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} stepId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskSourceAggregateControllerGetLinkOptionsByStep(stepId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskSourceAggregateControllerGetLinkOptionsByStep(stepId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} riskId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskSourceAggregateControllerReadByRisk(riskId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskSourceAggregateControllerReadByRisk(riskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} riskSourceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskSourceAggregateControllerReadByRiskSource(riskSourceId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskSourceAggregateControllerReadByRiskSource(riskSourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} riskSourceId 
     * @param {string} stepId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskSourceAggregateControllerRemoveStepRelationship(riskSourceId: string, stepId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskSourceAggregateControllerRemoveStepRelationship(riskSourceId, stepId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RiskSourceAggregateUpdateRequest} riskSourceAggregateUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskSourceAggregateControllerUpdate(riskSourceAggregateUpdateRequest: RiskSourceAggregateUpdateRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskSourceAggregateControllerUpdate(riskSourceAggregateUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RiskSourceEssential} riskSourceEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskSourceControllerCreateEntity(riskSourceEssential: RiskSourceEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskSourceControllerCreateEntity(riskSourceEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskSourceControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskSourceControllerDeleteEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskSourceControllerGetAll(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskSourceControllerGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskSourceControllerGetById(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskSourceControllerGetById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} riskId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskSourceControllerGetByRisk(riskId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskSourceControllerGetByRisk(riskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RiskSourceIdEssential} riskSourceIdEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskSourceControllerUpdateEntity(riskSourceIdEssential: RiskSourceIdEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskSourceControllerUpdateEntity(riskSourceIdEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RiskSourceRevisionEssential} riskSourceRevisionEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskSourceRevisionControllerCreateEntity(riskSourceRevisionEssential: RiskSourceRevisionEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskSourceRevisionControllerCreateEntity(riskSourceRevisionEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskSourceRevisionControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskSourceRevisionControllerDeleteEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DomainFilter} domainFilter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskSourceRevisionControllerFindByDomainFilter(domainFilter: DomainFilter, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskSourceRevisionControllerFindByDomainFilter(domainFilter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} instant 
     * @param {DomainFilter} domainFilter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskSourceRevisionControllerFindByDomainFilterAndInstant(instant: string, domainFilter: DomainFilter, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskSourceRevisionControllerFindByDomainFilterAndInstant(instant, domainFilter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskSourceRevisionControllerGetAll(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskSourceRevisionControllerGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} instant 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskSourceRevisionControllerGetAllEntities(instant: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskSourceRevisionControllerGetAllEntities(instant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskSourceRevisionControllerGetById(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskSourceRevisionControllerGetById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} riskSourceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskSourceRevisionControllerGetByRiskSource(riskSourceId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskSourceRevisionControllerGetByRiskSource(riskSourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} columnName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskSourceRevisionControllerGetDistinctValues(columnName: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskSourceRevisionControllerGetDistinctValues(columnName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} columnName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskSourceRevisionControllerGetSelectableValues(columnName: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskSourceRevisionControllerGetSelectableValues(columnName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskSourceRevisionControllerRemoveEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskSourceRevisionControllerRemoveEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskSourceRevisionControllerRestoreEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskSourceRevisionControllerRestoreEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} removedBy 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskSourceRevisionControllerRestoreEntityGroup(removedBy: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskSourceRevisionControllerRestoreEntityGroup(removedBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RiskSourceRevisionIdEssential} riskSourceRevisionIdEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public riskSourceRevisionControllerUpdateEntity(riskSourceRevisionIdEssential: RiskSourceRevisionIdEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).riskSourceRevisionControllerUpdateEntity(riskSourceRevisionIdEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {TaskActionRequest} taskActionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public rootTaskControllerClaimTask(id: string, taskActionRequest: TaskActionRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).rootTaskControllerClaimTask(id, taskActionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RootTaskEssential} rootTaskEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public rootTaskControllerCreateEntity(rootTaskEssential: RootTaskEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).rootTaskControllerCreateEntity(rootTaskEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateTaskRequest} createTaskRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public rootTaskControllerCreateTaskWithLogs(createTaskRequest: CreateTaskRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).rootTaskControllerCreateTaskWithLogs(createTaskRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {TaskActionRequest} taskActionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public rootTaskControllerDeclineTask(id: string, taskActionRequest: TaskActionRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).rootTaskControllerDeclineTask(id, taskActionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public rootTaskControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).rootTaskControllerDeleteEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {TaskActionRequest} taskActionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public rootTaskControllerDeleteTask(id: string, taskActionRequest: TaskActionRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).rootTaskControllerDeleteTask(id, taskActionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public rootTaskControllerGetAll(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).rootTaskControllerGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public rootTaskControllerGetById(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).rootTaskControllerGetById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public rootTaskControllerGetClaimed(employeeId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).rootTaskControllerGetClaimed(employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public rootTaskControllerGetDone(employeeId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).rootTaskControllerGetDone(employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public rootTaskControllerGetGenerated(employeeId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).rootTaskControllerGetGenerated(employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public rootTaskControllerGetNeedsReview(employeeId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).rootTaskControllerGetNeedsReview(employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MarkTaskCompleteRequest} markTaskCompleteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public rootTaskControllerMarkComplete(markTaskCompleteRequest: MarkTaskCompleteRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).rootTaskControllerMarkComplete(markTaskCompleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {TaskActionRequest} taskActionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public rootTaskControllerRevertTask(id: string, taskActionRequest: TaskActionRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).rootTaskControllerRevertTask(id, taskActionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [description] 
     * @param {TaskTypeEnum} [sourceType] 
     * @param {string} [sourceId] 
     * @param {TaskTypeEnum} [targetType] 
     * @param {string} [targetId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public rootTaskControllerSearch(description?: string, sourceType?: TaskTypeEnum, sourceId?: string, targetType?: TaskTypeEnum, targetId?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).rootTaskControllerSearch(description, sourceType, sourceId, targetType, targetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {TaskActionRequest} taskActionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public rootTaskControllerUnclaimTask(id: string, taskActionRequest: TaskActionRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).rootTaskControllerUnclaimTask(id, taskActionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RootTaskIdEssential} rootTaskIdEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public rootTaskControllerUpdateEntity(rootTaskIdEssential: RootTaskIdEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).rootTaskControllerUpdateEntity(rootTaskIdEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SignOffOwners} signOffOwners 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public signOffOwnersControllerCreateOwner(signOffOwners: SignOffOwners, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).signOffOwnersControllerCreateOwner(signOffOwners, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SignOffInsertDTO} signOffInsertDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public signOffOwnersControllerDeleteAndInsert(signOffInsertDTO: SignOffInsertDTO, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).signOffOwnersControllerDeleteAndInsert(signOffInsertDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public signOffOwnersControllerDeleteOwner(employeeId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).signOffOwnersControllerDeleteOwner(employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public signOffOwnersControllerGetAllOwners(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).signOffOwnersControllerGetAllOwners(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public signOffOwnersControllerIsSignOffOwner(employeeId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).signOffOwnersControllerIsSignOffOwner(employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public slackSenderControllerHealthCheck(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).slackSenderControllerHealthCheck(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public slackSenderControllerTriggerReminderMessage(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).slackSenderControllerTriggerReminderMessage(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public slackSenderControllerTriggerReminderMessageForEmail(email: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).slackSenderControllerTriggerReminderMessageForEmail(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SourceStepEssential} sourceStepEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sourceStepControllerCreateEntity(sourceStepEssential: SourceStepEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).sourceStepControllerCreateEntity(sourceStepEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sourceStepControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).sourceStepControllerDeleteEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sourceStepControllerGetAll(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).sourceStepControllerGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} instant 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sourceStepControllerGetAllEntities(instant: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).sourceStepControllerGetAllEntities(instant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sourceStepControllerGetById(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).sourceStepControllerGetById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} riskSourceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sourceStepControllerGetByRiskSource(riskSourceId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).sourceStepControllerGetByRiskSource(riskSourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} stepId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sourceStepControllerGetByStep(stepId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).sourceStepControllerGetByStep(stepId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} columnName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sourceStepControllerGetDistinctValues(columnName: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).sourceStepControllerGetDistinctValues(columnName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} columnName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sourceStepControllerGetSelectableValues(columnName: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).sourceStepControllerGetSelectableValues(columnName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sourceStepControllerRemoveEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).sourceStepControllerRemoveEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sourceStepControllerRestoreEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).sourceStepControllerRestoreEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} removedBy 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sourceStepControllerRestoreEntityGroup(removedBy: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).sourceStepControllerRestoreEntityGroup(removedBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SourceStepIdEssential} sourceStepIdEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sourceStepControllerUpdateEntity(sourceStepIdEssential: SourceStepIdEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).sourceStepControllerUpdateEntity(sourceStepIdEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StepConfirmationEssential} stepConfirmationEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepConfirmationControllerCreateEntity(stepConfirmationEssential: StepConfirmationEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepConfirmationControllerCreateEntity(stepConfirmationEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepConfirmationControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepConfirmationControllerDeleteEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} stepId 
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepConfirmationControllerFindByStepInRange(stepId: string, startDate: string, endDate: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepConfirmationControllerFindByStepInRange(stepId, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepConfirmationControllerGetAll(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepConfirmationControllerGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} asOfDate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepConfirmationControllerGetAllUnconfirmedStepRevisions(asOfDate: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepConfirmationControllerGetAllUnconfirmedStepRevisions(asOfDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepConfirmationControllerGetById(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepConfirmationControllerGetById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} employeeId 
     * @param {string} asOfDate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepConfirmationControllerGetUnconfirmedStepRevisionsByOwner(employeeId: string, asOfDate: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepConfirmationControllerGetUnconfirmedStepRevisionsByOwner(employeeId, asOfDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} employeeId 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepConfirmationControllerSubmitNewConfirmation(employeeId: string, requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepConfirmationControllerSubmitNewConfirmation(employeeId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StepConfirmationIdEssential} stepConfirmationIdEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepConfirmationControllerUpdateEntity(stepConfirmationIdEssential: StepConfirmationIdEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepConfirmationControllerUpdateEntity(stepConfirmationIdEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StepConfirmationLinkEssential} stepConfirmationLinkEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepConfirmationLinkControllerCreateEntity(stepConfirmationLinkEssential: StepConfirmationLinkEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepConfirmationLinkControllerCreateEntity(stepConfirmationLinkEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepConfirmationLinkControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepConfirmationLinkControllerDeleteEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} employeeId 
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepConfirmationLinkControllerFindAllByEmployeeIdAndDateRange(employeeId: string, startDate: string, endDate: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepConfirmationLinkControllerFindAllByEmployeeIdAndDateRange(employeeId, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepConfirmationLinkControllerFindByDateRange(startDate: string, endDate: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepConfirmationLinkControllerFindByDateRange(startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepConfirmationLinkControllerGetAll(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepConfirmationLinkControllerGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepConfirmationLinkControllerGetById(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepConfirmationLinkControllerGetById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StepConfirmationLinkIdEssential} stepConfirmationLinkIdEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepConfirmationLinkControllerUpdateEntity(stepConfirmationLinkIdEssential: StepConfirmationLinkIdEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepConfirmationLinkControllerUpdateEntity(stepConfirmationLinkIdEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {any} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepControllerCreateEntity(body: any, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepControllerCreateEntity(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepControllerDeleteEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepControllerGetAll(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepControllerGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepControllerGetById(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepControllerGetById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StepIdEssential} stepIdEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepControllerUpdateEntity(stepIdEssential: StepIdEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepControllerUpdateEntity(stepIdEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StepDocumentEssential} stepDocumentEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepDocumentControllerCreateEntity(stepDocumentEssential: StepDocumentEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepDocumentControllerCreateEntity(stepDocumentEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepDocumentControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepDocumentControllerDeleteEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} documentId 
     * @param {string} extension 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepDocumentControllerDownloadDocument(documentId: string, extension: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepDocumentControllerDownloadDocument(documentId, extension, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<StepDocument>} stepDocument 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepDocumentControllerDownloadDocuments(stepDocument: Array<StepDocument>, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepDocumentControllerDownloadDocuments(stepDocument, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepDocumentControllerFindByDocumentId(documentId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepDocumentControllerFindByDocumentId(documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} stepId 
     * @param {string} instant 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepDocumentControllerFindByStep(stepId: string, instant: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepDocumentControllerFindByStep(stepId, instant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepDocumentControllerGetAll(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepDocumentControllerGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} instant 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepDocumentControllerGetAllEntities(instant: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepDocumentControllerGetAllEntities(instant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepDocumentControllerGetById(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepDocumentControllerGetById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} columnName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepDocumentControllerGetDistinctValues(columnName: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepDocumentControllerGetDistinctValues(columnName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} stepId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepDocumentControllerGetEdits(stepId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepDocumentControllerGetEdits(stepId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} columnName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepDocumentControllerGetSelectableValues(columnName: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepDocumentControllerGetSelectableValues(columnName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepDocumentControllerRemoveEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepDocumentControllerRemoveEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepDocumentControllerRestoreEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepDocumentControllerRestoreEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} removedBy 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepDocumentControllerRestoreEntityGroup(removedBy: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepDocumentControllerRestoreEntityGroup(removedBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StepDocumentIdEssential} stepDocumentIdEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepDocumentControllerUpdateEntity(stepDocumentIdEssential: StepDocumentIdEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepDocumentControllerUpdateEntity(stepDocumentIdEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} entityId 
     * @param {File} document 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepDocumentControllerUploadDocument(entityId: string, document: File, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepDocumentControllerUploadDocument(entityId, document, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} entityId 
     * @param {Array<File>} documents 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepDocumentControllerUploadDocuments(entityId: string, documents: Array<File>, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepDocumentControllerUploadDocuments(entityId, documents, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StepLinkEssential} stepLinkEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepLinkControllerCreateEntity(stepLinkEssential: StepLinkEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepLinkControllerCreateEntity(stepLinkEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepLinkControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepLinkControllerDeleteEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} stepId 
     * @param {string} instant 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepLinkControllerFindAllBySource(stepId: string, instant: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepLinkControllerFindAllBySource(stepId, instant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} stepId 
     * @param {string} instant 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepLinkControllerFindAllByStep(stepId: string, instant: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepLinkControllerFindAllByStep(stepId, instant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} stepId 
     * @param {string} instant 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepLinkControllerFindAllByTarget(stepId: string, instant: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepLinkControllerFindAllByTarget(stepId, instant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepLinkControllerGetAll(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepLinkControllerGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} instant 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepLinkControllerGetAllEntities(instant: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepLinkControllerGetAllEntities(instant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepLinkControllerGetById(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepLinkControllerGetById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} columnName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepLinkControllerGetDistinctValues(columnName: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepLinkControllerGetDistinctValues(columnName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} stepId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepLinkControllerGetEdits(stepId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepLinkControllerGetEdits(stepId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} columnName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepLinkControllerGetSelectableValues(columnName: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepLinkControllerGetSelectableValues(columnName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepLinkControllerGetStepLinksMap(requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepLinkControllerGetStepLinksMap(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} instant 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepLinkControllerGetStepLinksMapByInstant(instant: string, requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepLinkControllerGetStepLinksMapByInstant(instant, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepLinkControllerRemoveEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepLinkControllerRemoveEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} source 
     * @param {string} target 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepLinkControllerRemoveStepLinksBySourceAndTarget(source: string, target: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepLinkControllerRemoveStepLinksBySourceAndTarget(source, target, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepLinkControllerRestoreEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepLinkControllerRestoreEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} removedBy 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepLinkControllerRestoreEntityGroup(removedBy: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepLinkControllerRestoreEntityGroup(removedBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StepLinkIdEssential} stepLinkIdEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepLinkControllerUpdateEntity(stepLinkIdEssential: StepLinkIdEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepLinkControllerUpdateEntity(stepLinkIdEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<StepRevision>} stepRevision 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepRevisionControllerCreateBulkEntityForce(stepRevision: Array<StepRevision>, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepRevisionControllerCreateBulkEntityForce(stepRevision, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StepRevisionEssential} stepRevisionEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepRevisionControllerCreateEntity(stepRevisionEssential: StepRevisionEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepRevisionControllerCreateEntity(stepRevisionEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StepRevision} stepRevision 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepRevisionControllerCreateEntityForce(stepRevision: StepRevision, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepRevisionControllerCreateEntityForce(stepRevision, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepRevisionControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepRevisionControllerDeleteEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FilterDTO} filterDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepRevisionControllerFindAllGivenFilter(filterDTO: FilterDTO, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepRevisionControllerFindAllGivenFilter(filterDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} instant 
     * @param {FilterDTO} filterDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepRevisionControllerFindAllGivenFilterByInstant(instant: string, filterDTO: FilterDTO, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepRevisionControllerFindAllGivenFilterByInstant(instant, filterDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} stepId 
     * @param {string} instant 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepRevisionControllerFindAllSources(stepId: string, instant: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepRevisionControllerFindAllSources(stepId, instant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} stepId 
     * @param {string} instant 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepRevisionControllerFindAllTargets(stepId: string, instant: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepRevisionControllerFindAllTargets(stepId, instant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DomainFilter} domainFilter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepRevisionControllerFindByDomainFilter(domainFilter: DomainFilter, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepRevisionControllerFindByDomainFilter(domainFilter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} instant 
     * @param {DomainFilter} domainFilter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepRevisionControllerFindByDomainFilterAndInstant(instant: string, domainFilter: DomainFilter, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepRevisionControllerFindByDomainFilterAndInstant(instant, domainFilter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepRevisionControllerFindByOwnerNested(employeeId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepRevisionControllerFindByOwnerNested(employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} employeeId 
     * @param {string} instant 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepRevisionControllerFindByResponsibleUser(employeeId: string, instant: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepRevisionControllerFindByResponsibleUser(employeeId, instant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepRevisionControllerFindByStepId(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepRevisionControllerFindByStepId(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} stepName 
     * @param {string} instant 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepRevisionControllerFindByStepName(stepName: string, instant: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepRevisionControllerFindByStepName(stepName, instant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<StepRevision>} stepRevision 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepRevisionControllerFindNewValues(stepRevision: Array<StepRevision>, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepRevisionControllerFindNewValues(stepRevision, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} instant 
     * @param {string} nodeId 
     * @param {Array<string>} filterLevels 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepRevisionControllerFindOneMatching(instant: string, nodeId: string, filterLevels: Array<string>, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepRevisionControllerFindOneMatching(instant, nodeId, filterLevels, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepRevisionControllerGetAll(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepRevisionControllerGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} instant 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepRevisionControllerGetAllEntities(instant: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepRevisionControllerGetAllEntities(instant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepRevisionControllerGetById(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepRevisionControllerGetById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} columnName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepRevisionControllerGetDistinctValues(columnName: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepRevisionControllerGetDistinctValues(columnName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} fieldName 
     * @param {FilterDTO} filterDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepRevisionControllerGetDistinctValuesGivenFilter(fieldName: string, filterDTO: FilterDTO, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepRevisionControllerGetDistinctValuesGivenFilter(fieldName, filterDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StepRevision} stepRevision 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepRevisionControllerGetEdits(stepRevision: StepRevision, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepRevisionControllerGetEdits(stepRevision, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Set<string>} stepIds 
     * @param {string} type 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepRevisionControllerGetExternalNodes(stepIds: Set<string>, type: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepRevisionControllerGetExternalNodes(stepIds, type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GraphNodeFilterRequest} graphNodeFilterRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepRevisionControllerGetInboundConnectionCountsByGraphNode(graphNodeFilterRequest: GraphNodeFilterRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepRevisionControllerGetInboundConnectionCountsByGraphNode(graphNodeFilterRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} stepId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepRevisionControllerGetJobAidLinkEdits(stepId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepRevisionControllerGetJobAidLinkEdits(stepId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GraphNodeFilterRequest} graphNodeFilterRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepRevisionControllerGetOutboundConnectionCountsByGraphNode(graphNodeFilterRequest: GraphNodeFilterRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepRevisionControllerGetOutboundConnectionCountsByGraphNode(graphNodeFilterRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} department 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepRevisionControllerGetProcessesByDepartment(department: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepRevisionControllerGetProcessesByDepartment(department, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepRevisionControllerGetRemovedSteps(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepRevisionControllerGetRemovedSteps(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} columnName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepRevisionControllerGetSelectableValues(columnName: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepRevisionControllerGetSelectableValues(columnName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepRevisionControllerGetStepCountsByDepartment(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepRevisionControllerGetStepCountsByDepartment(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GraphNodeFilterRequest} graphNodeFilterRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepRevisionControllerGetStepCountsByGraphNode(graphNodeFilterRequest: GraphNodeFilterRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepRevisionControllerGetStepCountsByGraphNode(graphNodeFilterRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepRevisionControllerGetUpdateAuthor(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepRevisionControllerGetUpdateAuthor(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepRevisionControllerQueryStepRevisionsRelatedToKeyControls(requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepRevisionControllerQueryStepRevisionsRelatedToKeyControls(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepRevisionControllerRemoveEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepRevisionControllerRemoveEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepRevisionControllerRestoreEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepRevisionControllerRestoreEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} removedBy 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepRevisionControllerRestoreEntityGroup(removedBy: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepRevisionControllerRestoreEntityGroup(removedBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StepRevisionIdEssential} stepRevisionIdEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepRevisionControllerUpdateEntity(stepRevisionIdEssential: StepRevisionIdEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepRevisionControllerUpdateEntity(stepRevisionIdEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StepRevision} stepRevision 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stepRevisionControllerUpdateEntityForce(stepRevision: StepRevision, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stepRevisionControllerUpdateEntityForce(stepRevision, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaskLogEssential} taskLogEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public taskLogControllerCreateEntity(taskLogEssential: TaskLogEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).taskLogControllerCreateEntity(taskLogEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public taskLogControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).taskLogControllerDeleteEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public taskLogControllerGetAll(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).taskLogControllerGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public taskLogControllerGetById(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).taskLogControllerGetById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [rootTask] 
     * @param {string} [employeeId] 
     * @param {string} [relatedLog] 
     * @param {TaskLogActivityEnum} [activity] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public taskLogControllerSearch(rootTask?: string, employeeId?: string, relatedLog?: string, activity?: TaskLogActivityEnum, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).taskLogControllerSearch(rootTask, employeeId, relatedLog, activity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaskLogIdEssential} taskLogIdEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public taskLogControllerUpdateEntity(taskLogIdEssential: TaskLogIdEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).taskLogControllerUpdateEntity(taskLogIdEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserRoleUpdateRequest} userRoleUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userControllerAssignUserRoles(userRoleUpdateRequest: UserRoleUpdateRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).userControllerAssignUserRoles(userRoleUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserIdEssential} userIdEssential 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userControllerCreateEntity(userIdEssential: UserIdEssential, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).userControllerCreateEntity(userIdEssential, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userControllerDeleteEntity(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).userControllerDeleteEntity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userControllerGetAll(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).userControllerGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userControllerGetAllAuth0Roles(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).userControllerGetAllAuth0Roles(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userControllerGetAuth0Users(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).userControllerGetAuth0Users(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userControllerGetByEmployeeId(employeeId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).userControllerGetByEmployeeId(employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userControllerGetById(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).userControllerGetById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userAuth0Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userControllerGetUserRoles(userAuth0Id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).userControllerGetUserRoles(userAuth0Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserRoleUpdateRequest} userRoleUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userControllerRemoveUserRoles(userRoleUpdateRequest: UserRoleUpdateRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).userControllerRemoveUserRoles(userRoleUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userControllerSyncUsers(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).userControllerSyncUsers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} employeeId 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userControllerUpdatePinnedItems(employeeId: string, requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).userControllerUpdatePinnedItems(employeeId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

}
